import { emptySplitApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    requeueJob: build.query<RequeueJobApiResponse, RequeueJobApiArg>({
      query: (queryArg) => ({
        url: `/api/admin/requeuejob`,
        params: {
          queuedDataKey: queryArg.queuedDataKey,
          process: queryArg.process,
        },
      }),
    }),
    getAppDefaults: build.query<
      GetAppDefaultsApiResponse,
      GetAppDefaultsApiArg
    >({
      query: () => ({ url: `/api/admin/appdefault` }),
    }),
    getAppDefaultsQuery: build.query<
      GetAppDefaultsQueryApiResponse,
      GetAppDefaultsQueryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/appdefaultquery`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    putAppDefaults: build.mutation<
      PutAppDefaultsApiResponse,
      PutAppDefaultsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/appdefault/${queryArg.parmId}`,
        method: "PUT",
        body: queryArg.appDefaultVm,
      }),
    }),
    putSecureDefaults: build.mutation<
      PutSecureDefaultsApiResponse,
      PutSecureDefaultsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/securedefault/${queryArg.parmId}`,
        method: "PUT",
        body: queryArg.secureDefaultVm,
      }),
    }),
    getSecureDefaultsQuery: build.query<
      GetSecureDefaultsQueryApiResponse,
      GetSecureDefaultsQueryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/securedefaultquery`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getWebDefaults: build.query<
      GetWebDefaultsApiResponse,
      GetWebDefaultsApiArg
    >({
      query: () => ({ url: `/api/admin/webdefault` }),
    }),
    getInvoicesApprovalPopulationData: build.query<
      GetInvoicesApprovalPopulationDataApiResponse,
      GetInvoicesApprovalPopulationDataApiArg
    >({
      query: () => ({ url: `/api/approveinvoices` }),
    }),
    getInvoicesNeedingApproval: build.mutation<
      GetInvoicesNeedingApprovalApiResponse,
      GetInvoicesNeedingApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/api/approveinvoices/search`,
        method: "POST",
        body: queryArg.invoiceApprovalOptionsVm,
      }),
    }),
    getMinimalInvoiceDetail: build.query<
      GetMinimalInvoiceDetailApiResponse,
      GetMinimalInvoiceDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/approveinvoices/invoicedetail/${queryArg.id}`,
      }),
    }),
    approveInvoices: build.mutation<
      ApproveInvoicesApiResponse,
      ApproveInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/approveinvoices/approve`,
        method: "POST",
        body: queryArg.approveInvoicesRequestVm,
      }),
    }),
    saveCurrentInvoiceState: build.mutation<
      SaveCurrentInvoiceStateApiResponse,
      SaveCurrentInvoiceStateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/approveinvoices/save`,
        method: "POST",
        body: queryArg.approveInvoicesRequestVm,
      }),
    }),
    postApiApproveinvoicesFrominvoiceidxs: build.mutation<
      PostApiApproveinvoicesFrominvoiceidxsApiResponse,
      PostApiApproveinvoicesFrominvoiceidxsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/approveinvoices/frominvoiceidxs`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getAllAscChargeCodes: build.query<
      GetAllAscChargeCodesApiResponse,
      GetAllAscChargeCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ascchargecode`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createAscChargeCodes: build.mutation<
      CreateAscChargeCodesApiResponse,
      CreateAscChargeCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ascchargecode`,
        method: "POST",
        body: queryArg.ascChargeCodeVm,
      }),
    }),
    modifyAscChargeCodes: build.mutation<
      ModifyAscChargeCodesApiResponse,
      ModifyAscChargeCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ascchargecode/${queryArg.codeId}`,
        method: "PUT",
        body: queryArg.ascChargeCodeVm,
      }),
    }),
    deleteAscChargeCodes: build.mutation<
      DeleteAscChargeCodesApiResponse,
      DeleteAscChargeCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ascchargecode/${queryArg.codeId}`,
        method: "DELETE",
      }),
    }),
    getInvoiceChargeTypes: build.query<
      GetInvoiceChargeTypesApiResponse,
      GetInvoiceChargeTypesApiArg
    >({
      query: () => ({ url: `/api/ascchargecode/chargetypes` }),
    }),
    getAllAscRefCodes: build.query<
      GetAllAscRefCodesApiResponse,
      GetAllAscRefCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ascrefcode`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createAscRefCodes: build.mutation<
      CreateAscRefCodesApiResponse,
      CreateAscRefCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ascrefcode`,
        method: "POST",
        body: queryArg.ascReferenceCodeVm,
      }),
    }),
    modifyAscRefCodes: build.mutation<
      ModifyAscRefCodesApiResponse,
      ModifyAscRefCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ascrefcode/${queryArg.codeId}`,
        method: "PUT",
        body: queryArg.ascReferenceCodeVm,
      }),
    }),
    deleteAscRefCodes: build.mutation<
      DeleteAscRefCodesApiResponse,
      DeleteAscRefCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ascrefcode/${queryArg.codeId}`,
        method: "DELETE",
      }),
    }),
    getGenMiles: build.mutation<GetGenMilesApiResponse, GetGenMilesApiArg>({
      query: (queryArg) => ({
        url: `/api/audit/auditmiles`,
        method: "POST",
        body: queryArg.auditMilesRequestVm,
      }),
    }),
    login: build.mutation<LoginApiResponse, LoginApiArg>({
      query: (queryArg) => ({
        url: `/api/authentication`,
        method: "POST",
        body: queryArg.loginVm,
      }),
    }),
    refreshToken: build.query<RefreshTokenApiResponse, RefreshTokenApiArg>({
      query: () => ({ url: `/api/authentication` }),
    }),
    loginWithPermissions: build.mutation<
      LoginWithPermissionsApiResponse,
      LoginWithPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/authentication/withpermissions`,
        method: "POST",
        body: queryArg.loginVm,
      }),
    }),
    refreshWithPermissions: build.query<
      RefreshWithPermissionsApiResponse,
      RefreshWithPermissionsApiArg
    >({
      query: () => ({ url: `/api/authentication/withpermissions` }),
    }),
    logOut: build.query<LogOutApiResponse, LogOutApiArg>({
      query: () => ({ url: `/api/authentication/logout` }),
    }),
    getMyUser: build.query<GetMyUserApiResponse, GetMyUserApiArg>({
      query: () => ({ url: `/api/authentication/getmyuser` }),
    }),
    getAllBankAccounts: build.query<
      GetAllBankAccountsApiResponse,
      GetAllBankAccountsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/bankaccount`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    updateBankAccount: build.mutation<
      UpdateBankAccountApiResponse,
      UpdateBankAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/bankaccount`,
        method: "PUT",
        body: queryArg.bankAccountChangeVm,
      }),
    }),
    getBillToById: build.query<GetBillToByIdApiResponse, GetBillToByIdApiArg>({
      query: (queryArg) => ({ url: `/api/billto/${queryArg.id}` }),
    }),
    getDataEntryAscRefCodes: build.query<
      GetDataEntryAscRefCodesApiResponse,
      GetDataEntryAscRefCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billto/${queryArg.id}/dataentryascrefcodes/${queryArg.carrierId}`,
      }),
    }),
    getAllBillTo: build.query<GetAllBillToApiResponse, GetAllBillToApiArg>({
      query: () => ({ url: `/api/billto` }),
    }),
    getBillToForDisplay: build.query<
      GetBillToForDisplayApiResponse,
      GetBillToForDisplayApiArg
    >({
      query: () => ({ url: `/api/billto/dropdown` }),
    }),
    getUserCustomers: build.query<
      GetUserCustomersApiResponse,
      GetUserCustomersApiArg
    >({
      query: () => ({ url: `/api/billto/user` }),
    }),
    getCentralSaltBillTos: build.query<
      GetCentralSaltBillTosApiResponse,
      GetCentralSaltBillTosApiArg
    >({
      query: () => ({ url: `/api/billto/centralsaltdropdown` }),
    }),
    getAllBillTosForDisplay: build.query<
      GetAllBillTosForDisplayApiResponse,
      GetAllBillTosForDisplayApiArg
    >({
      query: () => ({ url: `/api/billto/alldropdown` }),
    }),
    getActiveBillTosForDisplay: build.query<
      GetActiveBillTosForDisplayApiResponse,
      GetActiveBillTosForDisplayApiArg
    >({
      query: () => ({ url: `/api/billto/activedropdown` }),
    }),
    getCustomerById: build.query<
      GetCustomerByIdApiResponse,
      GetCustomerByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billto/admin/${queryArg.customerId}`,
      }),
    }),
    modifyCustomers: build.mutation<
      ModifyCustomersApiResponse,
      ModifyCustomersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billto/admin/${queryArg.customerId}`,
        method: "PUT",
        body: queryArg.billToVm,
      }),
    }),
    deleteCustomers: build.mutation<
      DeleteCustomersApiResponse,
      DeleteCustomersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billto/admin/${queryArg.customerId}`,
        method: "DELETE",
      }),
    }),
    getAllCustomers: build.query<
      GetAllCustomersApiResponse,
      GetAllCustomersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billto/admin`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCustomers: build.mutation<
      CreateCustomersApiResponse,
      CreateCustomersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billto/admin`,
        method: "POST",
        body: queryArg.billToVm,
      }),
    }),
    getParentCustomers: build.query<
      GetParentCustomersApiResponse,
      GetParentCustomersApiArg
    >({
      query: () => ({ url: `/api/billto/parent` }),
    }),
    activateCustomers: build.mutation<
      ActivateCustomersApiResponse,
      ActivateCustomersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billto/admin/${queryArg.customerId}/active`,
        method: "PUT",
        body: queryArg.billToActiveVm,
      }),
    }),
    getFeeInvoiceData: build.query<
      GetFeeInvoiceDataApiResponse,
      GetFeeInvoiceDataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billtofeeinvoice/${queryArg.customerId}`,
      }),
    }),
    setFeeInvoiceData: build.mutation<
      SetFeeInvoiceDataApiResponse,
      SetFeeInvoiceDataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billtofeeinvoice`,
        method: "PUT",
        body: queryArg.billToFeeInvoiceVm,
      }),
    }),
    getModeDefaultsByCustomer: build.query<
      GetModeDefaultsByCustomerApiResponse,
      GetModeDefaultsByCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billtomodedefault/${queryArg.customerId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createBillToModeDefault: build.mutation<
      CreateBillToModeDefaultApiResponse,
      CreateBillToModeDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billtomodedefault`,
        method: "POST",
        body: queryArg.billToModeDefaultVm,
      }),
    }),
    modifyBillToModeDefault: build.mutation<
      ModifyBillToModeDefaultApiResponse,
      ModifyBillToModeDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billtomodedefault/${queryArg.defaultId}`,
        method: "PUT",
        body: queryArg.billToModeDefaultVm,
      }),
    }),
    deleteBillToModeDefault: build.mutation<
      DeleteBillToModeDefaultApiResponse,
      DeleteBillToModeDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/billtomodedefault/${queryArg.defaultId}`,
        method: "DELETE",
      }),
    }),
    getGlRules: build.query<GetGlRulesApiResponse, GetGlRulesApiArg>({
      query: (queryArg) => ({
        url: `/api/btaccountrules/${queryArg.customerId}`,
      }),
    }),
    getGlCodingPreview: build.query<
      GetGlCodingPreviewApiResponse,
      GetGlCodingPreviewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/btaccountrules/preview/${queryArg.customerId}/${queryArg.createDate}`,
      }),
    }),
    getGlOverwritePreview: build.query<
      GetGlOverwritePreviewApiResponse,
      GetGlOverwritePreviewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/btaccountrules/preview/${queryArg.customerId}/${queryArg.fromDate}/${queryArg.toDate}`,
      }),
    }),
    saveGlRules: build.mutation<SaveGlRulesApiResponse, SaveGlRulesApiArg>({
      query: (queryArg) => ({
        url: `/api/btaccountrules`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    glCodingBatch: build.mutation<
      GlCodingBatchApiResponse,
      GlCodingBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/btaccountrules/coding`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    glCodingQueue: build.mutation<
      GlCodingQueueApiResponse,
      GlCodingQueueApiArg
    >({
      query: (queryArg) => ({
        url: `/api/btaccountrules/queue`,
        method: "POST",
        body: queryArg.btCodingQueueVm,
      }),
    }),
    getBillToMapsByCarrier: build.query<
      GetBillToMapsByCarrierApiResponse,
      GetBillToMapsByCarrierApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrbtmap/${queryArg.carrierId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCarrierBtMap: build.mutation<
      CreateCarrierBtMapApiResponse,
      CreateCarrierBtMapApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrbtmap`,
        method: "POST",
        body: queryArg.carrBtMapVm,
      }),
    }),
    deleteCarrierBtMap: build.mutation<
      DeleteCarrierBtMapApiResponse,
      DeleteCarrierBtMapApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrbtmap/${queryArg.carrId}/${queryArg.carrAcct}/${queryArg.btId}`,
        method: "DELETE",
      }),
    }),
    getVoidableChecks: build.mutation<
      GetVoidableChecksApiResponse,
      GetVoidableChecksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrcheck/tovoid`,
        method: "POST",
        body: queryArg.checkInfoSearchVm,
      }),
    }),
    voidChecks: build.mutation<VoidChecksApiResponse, VoidChecksApiArg>({
      query: (queryArg) => ({
        url: `/api/carrcheck/void`,
        method: "POST",
        body: queryArg.body,
        params: {
          reason: queryArg.reason,
        },
      }),
    }),
    getAllRemits: build.query<GetAllRemitsApiResponse, GetAllRemitsApiArg>({
      query: () => ({ url: `/api/carrcheck/remits` }),
    }),
    makeRemits: build.mutation<MakeRemitsApiResponse, MakeRemitsApiArg>({
      query: (queryArg) => ({
        url: `/api/carrcheck/remits`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getRemitsForChecks: build.query<
      GetRemitsForChecksApiResponse,
      GetRemitsForChecksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrcheck/remits/${queryArg.checkNums}`,
      }),
    }),
    getRemitKeys: build.query<GetRemitKeysApiResponse, GetRemitKeysApiArg>({
      query: () => ({ url: `/api/carrcheck/remitkeys` }),
    }),
    getRemitsForKey: build.query<
      GetRemitsForKeyApiResponse,
      GetRemitsForKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrcheck/remitkey/${queryArg.remitKey}`,
      }),
    }),
    getCarrierEdiMasterById: build.query<
      GetCarrierEdiMasterByIdApiResponse,
      GetCarrierEdiMasterByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carredimaster/${queryArg.carrierId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCarrierEdiMaster: build.mutation<
      CreateCarrierEdiMasterApiResponse,
      CreateCarrierEdiMasterApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carredimaster`,
        method: "POST",
        body: queryArg.carrEdiMasterVm,
      }),
    }),
    modifyCarrierEdiMaster: build.mutation<
      ModifyCarrierEdiMasterApiResponse,
      ModifyCarrierEdiMasterApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carredimaster/${queryArg.senderQual}/${queryArg.senderId}/${queryArg.ediType}/${queryArg.rcvQual}/${queryArg.rcvId}`,
        method: "PUT",
        body: queryArg.carrEdiMasterVm,
      }),
    }),
    deleteCarrierEdiMaster: build.mutation<
      DeleteCarrierEdiMasterApiResponse,
      DeleteCarrierEdiMasterApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carredimaster/${queryArg.senderQual}/${queryArg.senderId}/${queryArg.ediType}/${queryArg.rcvQual}/${queryArg.rcvId}`,
        method: "DELETE",
      }),
    }),
    getAllCarrierFamilies: build.query<
      GetAllCarrierFamiliesApiResponse,
      GetAllCarrierFamiliesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrfam`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getCarrierFamilyTree: build.query<
      GetCarrierFamilyTreeApiResponse,
      GetCarrierFamilyTreeApiArg
    >({
      query: () => ({ url: `/api/carrfam/tree` }),
    }),
    getCarrierFamilyById: build.query<
      GetCarrierFamilyByIdApiResponse,
      GetCarrierFamilyByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/carrfam/${queryArg.familyId}` }),
    }),
    getFamilyMembers: build.query<
      GetFamilyMembersApiResponse,
      GetFamilyMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrfam/${queryArg.familyId}/members`,
      }),
    }),
    createCarrierFamily: build.mutation<
      CreateCarrierFamilyApiResponse,
      CreateCarrierFamilyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrfam/admin`,
        method: "POST",
        body: queryArg.createCarrFamRequest,
      }),
    }),
    updateCarrierFamily: build.mutation<
      UpdateCarrierFamilyApiResponse,
      UpdateCarrierFamilyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrfam/admin/${queryArg.familyId}`,
        method: "PUT",
        body: queryArg.updateCarrFamRequest,
      }),
    }),
    deleteCarrierFamily: build.mutation<
      DeleteCarrierFamilyApiResponse,
      DeleteCarrierFamilyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrfam/admin/${queryArg.familyId}`,
        method: "DELETE",
      }),
    }),
    assignCarrierToFamily: build.mutation<
      AssignCarrierToFamilyApiResponse,
      AssignCarrierToFamilyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrfam/admin/${queryArg.familyId}/members`,
        method: "POST",
        body: queryArg.assignCarrierToFamilyRequest,
      }),
    }),
    removeCarrierFromFamily: build.mutation<
      RemoveCarrierFromFamilyApiResponse,
      RemoveCarrierFromFamilyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrfam/admin/${queryArg.familyId}/members/${queryArg.carrierId}`,
        method: "DELETE",
      }),
    }),
    checkFamilyNameExists: build.query<
      CheckFamilyNameExistsApiResponse,
      CheckFamilyNameExistsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrfam/admin/exists`,
        params: {
          familyName: queryArg.familyName,
          excludeFamilyId: queryArg.excludeFamilyId,
        },
      }),
    }),
    getCarriersForDropdown: build.query<
      GetCarriersForDropdownApiResponse,
      GetCarriersForDropdownApiArg
    >({
      query: () => ({ url: `/api/carrier` }),
    }),
    getActiveCarriersForDropdown: build.query<
      GetActiveCarriersForDropdownApiResponse,
      GetActiveCarriersForDropdownApiArg
    >({
      query: () => ({ url: `/api/carrier/activedropdown` }),
    }),
    getPermissionedCarriersForDropdown: build.query<
      GetPermissionedCarriersForDropdownApiResponse,
      GetPermissionedCarriersForDropdownApiArg
    >({
      query: () => ({ url: `/api/carrier/userdropdown` }),
    }),
    getByScac: build.query<GetByScacApiResponse, GetByScacApiArg>({
      query: (queryArg) => ({ url: `/api/carrier/scac/${queryArg.scac}` }),
    }),
    getCarrierChargeCodeMapping: build.query<
      GetCarrierChargeCodeMappingApiResponse,
      GetCarrierChargeCodeMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/chargecodemapping`,
        params: {
          options: queryArg.options,
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getCarrierChargeCodeMappingById: build.query<
      GetCarrierChargeCodeMappingByIdApiResponse,
      GetCarrierChargeCodeMappingByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/${queryArg.id}/chargecodemapping`,
      }),
    }),
    addNewCarrierChargeCodeMapping: build.mutation<
      AddNewCarrierChargeCodeMappingApiResponse,
      AddNewCarrierChargeCodeMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/${queryArg.id}/chargecodemapping`,
        method: "POST",
        body: queryArg.carrierChargeCodeMappingVm,
      }),
    }),
    updateCarrierChargeCodeMapping: build.mutation<
      UpdateCarrierChargeCodeMappingApiResponse,
      UpdateCarrierChargeCodeMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/${queryArg.id}/chargecodemapping`,
        method: "PUT",
        body: queryArg.carrierChargeCodeMappingVm,
      }),
    }),
    deletCarrierChargeCodeMapping: build.mutation<
      DeletCarrierChargeCodeMappingApiResponse,
      DeletCarrierChargeCodeMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/${queryArg.id}/chargecodemapping`,
        method: "DELETE",
        body: queryArg.carrierChargeCodeMappingVm,
      }),
    }),
    getCarrierChargeCodeMappingOverrides: build.query<
      GetCarrierChargeCodeMappingOverridesApiResponse,
      GetCarrierChargeCodeMappingOverridesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/chargecodemappingoverrides`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getCarrierChargeCodeMappingOverrideByCarrierId: build.query<
      GetCarrierChargeCodeMappingOverrideByCarrierIdApiResponse,
      GetCarrierChargeCodeMappingOverrideByCarrierIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/${queryArg.id}/chargecodemappingoverrides`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    addNewCarrierChargeCodeMappingOverride: build.mutation<
      AddNewCarrierChargeCodeMappingOverrideApiResponse,
      AddNewCarrierChargeCodeMappingOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/${queryArg.id}/chargecodemappingoverrides/${queryArg.billto}`,
        method: "POST",
        body: queryArg.carrierChargeCodesCustomerModeOverrideVm,
      }),
    }),
    updateCarrierChargeCodeMappingOverride: build.mutation<
      UpdateCarrierChargeCodeMappingOverrideApiResponse,
      UpdateCarrierChargeCodeMappingOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/${queryArg.id}/chargecodemappingoverrides/${queryArg.billto}`,
        method: "PUT",
        body: queryArg.carrierChargeCodesCustomerModeOverrideVm,
      }),
    }),
    deleteCarrierChargeCodeMappingOverride: build.mutation<
      DeleteCarrierChargeCodeMappingOverrideApiResponse,
      DeleteCarrierChargeCodeMappingOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/${queryArg.id}/chargecodemappingoverrides/${queryArg.billto}`,
        method: "DELETE",
        body: queryArg.carrierChargeCodesCustomerModeOverrideVm,
      }),
    }),
    getCarrierById: build.query<
      GetCarrierByIdApiResponse,
      GetCarrierByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/carrier/${queryArg.carrierId}` }),
    }),
    getAllCarriers: build.query<
      GetAllCarriersApiResponse,
      GetAllCarriersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/admin`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCarriers: build.mutation<
      CreateCarriersApiResponse,
      CreateCarriersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/admin`,
        method: "POST",
        body: queryArg.carrierVm,
      }),
    }),
    modifyCarriers: build.mutation<
      ModifyCarriersApiResponse,
      ModifyCarriersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/admin/${queryArg.carrierId}`,
        method: "PUT",
        body: queryArg.carrierVm,
      }),
    }),
    deleteCarriers: build.mutation<
      DeleteCarriersApiResponse,
      DeleteCarriersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/admin/${queryArg.carrierId}`,
        method: "DELETE",
      }),
    }),
    activateCarriers: build.mutation<
      ActivateCarriersApiResponse,
      ActivateCarriersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/admin/${queryArg.carrierId}/active`,
        method: "PUT",
        body: queryArg.carrierActiveVm,
      }),
    }),
    getModeOverrides: build.query<
      GetModeOverridesApiResponse,
      GetModeOverridesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/getmodeoverrides`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getSpecificModeOverride: build.query<
      GetSpecificModeOverrideApiResponse,
      GetSpecificModeOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/getspecificmodeoverride/${queryArg.carrierId}/${queryArg.btid}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    deleteModeOverride: build.mutation<
      DeleteModeOverrideApiResponse,
      DeleteModeOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/deletemodeoverride/${queryArg.carrierId}/${queryArg.btid}`,
        method: "DELETE",
      }),
    }),
    updateModeOverride: build.mutation<
      UpdateModeOverrideApiResponse,
      UpdateModeOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/updatemodeoverride`,
        method: "PUT",
        body: queryArg.billToCarrierModeOverrideVm,
      }),
    }),
    addModeOverride: build.mutation<
      AddModeOverrideApiResponse,
      AddModeOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrier/addmodeoverride`,
        method: "PUT",
        body: queryArg.billToCarrierModeOverrideVm,
      }),
    }),
    getAllCarrierContacts: build.query<
      GetAllCarrierContactsApiResponse,
      GetAllCarrierContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carriercontact`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCarrierContacts: build.mutation<
      CreateCarrierContactsApiResponse,
      CreateCarrierContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carriercontact`,
        method: "POST",
        body: queryArg.carrierContactVm,
      }),
    }),
    getCarrierContactById: build.query<
      GetCarrierContactByIdApiResponse,
      GetCarrierContactByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carriercontact/${queryArg.carrierId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    modifyCarrierContacts: build.mutation<
      ModifyCarrierContactsApiResponse,
      ModifyCarrierContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carriercontact/${queryArg.contactId}`,
        method: "PUT",
        body: queryArg.carrierContactVm,
      }),
    }),
    deleteCarrierContacts: build.mutation<
      DeleteCarrierContactsApiResponse,
      DeleteCarrierContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carriercontact/${queryArg.contactId}`,
        method: "DELETE",
      }),
    }),
    getCarrierModeMapsById: build.query<
      GetCarrierModeMapsByIdApiResponse,
      GetCarrierModeMapsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carriermodemap/${queryArg.carrierId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCarrierModeMaps: build.mutation<
      CreateCarrierModeMapsApiResponse,
      CreateCarrierModeMapsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carriermodemap`,
        method: "POST",
        body: queryArg.carrierModeMapVm,
      }),
    }),
    modifyCarrierModeMaps: build.mutation<
      ModifyCarrierModeMapsApiResponse,
      ModifyCarrierModeMapsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carriermodemap/${queryArg.mapId}`,
        method: "PUT",
        body: queryArg.carrierModeMapVm,
      }),
    }),
    deleteCarrierModeMaps: build.mutation<
      DeleteCarrierModeMapsApiResponse,
      DeleteCarrierModeMapsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carriermodemap/${queryArg.mapId}`,
        method: "DELETE",
      }),
    }),
    getPayMethodsForCarrier: build.query<
      GetPayMethodsForCarrierApiResponse,
      GetPayMethodsForCarrierApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrierpaymentremit/${queryArg.carrierId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCarrierPayRemit: build.mutation<
      CreateCarrierPayRemitApiResponse,
      CreateCarrierPayRemitApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrierpaymentremit`,
        method: "POST",
        body: queryArg.carrierPaymentRemitVm,
      }),
    }),
    modifyCarrierPayRemit: build.mutation<
      ModifyCarrierPayRemitApiResponse,
      ModifyCarrierPayRemitApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrierpaymentremit/${queryArg.remitInfoId}`,
        method: "PUT",
        body: queryArg.carrierPaymentRemitVm,
      }),
    }),
    deleteCarrierPayRemit: build.mutation<
      DeleteCarrierPayRemitApiResponse,
      DeleteCarrierPayRemitApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrierpaymentremit/${queryArg.remitInfoId}`,
        method: "DELETE",
      }),
    }),
    getCarrierRemitMethods: build.query<
      GetCarrierRemitMethodsApiResponse,
      GetCarrierRemitMethodsApiArg
    >({
      query: () => ({ url: `/api/carrierpaymentremit/remitmethods` }),
    }),
    getCarrierRemitDeliveryMethods: build.query<
      GetCarrierRemitDeliveryMethodsApiResponse,
      GetCarrierRemitDeliveryMethodsApiArg
    >({
      query: () => ({ url: `/api/carrierpaymentremit/remitdeliverymethods` }),
    }),
    getCarrierRemitFormats: build.query<
      GetCarrierRemitFormatsApiResponse,
      GetCarrierRemitFormatsApiArg
    >({
      query: () => ({ url: `/api/carrierpaymentremit/remitformats` }),
    }),
    getAchSecCodes: build.query<
      GetAchSecCodesApiResponse,
      GetAchSecCodesApiArg
    >({
      query: () => ({ url: `/api/carrierpaymentremit/achseccodes` }),
    }),
    getCarrierInvoiceById: build.query<
      GetCarrierInvoiceByIdApiResponse,
      GetCarrierInvoiceByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/carrinv/${queryArg.id}` }),
    }),
    deleteInvoice: build.mutation<
      DeleteInvoiceApiResponse,
      DeleteInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getCarrInvByInvNum: build.query<
      GetCarrInvByInvNumApiResponse,
      GetCarrInvByInvNumApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.recType}/${queryArg.carrId}/${queryArg.invNum}`,
      }),
    }),
    getInvoiceSummary: build.query<
      GetInvoiceSummaryApiResponse,
      GetInvoiceSummaryApiArg
    >({
      query: (queryArg) => ({ url: `/api/carrinv/${queryArg.id}/summary` }),
    }),
    getInvoiceLineSummary: build.query<
      GetInvoiceLineSummaryApiResponse,
      GetInvoiceLineSummaryApiArg
    >({
      query: (queryArg) => ({ url: `/api/carrinv/${queryArg.id}/linesummary` }),
    }),
    getInvoiceChargeDetails: build.query<
      GetInvoiceChargeDetailsApiResponse,
      GetInvoiceChargeDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/chargedetails`,
      }),
    }),
    getInvoiceLineChargeDetails: build.query<
      GetInvoiceLineChargeDetailsApiResponse,
      GetInvoiceLineChargeDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/linechargedetails`,
      }),
    }),
    getBundleInfo: build.query<GetBundleInfoApiResponse, GetBundleInfoApiArg>({
      query: (queryArg) => ({
        url: `/api/carrinv/bundleinfo/${queryArg.bundleId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getAllInvoiceRevs: build.query<
      GetAllInvoiceRevsApiResponse,
      GetAllInvoiceRevsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/getallrevs/${queryArg.recType}/${queryArg.carrierId}/${queryArg.invoiceNum}`,
      }),
    }),
    create: build.mutation<CreateApiResponse, CreateApiArg>({
      query: (queryArg) => ({
        url: `/api/carrinv`,
        method: "POST",
        body: queryArg.carrInvVm,
      }),
    }),
    createWebInvoice: build.mutation<
      CreateWebInvoiceApiResponse,
      CreateWebInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/webinvoice`,
        method: "POST",
        body: queryArg.carrInvVm,
      }),
    }),
    updateWebInvoice: build.mutation<
      UpdateWebInvoiceApiResponse,
      UpdateWebInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/webinvoice`,
        method: "PUT",
        body: queryArg.carrInvVm,
        params: {
          comment: queryArg.comment,
        },
      }),
    }),
    initiateMultiPartInvoiceCreation: build.mutation<
      InitiateMultiPartInvoiceCreationApiResponse,
      InitiateMultiPartInvoiceCreationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/initiatemultipartinvoicecreation`,
        method: "POST",
        body: queryArg.initiateMultiPartInvoiceCreationRequest,
      }),
    }),
    multiPartInvoiceCreation: build.mutation<
      MultiPartInvoiceCreationApiResponse,
      MultiPartInvoiceCreationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/multipartinvoicecreation`,
        method: "POST",
        body: queryArg.invoicePartRequest,
      }),
    }),
    completeMultiPartInvoiceCreation: build.mutation<
      CompleteMultiPartInvoiceCreationApiResponse,
      CompleteMultiPartInvoiceCreationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/completemultipartinvoicecreation`,
        method: "POST",
        body: queryArg.completeMultiPartInvoiceCreationRequest,
      }),
    }),
    abortMultiPartInvoiceCreation: build.mutation<
      AbortMultiPartInvoiceCreationApiResponse,
      AbortMultiPartInvoiceCreationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/abortmultipartinvoicecreation`,
        method: "POST",
        body: queryArg.abortMultiPartInvoiceCreationRequest,
      }),
    }),
    createQueued: build.mutation<CreateQueuedApiResponse, CreateQueuedApiArg>({
      query: (queryArg) => ({
        url: `/api/carrinv/queued`,
        method: "POST",
        body: queryArg.carrInvVm,
      }),
    }),
    postApiCarrinvCheckqueuedinvoicecreationstate: build.mutation<
      PostApiCarrinvCheckqueuedinvoicecreationstateApiResponse,
      PostApiCarrinvCheckqueuedinvoicecreationstateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/checkqueuedinvoicecreationstate`,
        method: "POST",
        body: queryArg.invoiceCreationStatusRequest,
      }),
    }),
    reAudit: build.mutation<ReAuditApiResponse, ReAuditApiArg>({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/reaudit`,
        method: "POST",
      }),
    }),
    testAudit: build.mutation<TestAuditApiResponse, TestAuditApiArg>({
      query: (queryArg) => ({
        url: `/api/carrinv/testaudit`,
        method: "POST",
        body: queryArg.carrInvVm,
      }),
    }),
    deleteShipment: build.mutation<
      DeleteShipmentApiResponse,
      DeleteShipmentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/shipment/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    makeInvoiceMemo: build.mutation<
      MakeInvoiceMemoApiResponse,
      MakeInvoiceMemoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/memo`,
        method: "POST",
        params: {
          id: queryArg.id,
          comment: queryArg.comment,
        },
      }),
    }),
    makeInvoiceReal: build.mutation<
      MakeInvoiceRealApiResponse,
      MakeInvoiceRealApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/real`,
        method: "POST",
        params: {
          id: queryArg.id,
          comment: queryArg.comment,
        },
      }),
    }),
    reassignInvoiceCustomer: build.mutation<
      ReassignInvoiceCustomerApiResponse,
      ReassignInvoiceCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/changecustomer`,
        method: "POST",
        body: queryArg.carrInvCustChangeVm,
      }),
    }),
    reassignInvoiceNumber: build.mutation<
      ReassignInvoiceNumberApiResponse,
      ReassignInvoiceNumberApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/changenumber`,
        method: "POST",
        body: queryArg.carrInvNumberChangeVm,
      }),
    }),
    validateCoding: build.mutation<
      ValidateCodingApiResponse,
      ValidateCodingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/validatecoding`,
        method: "POST",
        params: {
          isSave: queryArg.isSave,
          isFromApp: queryArg.isFromApp,
        },
      }),
    }),
    validateLineCoding: build.mutation<
      ValidateLineCodingApiResponse,
      ValidateLineCodingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/validatecoding/${queryArg.lineIdx}`,
        method: "POST",
        params: {
          isSave: queryArg.isSave,
          isFromApp: queryArg.isFromApp,
        },
      }),
    }),
    createBillingInvoice: build.mutation<
      CreateBillingInvoiceApiResponse,
      CreateBillingInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/createbillinginvoice`,
        method: "POST",
        params: {
          handledInvoiceException: queryArg.handledInvoiceException,
          createPdf: queryArg.createPdf,
          createDupeIfExists: queryArg.createDupeIfExists,
        },
      }),
    }),
    createBillingInvoiceQueued: build.mutation<
      CreateBillingInvoiceQueuedApiResponse,
      CreateBillingInvoiceQueuedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/createbillinginvoice/queued`,
        method: "POST",
        params: {
          handledInvoiceException: queryArg.handledInvoiceException,
          createPdf: queryArg.createPdf,
        },
      }),
    }),
    createPdfInvoice: build.mutation<
      CreatePdfInvoiceApiResponse,
      CreatePdfInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/createpdfinvoice`,
        method: "POST",
      }),
    }),
    createPdfInvoiceQueued: build.mutation<
      CreatePdfInvoiceQueuedApiResponse,
      CreatePdfInvoiceQueuedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/createpdfinvoice/queued`,
        method: "POST",
      }),
    }),
    regeneratePdfInvoice: build.mutation<
      RegeneratePdfInvoiceApiResponse,
      RegeneratePdfInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/regeneratepdfinvoice/queued`,
        method: "POST",
      }),
    }),
    getImagesForInvoice: build.query<
      GetImagesForInvoiceApiResponse,
      GetImagesForInvoiceApiArg
    >({
      query: (queryArg) => ({ url: `/api/carrinv/${queryArg.id}/images` }),
    }),
    addImage: build.mutation<AddImageApiResponse, AddImageApiArg>({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/images`,
        method: "POST",
        body: queryArg.carrierInvoiceImagesVm,
      }),
    }),
    clearCachedImagesForInvoice: build.mutation<
      ClearCachedImagesForInvoiceApiResponse,
      ClearCachedImagesForInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/images/clearcachedimages`,
        method: "POST",
      }),
    }),
    getImageWithData: build.query<
      GetImageWithDataApiResponse,
      GetImageWithDataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/images/${queryArg.imageId}`,
      }),
    }),
    getImageWithDataFromObject: build.mutation<
      GetImageWithDataFromObjectApiResponse,
      GetImageWithDataFromObjectApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/images/${queryArg.imageId}/obj`,
        method: "POST",
        body: queryArg.carrierInvoiceImagesVm,
      }),
    }),
    getInvoiceEdi: build.query<GetInvoiceEdiApiResponse, GetInvoiceEdiApiArg>({
      query: (queryArg) => ({ url: `/api/carrinv/${queryArg.id}/edi` }),
    }),
    carrInvDisconnectImage: build.mutation<
      CarrInvDisconnectImageApiResponse,
      CarrInvDisconnectImageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/images/${queryArg.imageId}/disconnect`,
        method: "PUT",
      }),
    }),
    whatIfChargeCodesForNewBillto: build.query<
      WhatIfChargeCodesForNewBilltoApiResponse,
      WhatIfChargeCodesForNewBilltoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/${queryArg.id}/chargecodewhatif/${queryArg.newBillToId}`,
      }),
    }),
    getInvoicesForBatching: build.query<
      GetInvoicesForBatchingApiResponse,
      GetInvoicesForBatchingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrinv/receivables/${queryArg.searchDate}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getAllCarrServices: build.query<
      GetAllCarrServicesApiResponse,
      GetAllCarrServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrservices`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCarrierServices: build.mutation<
      CreateCarrierServicesApiResponse,
      CreateCarrierServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrservices`,
        method: "POST",
        body: queryArg.carrServicesVm,
      }),
    }),
    getCarrierServicesById: build.query<
      GetCarrierServicesByIdApiResponse,
      GetCarrierServicesByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrservices/${queryArg.carrierId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    modifyCarrierService: build.mutation<
      ModifyCarrierServiceApiResponse,
      ModifyCarrierServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrservices/${queryArg.carrierId}/${queryArg.svcCode}`,
        method: "PUT",
        body: queryArg.carrServicesVm,
      }),
    }),
    deleteCarrierServices: build.mutation<
      DeleteCarrierServicesApiResponse,
      DeleteCarrierServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/carrservices/${queryArg.carrierId}/${queryArg.svcCode}`,
        method: "DELETE",
      }),
    }),
    getAllowedCarrSvcAuditFns: build.query<
      GetAllowedCarrSvcAuditFnsApiResponse,
      GetAllowedCarrSvcAuditFnsApiArg
    >({
      query: () => ({ url: `/api/carrservices/functions` }),
    }),
    getTicket: build.query<GetTicketApiResponse, GetTicketApiArg>({
      query: (queryArg) => ({
        url: `/api/centralsalt/${queryArg.customerId}/${queryArg.carrierId}/${queryArg.ticketNum}`,
      }),
    }),
    makeCSaltInvoice: build.mutation<
      MakeCSaltInvoiceApiResponse,
      MakeCSaltInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/centralsalt`,
        method: "POST",
        body: queryArg.centralSaltVm,
      }),
    }),
    getRegisterFbOs: build.query<
      GetRegisterFbOsApiResponse,
      GetRegisterFbOsApiArg
    >({
      query: () => ({ url: `/api/checkregister/fbo` }),
    }),
    getRegisterInfo: build.mutation<
      GetRegisterInfoApiResponse,
      GetRegisterInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/checkregister`,
        method: "POST",
        body: queryArg.checkRegisterRequestVm,
      }),
    }),
    getAllCmContracts: build.query<
      GetAllCmContractsApiResponse,
      GetAllCmContractsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cmcontract`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCmContracts: build.mutation<
      CreateCmContractsApiResponse,
      CreateCmContractsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cmcontract`,
        method: "POST",
        body: queryArg.cmContractVm,
      }),
    }),
    modifyCmContracts: build.mutation<
      ModifyCmContractsApiResponse,
      ModifyCmContractsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cmcontract/${queryArg.carrier}/${queryArg.customer}/${queryArg.service}`,
        method: "PUT",
        body: queryArg.cmContractVm,
      }),
    }),
    deleteCmContracts: build.mutation<
      DeleteCmContractsApiResponse,
      DeleteCmContractsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/cmcontract/${queryArg.carrier}/${queryArg.customer}/${queryArg.service}`,
        method: "DELETE",
      }),
    }),
    getAllMasterCodes: build.query<
      GetAllMasterCodesApiResponse,
      GetAllMasterCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/codemaster`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getMasterCodesForElement: build.query<
      GetMasterCodesForElementApiResponse,
      GetMasterCodesForElementApiArg
    >({
      query: (queryArg) => ({
        url: `/api/codemaster/${queryArg.element}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    addMode: build.mutation<AddModeApiResponse, AddModeApiArg>({
      query: (queryArg) => ({
        url: `/api/codemaster/addmode`,
        method: "POST",
        body: queryArg.codeMasterVm,
      }),
    }),
    modifyMasterCodes: build.mutation<
      ModifyMasterCodesApiResponse,
      ModifyMasterCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/codemaster/${queryArg.element}/${queryArg.code}`,
        method: "PUT",
        body: queryArg.codeMasterVm,
      }),
    }),
    getMasterCodeFilters: build.query<
      GetMasterCodeFiltersApiResponse,
      GetMasterCodeFiltersApiArg
    >({
      query: () => ({ url: `/api/codemaster/filters` }),
    }),
    getActiveCurrencyCodes: build.query<
      GetActiveCurrencyCodesApiResponse,
      GetActiveCurrencyCodesApiArg
    >({
      query: () => ({ url: `/api/codemaster/currencycodes` }),
    }),
    getAuditFailCodes: build.query<
      GetAuditFailCodesApiResponse,
      GetAuditFailCodesApiArg
    >({
      query: () => ({ url: `/api/codemaster/auditfailcodes` }),
    }),
    getPreReqStatuses: build.query<
      GetPreReqStatusesApiResponse,
      GetPreReqStatusesApiArg
    >({
      query: () => ({ url: `/api/codemaster/prereqstatuses` }),
    }),
    getCustomerContactsById: build.query<
      GetCustomerContactsByIdApiResponse,
      GetCustomerContactsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/contact/${queryArg.customerId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCustomerContacts: build.mutation<
      CreateCustomerContactsApiResponse,
      CreateCustomerContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/contact`,
        method: "POST",
        body: queryArg.contactsVm,
      }),
    }),
    modifyCustomerContacts: build.mutation<
      ModifyCustomerContactsApiResponse,
      ModifyCustomerContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/contact/${queryArg.contactId}`,
        method: "PUT",
        body: queryArg.contactsVm,
      }),
    }),
    deleteCustomerContacts: build.mutation<
      DeleteCustomerContactsApiResponse,
      DeleteCustomerContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/contact/${queryArg.contactId}`,
        method: "DELETE",
      }),
    }),
    getAllCurrencies: build.query<
      GetAllCurrenciesApiResponse,
      GetAllCurrenciesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/currencies`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getRefDefs: build.query<GetRefDefsApiResponse, GetRefDefsApiArg>({
      query: (queryArg) => ({
        url: `/api/customerdataentry/${queryArg.customerId}/${queryArg.carrierId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getCustomerRefDefs: build.query<
      GetCustomerRefDefsApiResponse,
      GetCustomerRefDefsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/customerdataentry/${queryArg.customerId}`,
      }),
    }),
    getRefDefsForInvoice: build.query<
      GetRefDefsForInvoiceApiResponse,
      GetRefDefsForInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/customerdataentry/invoice/${queryArg.customerId}/${queryArg.carrierId}`,
      }),
    }),
    createRefDef: build.mutation<CreateRefDefApiResponse, CreateRefDefApiArg>({
      query: (queryArg) => ({
        url: `/api/customerdataentry`,
        method: "POST",
        body: queryArg.customerDataEntryVm,
      }),
    }),
    modifyRefDef: build.mutation<ModifyRefDefApiResponse, ModifyRefDefApiArg>({
      query: (queryArg) => ({
        url: `/api/customerdataentry/${queryArg.defId}`,
        method: "PUT",
        body: queryArg.customerDataEntryVm,
      }),
    }),
    deleteRefDef: build.mutation<DeleteRefDefApiResponse, DeleteRefDefApiArg>({
      query: (queryArg) => ({
        url: `/api/customerdataentry/${queryArg.defId}`,
        method: "DELETE",
      }),
    }),
    createAndPrepBatches: build.mutation<
      CreateAndPrepBatchesApiResponse,
      CreateAndPrepBatchesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/customerinvoice/createandprepbatches`,
        method: "POST",
        body: queryArg.createReceivableBatchesForCustomersVm,
      }),
    }),
    getChildBatches: build.query<
      GetChildBatchesApiResponse,
      GetChildBatchesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/customerinvoice/childbatches/${queryArg.customer}/${queryArg.reqDate}`,
      }),
    }),
    createAndPrepBatchesFromInvoices: build.mutation<
      CreateAndPrepBatchesFromInvoicesApiResponse,
      CreateAndPrepBatchesFromInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/customerinvoice/createandprepbatchesfrominvoices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getAgedReceivables: build.query<
      GetAgedReceivablesApiResponse,
      GetAgedReceivablesApiArg
    >({
      query: () => ({ url: `/api/customerinvoice/agedreceivables` }),
    }),
    getList: build.query<GetListApiResponse, GetListApiArg>({
      query: () => ({ url: `/api/custpay` }),
    }),
    upsert: build.mutation<UpsertApiResponse, UpsertApiArg>({
      query: (queryArg) => ({
        url: `/api/custpay`,
        method: "POST",
        body: queryArg.custPaySetupVm,
      }),
    }),
    getCustPayByBillToIdById: build.query<
      GetCustPayByBillToIdByIdApiResponse,
      GetCustPayByBillToIdByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/custpay/btid/${queryArg.id}` }),
    }),
    getCustPaySetupById: build.query<
      GetCustPaySetupByIdApiResponse,
      GetCustPaySetupByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/custpay/${queryArg.customerId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCustPaySetup: build.mutation<
      CreateCustPaySetupApiResponse,
      CreateCustPaySetupApiArg
    >({
      query: (queryArg) => ({
        url: `/api/custpay/${queryArg.customerId}`,
        method: "POST",
        body: queryArg.custPaySetupVm,
      }),
    }),
    modifyCustPaySetup: build.mutation<
      ModifyCustPaySetupApiResponse,
      ModifyCustPaySetupApiArg
    >({
      query: (queryArg) => ({
        url: `/api/custpay/${queryArg.setupId}`,
        method: "PUT",
        body: queryArg.custPaySetupVm,
      }),
    }),
    deleteCustPaySetup: build.mutation<
      DeleteCustPaySetupApiResponse,
      DeleteCustPaySetupApiArg
    >({
      query: (queryArg) => ({
        url: `/api/custpay/${queryArg.setupId}`,
        method: "DELETE",
      }),
    }),
    getShipmentCountByStatus: build.query<
      GetShipmentCountByStatusApiResponse,
      GetShipmentCountByStatusApiArg
    >({
      query: () => ({ url: `/api/dashboard/shipmentcountbystatus` }),
    }),
    getAgedInvoiceSummary: build.query<
      GetAgedInvoiceSummaryApiResponse,
      GetAgedInvoiceSummaryApiArg
    >({
      query: () => ({ url: `/api/dashboard/agedinvoicesummary` }),
    }),
    getDataEntryAdminInfoByCustomer: build.query<
      GetDataEntryAdminInfoByCustomerApiResponse,
      GetDataEntryAdminInfoByCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dataentryadmin/${queryArg.customerId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getDataEntryAdminInfoForInvoice: build.query<
      GetDataEntryAdminInfoForInvoiceApiResponse,
      GetDataEntryAdminInfoForInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dataentryadmin/${queryArg.customerId}/${queryArg.carrierId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    modifyDataEntryAdminInfo: build.mutation<
      ModifyDataEntryAdminInfoApiResponse,
      ModifyDataEntryAdminInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dataentryadmin/${queryArg.customerId}/${queryArg.carrierId}`,
        method: "PUT",
        body: queryArg.deAdminVm,
      }),
    }),
    deleteDataEntryAdminInfo: build.mutation<
      DeleteDataEntryAdminInfoApiResponse,
      DeleteDataEntryAdminInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dataentryadmin/${queryArg.customerId}/${queryArg.carrierId}`,
        method: "DELETE",
      }),
    }),
    createDataEntryAdminInfo: build.mutation<
      CreateDataEntryAdminInfoApiResponse,
      CreateDataEntryAdminInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dataentryadmin`,
        method: "POST",
        body: queryArg.deAdminVm,
      }),
    }),
    invoiceResearchExport: build.mutation<
      InvoiceResearchExportApiResponse,
      InvoiceResearchExportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dataexport/invoiceresearchexport`,
        method: "POST",
        body: queryArg.invoiceResearchOptionsVm,
        params: {
          userJobName: queryArg.userJobName,
          fileFormat: queryArg.fileFormat,
        },
      }),
    }),
    getDataExports: build.query<
      GetDataExportsApiResponse,
      GetDataExportsApiArg
    >({
      query: () => ({ url: `/api/dataexport` }),
    }),
    deleteExport: build.mutation<DeleteExportApiResponse, DeleteExportApiArg>({
      query: (queryArg) => ({
        url: `/api/dataexport/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    sendMailWithOutAttachments: build.mutation<
      SendMailWithOutAttachmentsApiResponse,
      SendMailWithOutAttachmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/email`,
        method: "POST",
        body: queryArg.emailVm,
      }),
    }),
    getActiveEquipsForDropdown: build.query<
      GetActiveEquipsForDropdownApiResponse,
      GetActiveEquipsForDropdownApiArg
    >({
      query: () => ({ url: `/api/equipment/dropdown` }),
    }),
    getInvoiceHistory: build.query<
      GetInvoiceHistoryApiResponse,
      GetInvoiceHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappinvoice/history/${queryArg.customerId}/${queryArg.startDate}/${queryArg.endDate}`,
      }),
    }),
    getInvoiceRange: build.mutation<
      GetInvoiceRangeApiResponse,
      GetInvoiceRangeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappinvoice/range`,
        method: "POST",
        body: queryArg.custFeesRangeRequestVm,
      }),
    }),
    getInvoiceHistoryDetails: build.query<
      GetInvoiceHistoryDetailsApiResponse,
      GetInvoiceHistoryDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappinvoice/details/${queryArg.customerId}/${queryArg.invoiceId}`,
      }),
    }),
    getInvoiceRangeDetails: build.query<
      GetInvoiceRangeDetailsApiResponse,
      GetInvoiceRangeDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappinvoice/rangedetails/${queryArg.customerId}/${queryArg.invoiceId}`,
      }),
    }),
    generateInvoiceDetailReport: build.query<
      GenerateInvoiceDetailReportApiResponse,
      GenerateInvoiceDetailReportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappinvoice/report/${queryArg.customerId}/${queryArg.invoiceId}`,
      }),
    }),
    deleteFeesInvoice: build.mutation<
      DeleteFeesInvoiceApiResponse,
      DeleteFeesInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappinvoice/${queryArg.invoiceId}`,
        method: "DELETE",
      }),
    }),
    renameFeesInvoice: build.mutation<
      RenameFeesInvoiceApiResponse,
      RenameFeesInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappinvoice/rename`,
        method: "POST",
        body: queryArg.custFeesChangeInvNumVm,
      }),
    }),
    importInvoices: build.mutation<
      ImportInvoicesApiResponse,
      ImportInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappinvoice/import`,
        method: "POST",
        body: queryArg.custFeesImportRequestVm,
      }),
    }),
    getImportDates: build.query<
      GetImportDatesApiResponse,
      GetImportDatesApiArg
    >({
      query: () => ({ url: `/api/feesappinvoice/importdates` }),
    }),
    getImportReportsForDate: build.query<
      GetImportReportsForDateApiResponse,
      GetImportReportsForDateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappinvoice/importfiles/${queryArg.importDate}`,
      }),
    }),
    getTermsCustomers: build.query<
      GetTermsCustomersApiResponse,
      GetTermsCustomersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappmakeinvoice/customers/${queryArg.isPayToTerms}`,
      }),
    }),
    testNonPayInvoices: build.mutation<
      TestNonPayInvoicesApiResponse,
      TestNonPayInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappmakeinvoice/nonpay/test`,
        method: "POST",
        body: queryArg.custFeesMakeInvoiceRequestVm,
      }),
    }),
    makeNonPayInvoices: build.mutation<
      MakeNonPayInvoicesApiResponse,
      MakeNonPayInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappmakeinvoice/nonpay/make`,
        method: "POST",
        body: queryArg.custFeesMakeInvoiceRequestVm,
      }),
    }),
    testPayInvoices: build.mutation<
      TestPayInvoicesApiResponse,
      TestPayInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappmakeinvoice/pay/test`,
        method: "POST",
        body: queryArg.custFeesMakeInvoiceRequestVm,
      }),
    }),
    makePayInvoices: build.mutation<
      MakePayInvoicesApiResponse,
      MakePayInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesappmakeinvoice/pay/make`,
        method: "POST",
        body: queryArg.custFeesMakeInvoiceRequestVm,
      }),
    }),
    getCompareRules: build.query<
      GetCompareRulesApiResponse,
      GetCompareRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesapprules/compare/${queryArg.customerId}`,
      }),
    }),
    convertFeesAppRule: build.mutation<
      ConvertFeesAppRuleApiResponse,
      ConvertFeesAppRuleApiArg
    >({
      query: () => ({ url: `/api/feesapprules/convert`, method: "POST" }),
    }),
    getCustomerRules: build.query<
      GetCustomerRulesApiResponse,
      GetCustomerRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesapprules/customer/${queryArg.customerId}`,
      }),
    }),
    getRuleData: build.query<GetRuleDataApiResponse, GetRuleDataApiArg>({
      query: (queryArg) => ({ url: `/api/feesapprules/${queryArg.ruleId}` }),
    }),
    deleteFeesRule: build.mutation<
      DeleteFeesRuleApiResponse,
      DeleteFeesRuleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesapprules/${queryArg.ruleId}`,
        method: "DELETE",
      }),
    }),
    createFeesRule: build.mutation<
      CreateFeesRuleApiResponse,
      CreateFeesRuleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesapprules`,
        method: "POST",
        body: queryArg.custFeesRuleInfoVm,
      }),
    }),
    updateFeesRule: build.mutation<
      UpdateFeesRuleApiResponse,
      UpdateFeesRuleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesapprules`,
        method: "PUT",
        body: queryArg.custFeesRuleInfoVm,
      }),
    }),
    setFeesRuleDetail: build.mutation<
      SetFeesRuleDetailApiResponse,
      SetFeesRuleDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesapprules/details`,
        method: "POST",
        body: queryArg.custFeesRuleTypeDetailsVm,
      }),
    }),
    getRuleTypes: build.query<GetRuleTypesApiResponse, GetRuleTypesApiArg>({
      query: () => ({ url: `/api/feesapprules/ruletypes` }),
    }),
    getBillPerTypes: build.query<
      GetBillPerTypesApiResponse,
      GetBillPerTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/feesapprules/billpertypes/${queryArg.periodic}`,
      }),
    }),
    getIntDomTypes: build.query<
      GetIntDomTypesApiResponse,
      GetIntDomTypesApiArg
    >({
      query: () => ({ url: `/api/feesapprules/intdomtypes` }),
    }),
    getFunctions: build.query<GetFunctionsApiResponse, GetFunctionsApiArg>({
      query: (queryArg) => ({
        url: `/api/functions`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createFunction: build.mutation<
      CreateFunctionApiResponse,
      CreateFunctionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/functions`,
        method: "POST",
        body: queryArg.functionsVm,
      }),
    }),
    modifyFunction: build.mutation<
      ModifyFunctionApiResponse,
      ModifyFunctionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/functions/${queryArg.functionId}`,
        method: "PUT",
        body: queryArg.functionsVm,
      }),
    }),
    bulkCoding: build.mutation<BulkCodingApiResponse, BulkCodingApiArg>({
      query: (queryArg) => ({
        url: `/api/glcoding/bulk`,
        method: "POST",
        body: queryArg.glBulkCodingRequest,
      }),
    }),
    getGlCodeForInvoice: build.mutation<
      GetGlCodeForInvoiceApiResponse,
      GetGlCodeForInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/glcoding/invoice`,
        method: "POST",
        body: queryArg.glCodingRequest,
      }),
    }),
    postHopkinsDepartment: build.mutation<
      PostHopkinsDepartmentApiResponse,
      PostHopkinsDepartmentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/glcoding/determinehopkinsdepartment`,
        method: "POST",
        body: queryArg.hopkinsDepartmentVm,
      }),
    }),
    getHealthCheck: build.query<
      GetHealthCheckApiResponse,
      GetHealthCheckApiArg
    >({
      query: () => ({ url: `/health/check` }),
    }),
    $get: build.query<$getApiResponse, $getApiArg>({
      query: () => ({ url: `/` }),
    }),
    getImage: build.query<GetImageApiResponse, GetImageApiArg>({
      query: (queryArg) => ({ url: `/api/images/${queryArg.imageId}` }),
    }),
    deleteImage: build.mutation<DeleteImageApiResponse, DeleteImageApiArg>({
      query: (queryArg) => ({
        url: `/api/images/${queryArg.imageId}`,
        method: "DELETE",
      }),
    }),
    deleteMultipleImages: build.mutation<
      DeleteMultipleImagesApiResponse,
      DeleteMultipleImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/deleteimages`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    disconnectImage: build.mutation<
      DisconnectImageApiResponse,
      DisconnectImageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/${queryArg.imageId}/disconnect`,
        method: "PUT",
      }),
    }),
    disconnectMultipleImages: build.mutation<
      DisconnectMultipleImagesApiResponse,
      DisconnectMultipleImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/disconnectimages`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getDisconnectedImages: build.query<
      GetDisconnectedImagesApiResponse,
      GetDisconnectedImagesApiArg
    >({
      query: () => ({ url: `/api/images/disconnectedimages` }),
    }),
    uploadDisconnectedImage: build.mutation<
      UploadDisconnectedImageApiResponse,
      UploadDisconnectedImageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/disconnectedimages`,
        method: "POST",
        body: queryArg.carrierInvoiceImagesVm,
      }),
    }),
    getDisconnectedImagesQueryable: build.query<
      GetDisconnectedImagesQueryableApiResponse,
      GetDisconnectedImagesQueryableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/disconnectedimagesqueryable`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getQueues: build.query<GetQueuesApiResponse, GetQueuesApiArg>({
      query: () => ({ url: `/api/images/queues` }),
    }),
    getQueueImages: build.query<
      GetQueueImagesApiResponse,
      GetQueueImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/queueimages/${queryArg.queue}`,
      }),
    }),
    indexImage: build.mutation<IndexImageApiResponse, IndexImageApiArg>({
      query: (queryArg) => ({
        url: `/api/images/${queryArg.queue}/indeximage`,
        method: "POST",
        body: queryArg.carrInvImages,
      }),
    }),
    addImageToQueue: build.mutation<
      AddImageToQueueApiResponse,
      AddImageToQueueApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/${queryArg.queue}/addimage`,
        method: "POST",
        body: queryArg.carrierInvoiceImagesVm,
      }),
    }),
    addScannedImage: build.mutation<
      AddScannedImageApiResponse,
      AddScannedImageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/addscan`,
        method: "PUT",
        body: queryArg.carrInvImageScanVm,
      }),
    }),
    getScannedImages: build.query<
      GetScannedImagesApiResponse,
      GetScannedImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/scans`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    deleteScannedImages: build.mutation<
      DeleteScannedImagesApiResponse,
      DeleteScannedImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/scans`,
        method: "DELETE",
        body: queryArg.body,
      }),
    }),
    getScannedImageCustomers: build.query<
      GetScannedImageCustomersApiResponse,
      GetScannedImageCustomersApiArg
    >({
      query: () => ({ url: `/api/images/scancusts` }),
    }),
    updateScannedImages: build.mutation<
      UpdateScannedImagesApiResponse,
      UpdateScannedImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/updatescans`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getAllowedImageTypes: build.query<
      GetAllowedImageTypesApiResponse,
      GetAllowedImageTypesApiArg
    >({
      query: () => ({ url: `/api/images/types` }),
    }),
    deleteUnindexedImage: build.mutation<
      DeleteUnindexedImageApiResponse,
      DeleteUnindexedImageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/deleteunindexed/${queryArg.queue}/${queryArg.image}`,
        method: "DELETE",
      }),
    }),
    customerImageExtract: build.mutation<
      CustomerImageExtractApiResponse,
      CustomerImageExtractApiArg
    >({
      query: (queryArg) => ({
        url: `/api/images/extract`,
        method: "POST",
        body: queryArg.custImageExtractVm,
      }),
    }),
    releaseInvoice: build.mutation<
      ReleaseInvoiceApiResponse,
      ReleaseInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/invoiceedit/${queryArg["type"]}/${queryArg.id}/release`,
        method: "PATCH",
      }),
    }),
    getBasicInvInfo: build.query<
      GetBasicInvInfoApiResponse,
      GetBasicInvInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/invoiceedit/${queryArg["type"]}/${queryArg.id}/basicinfo`,
      }),
    }),
    getDetailedCharges: build.query<
      GetDetailedChargesApiResponse,
      GetDetailedChargesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/invoiceedit/${queryArg["type"]}/${queryArg.id}/detailedcharges`,
      }),
    }),
    getReferences: build.query<GetReferencesApiResponse, GetReferencesApiArg>({
      query: (queryArg) => ({
        url: `/api/invoiceedit/${queryArg["type"]}/${queryArg.id}/references`,
      }),
    }),
    updateReferences: build.mutation<
      UpdateReferencesApiResponse,
      UpdateReferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/invoiceedit/${queryArg["type"]}/${queryArg.id}/references`,
        method: "PUT",
        body: queryArg.referenceListVm,
      }),
    }),
    getImages: build.query<GetImagesApiResponse, GetImagesApiArg>({
      query: (queryArg) => ({
        url: `/api/invoiceedit/${queryArg["type"]}/${queryArg.id}/images`,
      }),
    }),
    updateComment: build.mutation<
      UpdateCommentApiResponse,
      UpdateCommentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/invoiceedit/${queryArg["type"]}/${queryArg.id}/comments`,
        method: "PATCH",
        body: queryArg.invoiceComment,
      }),
    }),
    getPurgableInvoiceList: build.query<
      GetPurgableInvoiceListApiResponse,
      GetPurgableInvoiceListApiArg
    >({
      query: () => ({ url: `/api/invoicemaintenance/purgefiles` }),
    }),
    unbatchReceivableBatches: build.mutation<
      UnbatchReceivableBatchesApiResponse,
      UnbatchReceivableBatchesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/invoicemaintenance/unbatch/${queryArg.batchId}`,
        method: "POST",
      }),
    }),
    unapproveApprovedBatches: build.mutation<
      UnapproveApprovedBatchesApiResponse,
      UnapproveApprovedBatchesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/invoicemaintenance/unapprove/${queryArg.batchId}/${queryArg.unapproveAll}`,
        method: "POST",
      }),
    }),
    purgeInvoice: build.mutation<PurgeInvoiceApiResponse, PurgeInvoiceApiArg>({
      query: (queryArg) => ({
        url: `/api/invoicemaintenance/purge`,
        method: "POST",
        body: queryArg.invoicePurgeRequestVm,
      }),
    }),
    purgeInvoicesFromFile: build.mutation<
      PurgeInvoicesFromFileApiResponse,
      PurgeInvoicesFromFileApiArg
    >({
      query: (queryArg) => ({
        url: `/api/invoicemaintenance/purgefile/${queryArg.fileName}`,
        method: "POST",
      }),
    }),
    getInvoiceResearchPopulationData: build.query<
      GetInvoiceResearchPopulationDataApiResponse,
      GetInvoiceResearchPopulationDataApiArg
    >({
      query: () => ({ url: `/api/invoiceresearch` }),
    }),
    searchInvoices: build.mutation<
      SearchInvoicesApiResponse,
      SearchInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/invoiceresearch`,
        method: "POST",
        body: queryArg.invoiceResearchOptionsVm,
      }),
    }),
    reactDataTableServerSideProcessing: build.mutation<
      ReactDataTableServerSideProcessingApiResponse,
      ReactDataTableServerSideProcessingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/invoiceresearch/reactdatatable`,
        method: "POST",
        body: queryArg.invoiceResearchOptionsVm,
      }),
    }),
    getMakeRealWorkaroundInvoices: build.query<
      GetMakeRealWorkaroundInvoicesApiResponse,
      GetMakeRealWorkaroundInvoicesApiArg
    >({
      query: () => ({ url: `/api/itadmin/makereal` }),
    }),
    postMakeRealWorkaroundInvoices: build.mutation<
      PostMakeRealWorkaroundInvoicesApiResponse,
      PostMakeRealWorkaroundInvoicesApiArg
    >({
      query: () => ({ url: `/api/itadmin/makereal`, method: "POST" }),
    }),
    getStatusesForExceptions: build.query<
      GetStatusesForExceptionsApiResponse,
      GetStatusesForExceptionsApiArg
    >({
      query: () => ({ url: `/api/manageauditexception/getauditstatuses` }),
    }),
    getExceptionsForGrid: build.query<
      GetExceptionsForGridApiResponse,
      GetExceptionsForGridApiArg
    >({
      query: (queryArg) => ({
        url: `/api/manageauditexception`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    saveCurrentRemarks: build.mutation<
      SaveCurrentRemarksApiResponse,
      SaveCurrentRemarksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/manageauditexception/saveremarks`,
        method: "POST",
        body: queryArg.exceptionManagerActionVm,
      }),
    }),
    acceptAsEntered: build.mutation<
      AcceptAsEnteredApiResponse,
      AcceptAsEnteredApiArg
    >({
      query: (queryArg) => ({
        url: `/api/manageauditexception/acceptasentered`,
        method: "POST",
        body: queryArg.exceptionManagerActionVm,
      }),
    }),
    acceptAsAudited: build.mutation<
      AcceptAsAuditedApiResponse,
      AcceptAsAuditedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/manageauditexception/acceptasaudited`,
        method: "POST",
        body: queryArg.exceptionManagerActionVm,
      }),
    }),
    acceptAsAdjusted: build.mutation<
      AcceptAsAdjustedApiResponse,
      AcceptAsAdjustedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/manageauditexception/acceptasadjusted`,
        method: "POST",
        body: queryArg.exceptionManagerAcceptAsAdjustedVm,
      }),
    }),
    refuseInvoice: build.mutation<
      RefuseInvoiceApiResponse,
      RefuseInvoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/manageauditexception/refuseinvoice`,
        method: "POST",
        body: queryArg.exceptionManagerActionVm,
      }),
    }),
    exceptionManagerDelete: build.mutation<
      ExceptionManagerDeleteApiResponse,
      ExceptionManagerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/manageauditexception/deleteinvoice`,
        method: "POST",
        body: queryArg.exceptionManagerActionVm,
      }),
    }),
    declineServiceFail: build.mutation<
      DeclineServiceFailApiResponse,
      DeclineServiceFailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/manageauditexception/declineservicefail`,
        method: "POST",
        body: queryArg.exceptionManagerActionVm,
      }),
    }),
    approveServiceFail: build.mutation<
      ApproveServiceFailApiResponse,
      ApproveServiceFailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/manageauditexception/approveservicefail`,
        method: "POST",
        body: queryArg.exceptionManagerActionVm,
      }),
    }),
    massRefSearch: build.mutation<
      MassRefSearchApiResponse,
      MassRefSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/massupdate/search`,
        method: "POST",
        body: queryArg.updateSearchParams,
      }),
    }),
    massRefUpdate: build.mutation<
      MassRefUpdateApiResponse,
      MassRefUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/massupdate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getCentralSaltTickets: build.query<
      GetCentralSaltTicketsApiResponse,
      GetCentralSaltTicketsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/matchpay/centralsalt`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    updateCentralSaltTicket: build.mutation<
      UpdateCentralSaltTicketApiResponse,
      UpdateCentralSaltTicketApiArg
    >({
      query: (queryArg) => ({
        url: `/api/matchpay/centralsalt`,
        method: "PUT",
        body: queryArg.centralSaltMatchVm,
      }),
    }),
    getHarcrosTickets: build.query<
      GetHarcrosTicketsApiResponse,
      GetHarcrosTicketsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/matchpay/harcros`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getAscRefCodes: build.query<
      GetAscRefCodesApiResponse,
      GetAscRefCodesApiArg
    >({
      query: () => ({ url: `/api/metainformation/ascrefcodes` }),
    }),
    getAscChargeCodes: build.query<
      GetAscChargeCodesApiResponse,
      GetAscChargeCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/metainformation/ascchargecodes`,
        params: {
          sorted: queryArg.sorted,
        },
      }),
    }),
    getTransportModes: build.query<
      GetTransportModesApiResponse,
      GetTransportModesApiArg
    >({
      query: () => ({ url: `/api/metainformation/modes` }),
    }),
    getAvailableAuditFailStatuses: build.query<
      GetAvailableAuditFailStatusesApiResponse,
      GetAvailableAuditFailStatusesApiArg
    >({
      query: () => ({ url: `/api/metainformation/status/auditfail` }),
    }),
    getCarrierChargeCodeSources: build.query<
      GetCarrierChargeCodeSourcesApiResponse,
      GetCarrierChargeCodeSourcesApiArg
    >({
      query: () => ({ url: `/api/metainformation/carrierchargecodesource` }),
    }),
    getCustomerDataEntryCodesForUser: build.query<
      GetCustomerDataEntryCodesForUserApiResponse,
      GetCustomerDataEntryCodesForUserApiArg
    >({
      query: () => ({ url: `/api/metainformation/customerdataentrycodes` }),
    }),
    getCustomerDataEntryCodes: build.query<
      GetCustomerDataEntryCodesApiResponse,
      GetCustomerDataEntryCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/metainformation/customerdataentrycodes/${queryArg.billToId}`,
      }),
    }),
    getIa360ReportingLink: build.query<
      GetIa360ReportingLinkApiResponse,
      GetIa360ReportingLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/api/metainformation/ia360reportinglink`,
        params: {
          carrierId: queryArg.carrierId,
          invoiceNum: queryArg.invoiceNum,
        },
      }),
    }),
    getInvoiceStatusCodes: build.query<
      GetInvoiceStatusCodesApiResponse,
      GetInvoiceStatusCodesApiArg
    >({
      query: () => ({ url: `/api/metainformation/invoicestatuscodes` }),
    }),
    getEntryMethods: build.query<
      GetEntryMethodsApiResponse,
      GetEntryMethodsApiArg
    >({
      query: () => ({ url: `/api/metainformation/entrymethods` }),
    }),
    getActivityCodes: build.query<
      GetActivityCodesApiResponse,
      GetActivityCodesApiArg
    >({
      query: () => ({ url: `/api/metainformation/activitycodes` }),
    }),
    getInvoiceTypeList: build.query<
      GetInvoiceTypeListApiResponse,
      GetInvoiceTypeListApiArg
    >({
      query: () => ({ url: `/api/metainformation/invoicetypes` }),
    }),
    getIbobsList: build.query<GetIbobsListApiResponse, GetIbobsListApiArg>({
      query: () => ({ url: `/api/metainformation/ib-obs` }),
    }),
    getReportNameList: build.query<
      GetReportNameListApiResponse,
      GetReportNameListApiArg
    >({
      query: () => ({ url: `/api/metainformation/reportnames` }),
    }),
    getQueueIsActive: build.query<
      GetQueueIsActiveApiResponse,
      GetQueueIsActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/metainformation/queue/${queryArg.queue}`,
      }),
    }),
    getParties: build.query<GetPartiesApiResponse, GetPartiesApiArg>({
      query: (queryArg) => ({
        url: `/api/party/${queryArg.customerId}/${queryArg.partyType}/${queryArg.zipSearch}`,
      }),
    }),
    getUnMadeAchPayments: build.query<
      GetUnMadeAchPaymentsApiResponse,
      GetUnMadeAchPaymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payablebatch/ach`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    generateAcHes: build.mutation<
      GenerateAcHesApiResponse,
      GenerateAcHesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payablebatch/ach`,
        method: "POST",
        body: queryArg.body,
        params: {
          procDate: queryArg.procDate,
        },
      }),
    }),
    getAchDates: build.query<GetAchDatesApiResponse, GetAchDatesApiArg>({
      query: () => ({ url: `/api/payablebatch/achdates` }),
    }),
    getAchFilesForDate: build.query<
      GetAchFilesForDateApiResponse,
      GetAchFilesForDateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payablebatch/files/${queryArg.procDate}`,
      }),
    }),
    getCarrierPayableExceptionsById: build.query<
      GetCarrierPayableExceptionsByIdApiResponse,
      GetCarrierPayableExceptionsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payablesexceptions/${queryArg.carrierId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createCarrierPayException: build.mutation<
      CreateCarrierPayExceptionApiResponse,
      CreateCarrierPayExceptionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payablesexceptions`,
        method: "POST",
        body: queryArg.payablesExceptionsVm,
      }),
    }),
    modifyCarrierPayException: build.mutation<
      ModifyCarrierPayExceptionApiResponse,
      ModifyCarrierPayExceptionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payablesexceptions/${queryArg.exceptionId}`,
        method: "PUT",
        body: queryArg.payablesExceptionsVm,
      }),
    }),
    deleteCarrierPayException: build.mutation<
      DeleteCarrierPayExceptionApiResponse,
      DeleteCarrierPayExceptionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payablesexceptions/${queryArg.exceptionId}`,
        method: "DELETE",
      }),
    }),
    getAllPayDayStarts: build.query<
      GetAllPayDayStartsApiResponse,
      GetAllPayDayStartsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/paydaysstart`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getPermittedValsByCustomer: build.query<
      GetPermittedValsByCustomerApiResponse,
      GetPermittedValsByCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/permittedvalues/${queryArg.customerId}/${queryArg.carrierId}/${queryArg.code}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    getInvoicePermittedValues: build.query<
      GetInvoicePermittedValuesApiResponse,
      GetInvoicePermittedValuesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/permittedvalues/invoice/${queryArg.customerId}/${queryArg.carrierId}`,
      }),
    }),
    createPermittedValue: build.mutation<
      CreatePermittedValueApiResponse,
      CreatePermittedValueApiArg
    >({
      query: (queryArg) => ({
        url: `/api/permittedvalues`,
        method: "POST",
        body: queryArg.permittedValuesVm,
      }),
    }),
    modifyPermittedValue: build.mutation<
      ModifyPermittedValueApiResponse,
      ModifyPermittedValueApiArg
    >({
      query: (queryArg) => ({
        url: `/api/permittedvalues/${queryArg.valId}`,
        method: "PUT",
        body: queryArg.permittedValuesVm,
      }),
    }),
    deletePermittedValue: build.mutation<
      DeletePermittedValueApiResponse,
      DeletePermittedValueApiArg
    >({
      query: (queryArg) => ({
        url: `/api/permittedvalues/${queryArg.valId}`,
        method: "DELETE",
      }),
    }),
    getPostalCodes: build.query<
      GetPostalCodesApiResponse,
      GetPostalCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/postalcode`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createPostalCode: build.mutation<
      CreatePostalCodeApiResponse,
      CreatePostalCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/postalcode`,
        method: "POST",
        body: queryArg.postalCodeVm,
      }),
    }),
    modifyPostalCode: build.mutation<
      ModifyPostalCodeApiResponse,
      ModifyPostalCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/postalcode/${queryArg.codeId}`,
        method: "PUT",
        body: queryArg.postalCodeVm,
      }),
    }),
    deletePostalCode: build.mutation<
      DeletePostalCodeApiResponse,
      DeletePostalCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/postalcode/${queryArg.codeId}`,
        method: "DELETE",
      }),
    }),
    getAllChecks: build.query<GetAllChecksApiResponse, GetAllChecksApiArg>({
      query: (queryArg) => ({ url: `/api/printchecks/${queryArg.acctNum}` }),
    }),
    getChecksForDate: build.query<
      GetChecksForDateApiResponse,
      GetChecksForDateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/printchecks/${queryArg.acctNum}/${queryArg.searchDate}`,
      }),
    }),
    getReprintChecksForDate: build.query<
      GetReprintChecksForDateApiResponse,
      GetReprintChecksForDateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/printchecks/reprint/${queryArg.acctNum}/${queryArg.payDate}`,
      }),
    }),
    makeNewBatches: build.mutation<
      MakeNewBatchesApiResponse,
      MakeNewBatchesApiArg
    >({
      query: () => ({ url: `/api/printchecks/makebatches`, method: "POST" }),
    }),
    printChecks: build.mutation<PrintChecksApiResponse, PrintChecksApiArg>({
      query: (queryArg) => ({
        url: `/api/printchecks/print`,
        method: "POST",
        body: queryArg.printCheckRequestVm,
      }),
    }),
    reprintChecks: build.mutation<
      ReprintChecksApiResponse,
      ReprintChecksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/printchecks/reprint`,
        method: "POST",
        body: queryArg.reprintCheckRequestVm,
      }),
    }),
    getCheckDates: build.query<GetCheckDatesApiResponse, GetCheckDatesApiArg>({
      query: () => ({ url: `/api/printchecks/checkdates` }),
    }),
    getPrintedChecksForDate: build.query<
      GetPrintedChecksForDateApiResponse,
      GetPrintedChecksForDateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/printchecks/checks/${queryArg.checkDate}`,
      }),
    }),
    getReceipts: build.query<GetReceiptsApiResponse, GetReceiptsApiArg>({
      query: (queryArg) => ({
        url: `/api/receipts/${queryArg.customerId}/${queryArg.startDate}/${queryArg.endDate}`,
      }),
    }),
    mergeReceipts: build.mutation<
      MergeReceiptsApiResponse,
      MergeReceiptsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/receipts/merge`,
        method: "POST",
        body: queryArg.body,
        headers: {
          'X-Idempotency-Key': queryArg.transactionId,
        },
      }),
    }),
    getApprovedInvoices: build.query<
      GetApprovedInvoicesApiResponse,
      GetApprovedInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/receivefunds/${queryArg.customerId}`,
      }),
    }),
    getUnappliedCash: build.query<
      GetUnappliedCashApiResponse,
      GetUnappliedCashApiArg
    >({
      query: (queryArg) => ({
        url: `/api/receivefunds/unapplied/${queryArg.customerId}`,
      }),
    }),
    receiveFunds: build.mutation<ReceiveFundsApiResponse, ReceiveFundsApiArg>({
      query: (queryArg) => ({
        url: `/api/receivefunds`,
        method: "POST",
        body: queryArg.receiveFundsVm,
      }),
    }),
    useUnappliedCash: build.mutation<
      UseUnappliedCashApiResponse,
      UseUnappliedCashApiArg
    >({
      query: (queryArg) => ({
        url: `/api/receivefunds/receiveunapplied`,
        method: "POST",
        body: queryArg.useUnappliedCashVm,
        headers: {
          'X-Idempotency-Key': queryArg.transactionId,
        },
      }),
    }),
    depositFunds: build.mutation<DepositFundsApiResponse, DepositFundsApiArg>({
      query: (queryArg) => ({
        url: `/api/receivefunds/deposit`,
        method: "POST",
        body: queryArg.depositFundsVm,
      }),
    }),
    createCredit: build.mutation<CreateCreditApiResponse, CreateCreditApiArg>({
      query: (queryArg) => ({
        url: `/api/receivefunds/credit`,
        method: "POST",
        body: queryArg.receiveCreditVm,
      }),
    }),
    getApiReporting: build.query<
      GetApiReportingApiResponse,
      GetApiReportingApiArg
    >({
      query: () => ({ url: `/api/reporting` }),
    }),
    getBookmarksForUser: build.query<
      GetBookmarksForUserApiResponse,
      GetBookmarksForUserApiArg
    >({
      query: () => ({ url: `/api/reporting/bookmark` }),
    }),
    createBookmark: build.mutation<
      CreateBookmarkApiResponse,
      CreateBookmarkApiArg
    >({
      query: (queryArg) => ({
        url: `/api/reporting/bookmark`,
        method: "POST",
        body: queryArg.createReportBookmarkVm,
      }),
    }),
    deleteBookmark: build.mutation<
      DeleteBookmarkApiResponse,
      DeleteBookmarkApiArg
    >({
      query: (queryArg) => ({
        url: `/api/reporting/bookmark/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getStates: build.query<GetStatesApiResponse, GetStatesApiArg>({
      query: (queryArg) => ({
        url: `/api/states`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createStates: build.mutation<CreateStatesApiResponse, CreateStatesApiArg>({
      query: (queryArg) => ({
        url: `/api/states`,
        method: "POST",
        body: queryArg.statesVm,
      }),
    }),
    modifyStates: build.mutation<ModifyStatesApiResponse, ModifyStatesApiArg>({
      query: (queryArg) => ({
        url: `/api/states/${queryArg.stateId}`,
        method: "PUT",
        body: queryArg.statesVm,
      }),
    }),
    deleteStates: build.mutation<DeleteStatesApiResponse, DeleteStatesApiArg>({
      query: (queryArg) => ({
        url: `/api/states/${queryArg.stateId}`,
        method: "DELETE",
      }),
    }),
    getConfig: build.query<GetConfigApiResponse, GetConfigApiArg>({
      query: () => ({ url: `/config` }),
    }),
    getAppconfig: build.query<GetAppconfigApiResponse, GetAppconfigApiArg>({
      query: () => ({ url: `/appconfig` }),
    }),
    getTimecardForUserId: build.query<
      GetTimecardForUserIdApiResponse,
      GetTimecardForUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/timecard`,
        params: {
          userId: queryArg.userId,
          date: queryArg.date,
        },
      }),
    }),
    addTimeCard: build.mutation<AddTimeCardApiResponse, AddTimeCardApiArg>({
      query: (queryArg) => ({
        url: `/api/timecard`,
        method: "POST",
        body: queryArg.userTimeCardVm,
      }),
    }),
    deleteTimeCard: build.mutation<
      DeleteTimeCardApiResponse,
      DeleteTimeCardApiArg
    >({
      query: (queryArg) => ({ url: `/${queryArg.id}`, method: "DELETE" }),
    }),
    getUserBillToInfoByCustomer: build.query<
      GetUserBillToInfoByCustomerApiResponse,
      GetUserBillToInfoByCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/userbillto/${queryArg.customerId}`,
        params: {
          $top: queryArg.$top,
          $skip: queryArg.$skip,
          $filter: queryArg.$filter,
          $orderby: queryArg.$orderby,
          $expand: queryArg.$expand,
          $count: queryArg.$count,
        },
      }),
    }),
    createUserBillToInfo: build.mutation<
      CreateUserBillToInfoApiResponse,
      CreateUserBillToInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/userbillto`,
        method: "POST",
        body: queryArg.userBillToVm,
      }),
    }),
    deleteUserBillToInfo: build.mutation<
      DeleteUserBillToInfoApiResponse,
      DeleteUserBillToInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/userbillto/${queryArg.customerId}/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    getMyConfig: build.query<GetMyConfigApiResponse, GetMyConfigApiArg>({
      query: () => ({ url: `/api/userconfig` }),
    }),
    saveMyConfig: build.mutation<SaveMyConfigApiResponse, SaveMyConfigApiArg>({
      query: (queryArg) => ({
        url: `/api/userconfig`,
        method: "PUT",
        body: queryArg.userConfigurationVm,
      }),
    }),
    getUserConfiguration: build.query<
      GetUserConfigurationApiResponse,
      GetUserConfigurationApiArg
    >({
      query: (queryArg) => ({ url: `/api/userconfig/${queryArg.userId}` }),
    }),
    saveUserConfig: build.mutation<
      SaveUserConfigApiResponse,
      SaveUserConfigApiArg
    >({
      query: (queryArg) => ({
        url: `/api/userconfig/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.userConfigurationVm,
      }),
    }),
    getRoleAuths: build.query<GetRoleAuthsApiResponse, GetRoleAuthsApiArg>({
      query: (queryArg) => ({ url: `/api/userrole/${queryArg.role}` }),
    }),
    createNewRole: build.mutation<
      CreateNewRoleApiResponse,
      CreateNewRoleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/userrole`,
        method: "POST",
        body: queryArg.userRoleDefinitionVm,
      }),
    }),
    updateRole: build.mutation<UpdateRoleApiResponse, UpdateRoleApiArg>({
      query: (queryArg) => ({
        url: `/api/userrole`,
        method: "PUT",
        body: queryArg.functionalAuthVm,
      }),
    }),
    copyRole: build.mutation<CopyRoleApiResponse, CopyRoleApiArg>({
      query: (queryArg) => ({
        url: `/api/userrole/copy`,
        method: "POST",
        body: queryArg.userRoleDefinitionVm,
        params: {
          copyRole: queryArg.copyRole,
        },
      }),
    }),
    getAllUsers: build.query<GetAllUsersApiResponse, GetAllUsersApiArg>({
      query: () => ({ url: `/api/users` }),
    }),
    updateUser: build.mutation<UpdateUserApiResponse, UpdateUserApiArg>({
      query: (queryArg) => ({
        url: `/api/users`,
        method: "PUT",
        body: queryArg.userAdminVm,
      }),
    }),
    getFullUserList: build.query<
      GetFullUserListApiResponse,
      GetFullUserListApiArg
    >({
      query: () => ({ url: `/api/users/admin` }),
    }),
    getUserAdminInfo: build.query<
      GetUserAdminInfoApiResponse,
      GetUserAdminInfoApiArg
    >({
      query: (queryArg) => ({ url: `/api/users/admin/${queryArg.userId}` }),
    }),
    getKnownCompanies: build.query<
      GetKnownCompaniesApiResponse,
      GetKnownCompaniesApiArg
    >({
      query: () => ({ url: `/api/users/companies` }),
    }),
    addUser: build.mutation<AddUserApiResponse, AddUserApiArg>({
      query: (queryArg) => ({
        url: `/api/users/${queryArg.userId}`,
        method: "POST",
      }),
    }),
    changePassword: build.mutation<
      ChangePasswordApiResponse,
      ChangePasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/password`,
        method: "POST",
        body: queryArg.userAdminPasswordVm,
      }),
    }),
    suspendUser: build.mutation<SuspendUserApiResponse, SuspendUserApiArg>({
      query: (queryArg) => ({
        url: `/api/users/suspend`,
        method: "POST",
        body: queryArg.userAdminSuspendVm,
      }),
    }),
    getTimeCardUsers: build.query<
      GetTimeCardUsersApiResponse,
      GetTimeCardUsersApiArg
    >({
      query: () => ({ url: `/api/users/timecardusers` }),
    }),
    getUserSessionsForUser: build.query<
      GetUserSessionsForUserApiResponse,
      GetUserSessionsForUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/sessions/${queryArg.userId}`,
        params: {
          lastWorkDay: queryArg.lastWorkDay,
        },
      }),
    }),
    getMyUserSessions: build.query<
      GetMyUserSessionsApiResponse,
      GetMyUserSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/sessions`,
        params: {
          lastWorkDay: queryArg.lastWorkDay,
        },
      }),
    }),
    getCarrInvStatsForUser: build.query<
      GetCarrInvStatsForUserApiResponse,
      GetCarrInvStatsForUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/carrinvstats/${queryArg.userId}`,
        params: {
          lastWorkDay: queryArg.lastWorkDay,
        },
      }),
    }),
    getMyCarrInvStats: build.query<
      GetMyCarrInvStatsApiResponse,
      GetMyCarrInvStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/carrinvstats`,
        params: {
          lastWorkDay: queryArg.lastWorkDay,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as paylogikApi };
export type RequeueJobApiResponse = unknown;
export type RequeueJobApiArg = {
  queuedDataKey?: string;
  process?: string;
};
export type GetAppDefaultsApiResponse = /** status 200 OK */ AppDefaultVm[];
export type GetAppDefaultsApiArg = void;
export type GetAppDefaultsQueryApiResponse =
  /** status 200 OK */ AppDefaultVm[];
export type GetAppDefaultsQueryApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type PutAppDefaultsApiResponse = unknown;
export type PutAppDefaultsApiArg = {
  /** ID of the AppDefault to update */
  parmId: string;
  /** AppDefaultVm object of the new AppDefault settings */
  appDefaultVm: AppDefaultVm;
};
export type PutSecureDefaultsApiResponse = unknown;
export type PutSecureDefaultsApiArg = {
  /** ID of the SecureDefault to update */
  parmId: string;
  /** SecureDefaultVm object of the new SecureDefault settings */
  secureDefaultVm: SecureDefaultVm;
};
export type GetSecureDefaultsQueryApiResponse =
  /** status 200 OK */ SecureDefaultVm[];
export type GetSecureDefaultsQueryApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetWebDefaultsApiResponse = /** status 200 OK */ AppDefaultVm[];
export type GetWebDefaultsApiArg = void;
export type GetInvoicesApprovalPopulationDataApiResponse =
  /** status 200 OK */ InvoiceApprovalOptionsVmRead;
export type GetInvoicesApprovalPopulationDataApiArg = void;
export type GetInvoicesNeedingApprovalApiResponse =
  /** status 200 OK */ ApproveInvoicesSearchResponseRead;
export type GetInvoicesNeedingApprovalApiArg = {
  invoiceApprovalOptionsVm: InvoiceApprovalOptionsVm;
};
export type GetMinimalInvoiceDetailApiResponse =
  /** status 200 OK */ InvoiceSummaryVm;
export type GetMinimalInvoiceDetailApiArg = {
  id: number;
};
export type ApproveInvoicesApiResponse =
  /** status 200 OK */ ApproveInvoicesSearchResponseRead;
export type ApproveInvoicesApiArg = {
  approveInvoicesRequestVm: ApproveInvoicesRequestVm;
};
export type SaveCurrentInvoiceStateApiResponse =
  /** status 200 OK */ ApproveInvoicesSearchResponseRead;
export type SaveCurrentInvoiceStateApiArg = {
  approveInvoicesRequestVm: ApproveInvoicesRequestVm;
};
export type PostApiApproveinvoicesFrominvoiceidxsApiResponse = unknown;
export type PostApiApproveinvoicesFrominvoiceidxsApiArg = {
  body: number[];
};
export type GetAllAscChargeCodesApiResponse =
  /** status 200 OK */ AscChargeCodeVm[];
export type GetAllAscChargeCodesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateAscChargeCodesApiResponse =
  /** status 200 OK */ AscChargeCodeVm;
export type CreateAscChargeCodesApiArg = {
  /** AscChargeCodeVm object for the charge code to add */
  ascChargeCodeVm: AscChargeCodeVm;
};
export type ModifyAscChargeCodesApiResponse =
  /** status 200 OK */ AscChargeCodeVm;
export type ModifyAscChargeCodesApiArg = {
  /** ID of the charge code to update */
  codeId: string;
  /** AscChargeCodeVm object for the code to update */
  ascChargeCodeVm: AscChargeCodeVm;
};
export type DeleteAscChargeCodesApiResponse = unknown;
export type DeleteAscChargeCodesApiArg = {
  /** ID of the charge code to remove */
  codeId: string;
};
export type GetInvoiceChargeTypesApiResponse =
  /** status 200 OK */ InvoiceChargeTypeVm[];
export type GetInvoiceChargeTypesApiArg = void;
export type GetAllAscRefCodesApiResponse =
  /** status 200 OK */ AscReferenceCodeVm[];
export type GetAllAscRefCodesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateAscRefCodesApiResponse =
  /** status 200 OK */ AscReferenceCodeVm;
export type CreateAscRefCodesApiArg = {
  /** AscReferenceCodeVm object for the ref code to add */
  ascReferenceCodeVm: AscReferenceCodeVm;
};
export type ModifyAscRefCodesApiResponse =
  /** status 200 OK */ AscReferenceCodeVm;
export type ModifyAscRefCodesApiArg = {
  /** ID of the ref code to update */
  codeId: string;
  /** AscReferenceCodeVm object for the state to update */
  ascReferenceCodeVm: AscReferenceCodeVm;
};
export type DeleteAscRefCodesApiResponse = unknown;
export type DeleteAscRefCodesApiArg = {
  /** ID of the ref code to remove */
  codeId: string;
};
export type GetGenMilesApiResponse = /** status 200 OK */ number;
export type GetGenMilesApiArg = {
  auditMilesRequestVm: AuditMilesRequestVm;
};
export type LoginApiResponse = /** status 200 OK */ string;
export type LoginApiArg = {
  loginVm: LoginVm;
};
export type RefreshTokenApiResponse = /** status 200 OK */ string;
export type RefreshTokenApiArg = void;
export type LoginWithPermissionsApiResponse =
  /** status 200 OK */ LoginResponseVmRead;
export type LoginWithPermissionsApiArg = {
  loginVm: LoginVm;
};
export type RefreshWithPermissionsApiResponse =
  /** status 200 OK */ LoginResponseVmRead;
export type RefreshWithPermissionsApiArg = void;
export type LogOutApiResponse = unknown;
export type LogOutApiArg = void;
export type GetMyUserApiResponse = /** status 200 OK */ UserVmRead;
export type GetMyUserApiArg = void;
export type GetAllBankAccountsApiResponse =
  /** status 200 OK */ BankAccountVmRead[];
export type GetAllBankAccountsApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type UpdateBankAccountApiResponse = unknown;
export type UpdateBankAccountApiArg = {
  /** BankAccountChangeVm object for the updated Bank Account */
  bankAccountChangeVm: BankAccountChangeVm;
};
export type GetBillToByIdApiResponse = /** status 200 OK */ BillToVm;
export type GetBillToByIdApiArg = {
  id: string;
};
export type GetDataEntryAscRefCodesApiResponse =
  /** status 200 OK */ CustomerDataEntryVm[];
export type GetDataEntryAscRefCodesApiArg = {
  id: string;
  carrierId: string;
};
export type GetAllBillToApiResponse =
  /** status 200 OK */ BillToMinimalVmRead[];
export type GetAllBillToApiArg = void;
export type GetBillToForDisplayApiResponse =
  /** status 200 OK */ BillToMinimalVmRead[];
export type GetBillToForDisplayApiArg = void;
export type GetUserCustomersApiResponse =
  /** status 200 OK */ BillToMinimalVmRead[];
export type GetUserCustomersApiArg = void;
export type GetCentralSaltBillTosApiResponse =
  /** status 200 OK */ BillToMatchTableVm[];
export type GetCentralSaltBillTosApiArg = void;
export type GetAllBillTosForDisplayApiResponse =
  /** status 200 OK */ BillToMinimalVmRead[];
export type GetAllBillTosForDisplayApiArg = void;
export type GetActiveBillTosForDisplayApiResponse =
  /** status 200 OK */ BillToMinimalVmRead[];
export type GetActiveBillTosForDisplayApiArg = void;
export type GetCustomerByIdApiResponse = /** status 200 OK */ BillToVm;
export type GetCustomerByIdApiArg = {
  /** ID of the customer to load info on */
  customerId: string;
};
export type ModifyCustomersApiResponse = /** status 200 OK */ BillToVm;
export type ModifyCustomersApiArg = {
  /** ID of the customer to update */
  customerId: string;
  /** BillToVm object for the customer to update */
  billToVm: BillToVm;
};
export type DeleteCustomersApiResponse = unknown;
export type DeleteCustomersApiArg = {
  /** ID of the customer to remove */
  customerId: string;
};
export type GetAllCustomersApiResponse = /** status 200 OK */ BillToVm[];
export type GetAllCustomersApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCustomersApiResponse = /** status 200 OK */ BillToVm;
export type CreateCustomersApiArg = {
  /** BillToVm object for the customer to add */
  billToVm: BillToVm;
};
export type GetParentCustomersApiResponse = /** status 200 OK */ BillToVm[];
export type GetParentCustomersApiArg = void;
export type ActivateCustomersApiResponse = /** status 200 OK */ BillToVm;
export type ActivateCustomersApiArg = {
  /** ID of the customer to update */
  customerId: string;
  /** BillToActiveVm object for the customer to update */
  billToActiveVm: BillToActiveVm;
};
export type GetFeeInvoiceDataApiResponse =
  /** status 200 OK */ BillToFeeInvoiceVm;
export type GetFeeInvoiceDataApiArg = {
  /** ID of the customer to find fee invoice setup for */
  customerId: string;
};
export type SetFeeInvoiceDataApiResponse =
  /** status 200 OK */ BillToFeeInvoiceVm;
export type SetFeeInvoiceDataApiArg = {
  /** BillToFeeInvoiceVm object for the fee invoice setup */
  billToFeeInvoiceVm: BillToFeeInvoiceVm;
};
export type GetModeDefaultsByCustomerApiResponse =
  /** status 200 OK */ BillToModeDefaultVm[];
export type GetModeDefaultsByCustomerApiArg = {
  /** ID of the customer to load mode default info for */
  customerId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateBillToModeDefaultApiResponse =
  /** status 200 OK */ BillToModeDefaultVm;
export type CreateBillToModeDefaultApiArg = {
  /** BillToModeDefaultVm object for the default mode to add */
  billToModeDefaultVm: BillToModeDefaultVm;
};
export type ModifyBillToModeDefaultApiResponse =
  /** status 200 OK */ BillToModeDefaultVm;
export type ModifyBillToModeDefaultApiArg = {
  /** GUID of the customer mode default to update */
  defaultId: string;
  /** BillToModeDefaultVm object for the default to update */
  billToModeDefaultVm: BillToModeDefaultVm;
};
export type DeleteBillToModeDefaultApiResponse = unknown;
export type DeleteBillToModeDefaultApiArg = {
  /** ID of the default to remove */
  defaultId: string;
};
export type GetGlRulesApiResponse = /** status 200 OK */ BtAccountRulesVm[];
export type GetGlRulesApiArg = {
  /** The ID of the customer to check for rules */
  customerId: string;
};
export type GetGlCodingPreviewApiResponse =
  /** status 200 OK */ BtCodingGridVm[];
export type GetGlCodingPreviewApiArg = {
  /** The ID of the customer to check for uncoded invoices */
  customerId: string;
  /** Oldest creation date to include invoices from */
  createDate: string;
};
export type GetGlOverwritePreviewApiResponse =
  /** status 200 OK */ BtCodingGridVm[];
export type GetGlOverwritePreviewApiArg = {
  /** The ID of the customer to check for invoices */
  customerId: string;
  /** Start of the date range to find invoices */
  fromDate: string;
  /** End of the date range to find invoices */
  toDate: string;
};
export type SaveGlRulesApiResponse = unknown;
export type SaveGlRulesApiArg = {
  /** A list of BtAccountRulesVm objects for the updated rules */
  body: BtAccountRulesVm[];
};
export type GlCodingBatchApiResponse = /** status 200 OK */ BtCodingGridVm[];
export type GlCodingBatchApiArg = {
  /** A list of invoice IDs (and maybe Line IDs) to run rules against */
  body: BtCodingRequestVm[];
};
export type GlCodingQueueApiResponse = unknown;
export type GlCodingQueueApiArg = {
  /** A BtCodingQueueVm object for the customer and date (range) to search for invoices to GL Code */
  btCodingQueueVm: BtCodingQueueVm;
};
export type GetBillToMapsByCarrierApiResponse =
  /** status 200 OK */ CarrBtMapVm[];
export type GetBillToMapsByCarrierApiArg = {
  /** ID of the carrier to load bill-to maps for */
  carrierId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCarrierBtMapApiResponse = /** status 200 OK */ CarrBtMapVm;
export type CreateCarrierBtMapApiArg = {
  /** CarrBtMapVm object for the mapping to add */
  carrBtMapVm: CarrBtMapVm;
};
export type DeleteCarrierBtMapApiResponse = unknown;
export type DeleteCarrierBtMapApiArg = {
  /** Carrier whose mapping to delete */
  carrId: string;
  /** Carrier account for mapping to delete */
  carrAcct: string;
  /** Bill-To ID for mapping to delete */
  btId: string;
};
export type GetVoidableChecksApiResponse = /** status 200 OK */ CheckInfoVm[];
export type GetVoidableChecksApiArg = {
  /** Parameters to direct the search */
  checkInfoSearchVm: CheckInfoSearchVm;
};
export type VoidChecksApiResponse = unknown;
export type VoidChecksApiArg = {
  /** Reason given to void these checks */
  reason?: string;
  /** List of check numbers to void */
  body: number[];
};
export type GetAllRemitsApiResponse =
  /** status 200 OK */ CarrierCheckRemitViewModel[];
export type GetAllRemitsApiArg = void;
export type MakeRemitsApiResponse =
  /** status 200 OK */ ProcessCheckProcessedArgs[];
export type MakeRemitsApiArg = {
  /** List of CarrierCheckRemitViewModel objects for checks to make remits for */
  body: CarrierCheckRemitViewModel[];
};
export type GetRemitsForChecksApiResponse =
  /** status 200 OK */ CarrierCheckRemitViewModel[];
export type GetRemitsForChecksApiArg = {
  /** Comma-delimited list of check numbers to find remit info for */
  checkNums: string;
};
export type GetRemitKeysApiResponse = /** status 200 OK */ string[];
export type GetRemitKeysApiArg = void;
export type GetRemitsForKeyApiResponse = /** status 200 OK */ CheckS3FileInfo[];
export type GetRemitsForKeyApiArg = {
  /** The S3 key to find remits for */
  remitKey: string;
};
export type GetCarrierEdiMasterByIdApiResponse =
  /** status 200 OK */ CarrEdiMasterVm[];
export type GetCarrierEdiMasterByIdApiArg = {
  /** ID of the carrier to load EDI info for */
  carrierId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCarrierEdiMasterApiResponse =
  /** status 200 OK */ CarrEdiMasterVm;
export type CreateCarrierEdiMasterApiArg = {
  /** CarrEdiMasterVm object for the EDI info to add */
  carrEdiMasterVm: CarrEdiMasterVm;
};
export type ModifyCarrierEdiMasterApiResponse =
  /** status 200 OK */ CarrEdiMasterVm;
export type ModifyCarrierEdiMasterApiArg = {
  /** Sender Qualifier for the EDI mapping to update */
  senderQual: string;
  /** Sender ID for the EDI mapping to update */
  senderId: string;
  /** Type of the EDI mapping to update */
  ediType: string;
  /** Receiver Qualifier for the EDI mapping to update */
  rcvQual: string;
  /** Receiver ID for the EDI mapping to update */
  rcvId: string;
  /** CarrEdiMasterVm object for the EDI Master Info to update */
  carrEdiMasterVm: CarrEdiMasterVm;
};
export type DeleteCarrierEdiMasterApiResponse = unknown;
export type DeleteCarrierEdiMasterApiArg = {
  /** Sender Qualifier for the EDI mapping to delete */
  senderQual: string;
  /** Sender ID for the EDI mapping to delete */
  senderId: string;
  /** Type of the EDI mapping to delete */
  ediType: string;
  /** Receiver Qualifier for the EDI mapping to delete */
  rcvQual: string;
  /** Receiver ID for the EDI mapping to delete */
  rcvId: string;
};
export type GetAllCarrierFamiliesApiResponse = /** status 200 OK */ CarrFamVm[];
export type GetAllCarrierFamiliesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetCarrierFamilyTreeApiResponse =
  /** status 200 OK */ CarrFamTreeNodeVm[];
export type GetCarrierFamilyTreeApiArg = void;
export type GetCarrierFamilyByIdApiResponse = /** status 200 OK */ CarrFamVm;
export type GetCarrierFamilyByIdApiArg = {
  /** The family ID to retrieve */
  familyId: string;
};
export type GetFamilyMembersApiResponse =
  /** status 200 OK */ CarrierFamilyMemberVm[];
export type GetFamilyMembersApiArg = {
  /** The family ID */
  familyId: string;
};
export type CreateCarrierFamilyApiResponse =
  /** status 201 Created */ CarrFamVm;
export type CreateCarrierFamilyApiArg = {
  /** Family creation request */
  createCarrFamRequest: CreateCarrFamRequest;
};
export type UpdateCarrierFamilyApiResponse = /** status 200 OK */ CarrFamVm;
export type UpdateCarrierFamilyApiArg = {
  /** The family ID to update */
  familyId: string;
  /** Family update request */
  updateCarrFamRequest: UpdateCarrFamRequest;
};
export type DeleteCarrierFamilyApiResponse = unknown;
export type DeleteCarrierFamilyApiArg = {
  /** The family ID to delete */
  familyId: string;
};
export type AssignCarrierToFamilyApiResponse =
  /** status 201 Created */ boolean;
export type AssignCarrierToFamilyApiArg = {
  /** The family ID */
  familyId: string;
  /** Carrier assignment request */
  assignCarrierToFamilyRequest: AssignCarrierToFamilyRequest;
};
export type RemoveCarrierFromFamilyApiResponse = unknown;
export type RemoveCarrierFromFamilyApiArg = {
  /** The family ID */
  familyId: string;
  /** The carrier ID */
  carrierId: string;
};
export type CheckFamilyNameExistsApiResponse = /** status 200 OK */ boolean;
export type CheckFamilyNameExistsApiArg = {
  /** The family name to check */
  familyName?: string;
  /** Optional family ID to exclude from check */
  excludeFamilyId?: string;
};
export type GetCarriersForDropdownApiResponse =
  /** status 200 OK */ CarrierMinimalVm[];
export type GetCarriersForDropdownApiArg = void;
export type GetActiveCarriersForDropdownApiResponse =
  /** status 200 OK */ CarrierMinimalVm[];
export type GetActiveCarriersForDropdownApiArg = void;
export type GetPermissionedCarriersForDropdownApiResponse =
  /** status 200 OK */ CarrierMinimalVm[];
export type GetPermissionedCarriersForDropdownApiArg = void;
export type GetByScacApiResponse = /** status 200 OK */ CarrierMinimalVm;
export type GetByScacApiArg = {
  scac: string;
};
export type GetCarrierChargeCodeMappingApiResponse =
  /** status 200 OK */ CarrierChargeCodeMappingVmRead[];
export type GetCarrierChargeCodeMappingApiArg = {
  options?: CarrierChargeCodeMappingVmODataQueryOptions;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetCarrierChargeCodeMappingByIdApiResponse =
  /** status 200 OK */ CarrierChargeCodeMappingVmRead[];
export type GetCarrierChargeCodeMappingByIdApiArg = {
  id: string;
};
export type AddNewCarrierChargeCodeMappingApiResponse =
  /** status 200 OK */ CarrierChargeCodeMappingVmRead[];
export type AddNewCarrierChargeCodeMappingApiArg = {
  id: string;
  carrierChargeCodeMappingVm: CarrierChargeCodeMappingVm;
};
export type UpdateCarrierChargeCodeMappingApiResponse =
  /** status 200 OK */ CarrierChargeCodeMappingVmRead[];
export type UpdateCarrierChargeCodeMappingApiArg = {
  id: string;
  carrierChargeCodeMappingVm: CarrierChargeCodeMappingVm;
};
export type DeletCarrierChargeCodeMappingApiResponse =
  /** status 200 OK */ CarrierChargeCodeMappingVmRead[];
export type DeletCarrierChargeCodeMappingApiArg = {
  id: string;
  carrierChargeCodeMappingVm: CarrierChargeCodeMappingVm;
};
export type GetCarrierChargeCodeMappingOverridesApiResponse =
  /** status 200 OK */ CarrierChargeCodesCustomerModeOverrideVmRead[];
export type GetCarrierChargeCodeMappingOverridesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetCarrierChargeCodeMappingOverrideByCarrierIdApiResponse =
  /** status 200 OK */ CarrierChargeCodesCustomerModeOverrideVmRead[];
export type GetCarrierChargeCodeMappingOverrideByCarrierIdApiArg = {
  id: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type AddNewCarrierChargeCodeMappingOverrideApiResponse =
  /** status 200 OK */ CarrierChargeCodesCustomerModeOverrideVmRead[];
export type AddNewCarrierChargeCodeMappingOverrideApiArg = {
  id: string;
  billto: string;
  carrierChargeCodesCustomerModeOverrideVm: CarrierChargeCodesCustomerModeOverrideVm;
};
export type UpdateCarrierChargeCodeMappingOverrideApiResponse =
  /** status 200 OK */ CarrierChargeCodesCustomerModeOverrideVmRead;
export type UpdateCarrierChargeCodeMappingOverrideApiArg = {
  id: string;
  billto: string;
  carrierChargeCodesCustomerModeOverrideVm: CarrierChargeCodesCustomerModeOverrideVm;
};
export type DeleteCarrierChargeCodeMappingOverrideApiResponse =
  /** status 200 OK */ CarrierChargeCodesCustomerModeOverrideVmRead[];
export type DeleteCarrierChargeCodeMappingOverrideApiArg = {
  id: string;
  billto: string;
  carrierChargeCodesCustomerModeOverrideVm: CarrierChargeCodesCustomerModeOverrideVm;
};
export type GetCarrierByIdApiResponse = /** status 200 OK */ CarrierVm;
export type GetCarrierByIdApiArg = {
  /** ID of the carrier to load info on */
  carrierId: string;
};
export type GetAllCarriersApiResponse = /** status 200 OK */ CarrierVm[];
export type GetAllCarriersApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCarriersApiResponse = /** status 200 OK */ CarrierVm;
export type CreateCarriersApiArg = {
  /** CarrierVm object for the carrier to add */
  carrierVm: CarrierVm;
};
export type ModifyCarriersApiResponse = /** status 200 OK */ CarrierVm;
export type ModifyCarriersApiArg = {
  /** ID of the carrier to update */
  carrierId: string;
  /** CarrierVm object for the carrier to update */
  carrierVm: CarrierVm;
};
export type DeleteCarriersApiResponse = unknown;
export type DeleteCarriersApiArg = {
  /** ID of the carrier to remove */
  carrierId: string;
};
export type ActivateCarriersApiResponse = /** status 200 OK */ CarrierVm;
export type ActivateCarriersApiArg = {
  /** ID of the carrier to remove */
  carrierId: string;
  /** CarrierActiveVm object for the carrier to update */
  carrierActiveVm: CarrierActiveVm;
};
export type GetModeOverridesApiResponse =
  /** status 200 OK */ BillToCarrierModeOverrideVm[];
export type GetModeOverridesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetSpecificModeOverrideApiResponse =
  /** status 200 OK */ BillToCarrierModeOverrideVm[];
export type GetSpecificModeOverrideApiArg = {
  btid: string;
  carrierId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type DeleteModeOverrideApiResponse = unknown;
export type DeleteModeOverrideApiArg = {
  btid: string;
  /** ID of the carrier to remove */
  carrierId: string;
};
export type UpdateModeOverrideApiResponse =
  /** status 200 OK */ BillToCarrierModeOverrideVm;
export type UpdateModeOverrideApiArg = {
  billToCarrierModeOverrideVm: BillToCarrierModeOverrideVm;
};
export type AddModeOverrideApiResponse =
  /** status 200 OK */ BillToCarrierModeOverrideVm;
export type AddModeOverrideApiArg = {
  billToCarrierModeOverrideVm: BillToCarrierModeOverrideVm;
};
export type GetAllCarrierContactsApiResponse =
  /** status 200 OK */ CarrierContactVm[];
export type GetAllCarrierContactsApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCarrierContactsApiResponse =
  /** status 200 OK */ CarrierContactVm;
export type CreateCarrierContactsApiArg = {
  /** CarrierContactVm object for the carrier to add */
  carrierContactVm: CarrierContactVm;
};
export type GetCarrierContactByIdApiResponse =
  /** status 200 OK */ CarrierContactVm[];
export type GetCarrierContactByIdApiArg = {
  /** ID of the carrier to load contacts for */
  carrierId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type ModifyCarrierContactsApiResponse =
  /** status 200 OK */ CarrierContactVm;
export type ModifyCarrierContactsApiArg = {
  /** ID of the carrier contact to update */
  contactId: number;
  /** CarrierContactVm object for the contact to update */
  carrierContactVm: CarrierContactVm;
};
export type DeleteCarrierContactsApiResponse = unknown;
export type DeleteCarrierContactsApiArg = {
  /** ID of the carrier contact to remove */
  contactId: number;
};
export type GetCarrierModeMapsByIdApiResponse =
  /** status 200 OK */ CarrierModeMapVm[];
export type GetCarrierModeMapsByIdApiArg = {
  /** ID of the carrier to load mode mappings for */
  carrierId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCarrierModeMapsApiResponse =
  /** status 200 OK */ CarrierModeMapVm;
export type CreateCarrierModeMapsApiArg = {
  /** CarrierModeMapVm object for the mapping to add */
  carrierModeMapVm: CarrierModeMapVm;
};
export type ModifyCarrierModeMapsApiResponse =
  /** status 200 OK */ CarrierModeMapVm;
export type ModifyCarrierModeMapsApiArg = {
  /** ID of the carrier mode mapping to update */
  mapId: number;
  /** CarrierModeMapVm object for the mapping to update */
  carrierModeMapVm: CarrierModeMapVm;
};
export type DeleteCarrierModeMapsApiResponse = unknown;
export type DeleteCarrierModeMapsApiArg = {
  /** ID of the carrier mode map to remove */
  mapId: number;
};
export type GetPayMethodsForCarrierApiResponse =
  /** status 200 OK */ CarrierPaymentRemitVm[];
export type GetPayMethodsForCarrierApiArg = {
  /** ID of the carrier to pull payment info for */
  carrierId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCarrierPayRemitApiResponse =
  /** status 200 OK */ CarrierPaymentRemitVm;
export type CreateCarrierPayRemitApiArg = {
  /** CarrierPaymentRemitVm object for the payment/remit info to add */
  carrierPaymentRemitVm: CarrierPaymentRemitVm;
};
export type ModifyCarrierPayRemitApiResponse =
  /** status 200 OK */ CarrierPaymentRemitVm;
export type ModifyCarrierPayRemitApiArg = {
  /** ID of the payment/remit info entry to update */
  remitInfoId: number;
  /** CarrierPaymentRemitVm object for the Payment/Remit Info to update */
  carrierPaymentRemitVm: CarrierPaymentRemitVm;
};
export type DeleteCarrierPayRemitApiResponse = unknown;
export type DeleteCarrierPayRemitApiArg = {
  /** ID of the payment/remit info entry to delete */
  remitInfoId: number;
};
export type GetCarrierRemitMethodsApiResponse = /** status 200 OK */ string[];
export type GetCarrierRemitMethodsApiArg = void;
export type GetCarrierRemitDeliveryMethodsApiResponse =
  /** status 200 OK */ string[];
export type GetCarrierRemitDeliveryMethodsApiArg = void;
export type GetCarrierRemitFormatsApiResponse = /** status 200 OK */ string[];
export type GetCarrierRemitFormatsApiArg = void;
export type GetAchSecCodesApiResponse = /** status 200 OK */ string[];
export type GetAchSecCodesApiArg = void;
export type GetCarrierInvoiceByIdApiResponse =
  /** status 200 OK */ CarrInvVmRead;
export type GetCarrierInvoiceByIdApiArg = {
  id: number;
};
export type DeleteInvoiceApiResponse = /** status 200 OK */ boolean;
export type DeleteInvoiceApiArg = {
  /** Internal ID of the Carrier Invoice to delete */
  id: number;
};
export type GetCarrInvByInvNumApiResponse =
  /** status 200 OK */ CarrInvVmRead[];
export type GetCarrInvByInvNumApiArg = {
  /** Which kind of Carrier Invoice record (eg: CARRINV, MEMO) to load */
  recType: string;
  /** ID of the carrier whose Carrier Invoices to search */
  carrId: string;
  /** Carrier Invoice number to load */
  invNum: string;
};
export type GetInvoiceSummaryApiResponse =
  /** status 200 OK */ InvoiceSummaryVm;
export type GetInvoiceSummaryApiArg = {
  id: number;
};
export type GetInvoiceLineSummaryApiResponse =
  /** status 200 OK */ InvoiceSummaryVm;
export type GetInvoiceLineSummaryApiArg = {
  id: number;
};
export type GetInvoiceChargeDetailsApiResponse =
  /** status 200 OK */ LineRcTariffQwMarksVm[];
export type GetInvoiceChargeDetailsApiArg = {
  id: number;
};
export type GetInvoiceLineChargeDetailsApiResponse =
  /** status 200 OK */ LineRcTariffQwMarksVm[];
export type GetInvoiceLineChargeDetailsApiArg = {
  id: number;
};
export type GetBundleInfoApiResponse =
  /** status 200 OK */ CarrInvLineBundleVm[];
export type GetBundleInfoApiArg = {
  /** ID of the bundle to load */
  bundleId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetAllInvoiceRevsApiResponse =
  /** status 200 OK */ CarrInvMinimalVmRead[];
export type GetAllInvoiceRevsApiArg = {
  /** The type of Carrier Invoice record to load */
  recType: string;
  /** The ID of the carrier whose Carrier Invoice to load */
  carrierId: string;
  /** The Carrier Invoice number to load */
  invoiceNum: string;
};
export type CreateApiResponse = /** status 200 OK */ CarrInvMinimalVmRead;
export type CreateApiArg = {
  carrInvVm: CarrInvVm;
};
export type CreateWebInvoiceApiResponse = /** status 200 OK */ CarrInvVmRead;
export type CreateWebInvoiceApiArg = {
  /** CarrInvVm object to create the Carrier Invoice with */
  carrInvVm: CarrInvVm;
};
export type UpdateWebInvoiceApiResponse = /** status 200 OK */ CarrInvVmRead;
export type UpdateWebInvoiceApiArg = {
  /** Comment to include in the update */
  comment?: string;
  /** CarrInvVm object to update the Carrier Invoice to */
  carrInvVm: CarrInvVm;
};
export type InitiateMultiPartInvoiceCreationApiResponse =
  /** status 200 OK */ InitiateMultiPartInvoiceCreationResponse;
export type InitiateMultiPartInvoiceCreationApiArg = {
  initiateMultiPartInvoiceCreationRequest: InitiateMultiPartInvoiceCreationRequest;
};
export type MultiPartInvoiceCreationApiResponse =
  /** status 200 OK */ InvoicePartResponse;
export type MultiPartInvoiceCreationApiArg = {
  invoicePartRequest: InvoicePartRequest;
};
export type CompleteMultiPartInvoiceCreationApiResponse =
  /** status 200 OK */ CompleteMultiPartInvoiceCreationResponse;
export type CompleteMultiPartInvoiceCreationApiArg = {
  completeMultiPartInvoiceCreationRequest: CompleteMultiPartInvoiceCreationRequest;
};
export type AbortMultiPartInvoiceCreationApiResponse = unknown;
export type AbortMultiPartInvoiceCreationApiArg = {
  abortMultiPartInvoiceCreationRequest: AbortMultiPartInvoiceCreationRequest;
};
export type CreateQueuedApiResponse =
  /** status 200 OK */ QueuedInvoiceCreationResponse;
export type CreateQueuedApiArg = {
  carrInvVm: CarrInvVm;
};
export type PostApiCarrinvCheckqueuedinvoicecreationstateApiResponse =
  /** status 200 OK */ InvoiceCreationStatusResponse;
export type PostApiCarrinvCheckqueuedinvoicecreationstateApiArg = {
  invoiceCreationStatusRequest: InvoiceCreationStatusRequest;
};
export type ReAuditApiResponse = /** status 200 OK */ CarrInvVmRead;
export type ReAuditApiArg = {
  /** Internal ID of the Carrier Invoice to re-audit */
  id: number;
};
export type TestAuditApiResponse = /** status 200 OK */ CarrInvVmRead;
export type TestAuditApiArg = {
  /** CarrInvVm object of the Carrier Invoice to re-audit */
  carrInvVm: CarrInvVm;
};
export type DeleteShipmentApiResponse = /** status 200 OK */ boolean;
export type DeleteShipmentApiArg = {
  /** Internal ID of the shipment to delete */
  id: number;
};
export type MakeInvoiceMemoApiResponse = /** status 200 OK */ boolean;
export type MakeInvoiceMemoApiArg = {
  /** Internal ID of the Carrier Invoice to memo-ify */
  id?: number;
  /** Additional comment to add for this action */
  comment?: string;
};
export type MakeInvoiceRealApiResponse = /** status 200 OK */ boolean;
export type MakeInvoiceRealApiArg = {
  /** Internal ID of the Carrier Invoice to restore */
  id?: number;
  /** Additional comment to add for this action */
  comment?: string;
};
export type ReassignInvoiceCustomerApiResponse = /** status 200 OK */ boolean;
export type ReassignInvoiceCustomerApiArg = {
  /** CarrInvCustChangeVm object for the requested change */
  carrInvCustChangeVm: CarrInvCustChangeVm;
};
export type ReassignInvoiceNumberApiResponse = /** status 200 OK */ boolean;
export type ReassignInvoiceNumberApiArg = {
  /** CarrInvNumberChangeVm object for the requested change */
  carrInvNumberChangeVm: CarrInvNumberChangeVm;
};
export type ValidateCodingApiResponse = /** status 200 OK */ string;
export type ValidateCodingApiArg = {
  id: number;
  isSave?: boolean;
  isFromApp?: boolean;
};
export type ValidateLineCodingApiResponse = /** status 200 OK */ string;
export type ValidateLineCodingApiArg = {
  id: number;
  lineIdx: number;
  isSave?: boolean;
  isFromApp?: boolean;
};
export type CreateBillingInvoiceApiResponse =
  /** status 200 OK */ CarrInvVmRead;
export type CreateBillingInvoiceApiArg = {
  id: number;
  handledInvoiceException?: boolean;
  createPdf?: boolean;
  createDupeIfExists?: boolean;
};
export type CreateBillingInvoiceQueuedApiResponse =
  /** status 200 OK */ CarrInvVmRead;
export type CreateBillingInvoiceQueuedApiArg = {
  id: number;
  handledInvoiceException?: boolean;
  createPdf?: boolean;
};
export type CreatePdfInvoiceApiResponse = unknown;
export type CreatePdfInvoiceApiArg = {
  id: number;
};
export type CreatePdfInvoiceQueuedApiResponse = unknown;
export type CreatePdfInvoiceQueuedApiArg = {
  id: number;
};
export type RegeneratePdfInvoiceApiResponse = unknown;
export type RegeneratePdfInvoiceApiArg = {
  id: number;
};
export type GetImagesForInvoiceApiResponse =
  /** status 200 OK */ CarrierInvoiceImagesVmRead[];
export type GetImagesForInvoiceApiArg = {
  id: number;
};
export type AddImageApiResponse =
  /** status 200 OK */ CarrierInvoiceImagesVmRead;
export type AddImageApiArg = {
  id: number;
  carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type ClearCachedImagesForInvoiceApiResponse =
  /** status 200 OK */ CarrierInvoiceImagesVmRead[];
export type ClearCachedImagesForInvoiceApiArg = {
  id: number;
};
export type GetImageWithDataApiResponse =
  /** status 200 OK */ CarrierInvoiceImagesVmRead;
export type GetImageWithDataApiArg = {
  id: number;
  imageId: number;
};
export type GetImageWithDataFromObjectApiResponse =
  /** status 200 OK */ CarrierInvoiceImagesVmRead;
export type GetImageWithDataFromObjectApiArg = {
  id: number;
  imageId: string;
  carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type GetInvoiceEdiApiResponse = /** status 200 OK */ CarrInvEdiVm;
export type GetInvoiceEdiApiArg = {
  /** Internal Carrier Invoice ID to look up against */
  id: number;
};
export type CarrInvDisconnectImageApiResponse = unknown;
export type CarrInvDisconnectImageApiArg = {
  id: number;
  imageId: number;
};
export type WhatIfChargeCodesForNewBilltoApiResponse =
  /** status 200 OK */ WhatIfChargeCodeMapVm[];
export type WhatIfChargeCodesForNewBilltoApiArg = {
  id: number;
  newBillToId: string;
};
export type GetInvoicesForBatchingApiResponse =
  /** status 200 OK */ GetBatchableInvoicesCustomerVm[];
export type GetInvoicesForBatchingApiArg = {
  /** The date to search until for Carrier Invoices */
  searchDate: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetAllCarrServicesApiResponse =
  /** status 200 OK */ CarrServicesVm[];
export type GetAllCarrServicesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCarrierServicesApiResponse =
  /** status 200 OK */ CarrServicesVm;
export type CreateCarrierServicesApiArg = {
  /** CarrServicesVm object for the service to add */
  carrServicesVm: CarrServicesVm;
};
export type GetCarrierServicesByIdApiResponse =
  /** status 200 OK */ CarrServicesVm[];
export type GetCarrierServicesByIdApiArg = {
  /** ID of the carrier to load services for */
  carrierId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type ModifyCarrierServiceApiResponse =
  /** status 200 OK */ CarrServicesVm;
export type ModifyCarrierServiceApiArg = {
  /** Which carrier to update a code for */
  carrierId: string;
  /** Which code for the carrier to update */
  svcCode: string;
  /** CarrServicesVm object for the service to update */
  carrServicesVm: CarrServicesVm;
};
export type DeleteCarrierServicesApiResponse = unknown;
export type DeleteCarrierServicesApiArg = {
  /** Which carrier to delete a code for */
  carrierId: string;
  /** Which code for the carrier to delete */
  svcCode: string;
};
export type GetAllowedCarrSvcAuditFnsApiResponse =
  /** status 200 OK */ string[];
export type GetAllowedCarrSvcAuditFnsApiArg = void;
export type GetTicketApiResponse = /** status 200 OK */ CentralSaltMatchVm;
export type GetTicketApiArg = {
  /** ID of the customer (a Central Salt customer) */
  customerId: string;
  /** ID of the carrier to check for a ticket */
  carrierId: string;
  /** The ticket number we're looking up */
  ticketNum: string;
};
export type MakeCSaltInvoiceApiResponse = unknown;
export type MakeCSaltInvoiceApiArg = {
  /** CentralSaltVm object for the ticket data */
  centralSaltVm: CentralSaltVm;
};
export type GetRegisterFbOsApiResponse =
  /** status 200 OK */ BillToMinimalVmRead[];
export type GetRegisterFbOsApiArg = void;
export type GetRegisterInfoApiResponse = /** status 200 OK */ CheckRegisterVm[];
export type GetRegisterInfoApiArg = {
  /** CheckRegisterRequestVm object for the register search terms */
  checkRegisterRequestVm: CheckRegisterRequestVm;
};
export type GetAllCmContractsApiResponse = /** status 200 OK */ CmContractVm[];
export type GetAllCmContractsApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCmContractsApiResponse = /** status 200 OK */ CmContractVm;
export type CreateCmContractsApiArg = {
  /** CmContractVm object for the contract to add */
  cmContractVm: CmContractVm;
};
export type ModifyCmContractsApiResponse = /** status 200 OK */ CmContractVm;
export type ModifyCmContractsApiArg = {
  /** ID of the carrier used in the contract to update */
  carrier: string;
  /** ID of the customer used in the contract to update */
  customer: string;
  /** Service used in the contract to update */
  service: string;
  /** CmContractVm object for the contract to update */
  cmContractVm: CmContractVm;
};
export type DeleteCmContractsApiResponse = unknown;
export type DeleteCmContractsApiArg = {
  /** ID of the carrier used in the contract to remove */
  carrier: string;
  /** ID of the customer used in the contract to remove */
  customer: string;
  /** Service used in the contract to remove */
  service: string;
};
export type GetAllMasterCodesApiResponse = /** status 200 OK */ CodeMasterVm[];
export type GetAllMasterCodesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetMasterCodesForElementApiResponse =
  /** status 200 OK */ CodeMasterVm[];
export type GetMasterCodesForElementApiArg = {
  /** Master Code element to search on */
  element: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type AddModeApiResponse = unknown;
export type AddModeApiArg = {
  /** mode to be added */
  codeMasterVm: CodeMasterVm;
};
export type ModifyMasterCodesApiResponse = /** status 200 OK */ CodeMasterVm;
export type ModifyMasterCodesApiArg = {
  /** element of the Master Code to update */
  element: string;
  /** code of the Master Code to update */
  code: string;
  /** CodeMasterVm object for the state to update */
  codeMasterVm: CodeMasterVm;
};
export type GetMasterCodeFiltersApiResponse =
  /** status 200 OK */ CodeMasterElements;
export type GetMasterCodeFiltersApiArg = void;
export type GetActiveCurrencyCodesApiResponse =
  /** status 200 OK */ CurrencyVm[];
export type GetActiveCurrencyCodesApiArg = void;
export type GetAuditFailCodesApiResponse =
  /** status 200 OK */ StatusMasterVm[];
export type GetAuditFailCodesApiArg = void;
export type GetPreReqStatusesApiResponse = /** status 200 OK */ StatusCodeVm[];
export type GetPreReqStatusesApiArg = void;
export type GetCustomerContactsByIdApiResponse =
  /** status 200 OK */ ContactsVm[];
export type GetCustomerContactsByIdApiArg = {
  /** ID of the customer to load contacts for */
  customerId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCustomerContactsApiResponse = /** status 200 OK */ ContactsVm;
export type CreateCustomerContactsApiArg = {
  /** ContactsVm object for the contact to add */
  contactsVm: ContactsVm;
};
export type ModifyCustomerContactsApiResponse = /** status 200 OK */ ContactsVm;
export type ModifyCustomerContactsApiArg = {
  /** ID of the customer contact to update */
  contactId: number;
  /** ContactsVm object for the contact to update */
  contactsVm: ContactsVm;
};
export type DeleteCustomerContactsApiResponse = unknown;
export type DeleteCustomerContactsApiArg = {
  /** ID of the customer contact to remove */
  contactId: number;
};
export type GetAllCurrenciesApiResponse = /** status 200 OK */ CurrenciesVm[];
export type GetAllCurrenciesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetRefDefsApiResponse =
  /** status 200 OK */ CustomerDataEntryGridVm[];
export type GetRefDefsApiArg = {
  /** ID of the customer to load reference definitions for */
  customerId: string;
  /** ID of the carrier to load reference definitions for */
  carrierId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetCustomerRefDefsApiResponse =
  /** status 200 OK */ CustomerDataEntryCodeListVm[];
export type GetCustomerRefDefsApiArg = {
  /** ID of the customer to load reference definitions for */
  customerId: string;
};
export type GetRefDefsForInvoiceApiResponse =
  /** status 200 OK */ CustomerDataEntryVm[];
export type GetRefDefsForInvoiceApiArg = {
  /** ID of the customer to load reference definitions for */
  customerId: string;
  /** ID of the carrier to load reference definitions for */
  carrierId: string;
};
export type CreateRefDefApiResponse = /** status 200 OK */ CustomerDataEntryVm;
export type CreateRefDefApiArg = {
  /** CustomerDataEntryVm object for the reference definition to add */
  customerDataEntryVm: CustomerDataEntryVm;
};
export type ModifyRefDefApiResponse = /** status 200 OK */ CustomerDataEntryVm;
export type ModifyRefDefApiArg = {
  /** ID of the reference definition to update */
  defId: number;
  /** CustomerDataEntryVm object for the reference definition to update */
  customerDataEntryVm: CustomerDataEntryVm;
};
export type DeleteRefDefApiResponse = unknown;
export type DeleteRefDefApiArg = {
  /** ID of the definition to remove */
  defId: number;
};
export type CreateAndPrepBatchesApiResponse = unknown;
export type CreateAndPrepBatchesApiArg = {
  /** CreateReceivableBatchesForCustomersVm object for the invoices to batch */
  createReceivableBatchesForCustomersVm: CreateReceivableBatchesForCustomersVm;
};
export type GetChildBatchesApiResponse =
  /** status 200 OK */ ChildBatchResultVm[];
export type GetChildBatchesApiArg = {
  /** Customer to look up child batch info for */
  customer: string;
  /** The date to search for batches until */
  reqDate: string;
};
export type CreateAndPrepBatchesFromInvoicesApiResponse = unknown;
export type CreateAndPrepBatchesFromInvoicesApiArg = {
  /** List of invoice IDXs to include in the batch */
  body: number[];
};
export type GetAgedReceivablesApiResponse =
  /** status 200 OK */ AgedReceivablesVm[];
export type GetAgedReceivablesApiArg = void;
export type GetListApiResponse = /** status 200 OK */ CustPaySetupVm[];
export type GetListApiArg = void;
export type UpsertApiResponse = /** status 200 OK */ CustPaySetupVm;
export type UpsertApiArg = {
  custPaySetupVm: CustPaySetupVm;
};
export type GetCustPayByBillToIdByIdApiResponse =
  /** status 200 OK */ CustPaySetupVm[];
export type GetCustPayByBillToIdByIdApiArg = {
  id: string;
};
export type GetCustPaySetupByIdApiResponse =
  /** status 200 OK */ CustPaySetupVm[];
export type GetCustPaySetupByIdApiArg = {
  /** ID of the customer to load pay setup for */
  customerId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCustPaySetupApiResponse = /** status 200 OK */ CustPaySetupVm;
export type CreateCustPaySetupApiArg = {
  /** ID of the customer to add pay setup to */
  customerId: string;
  /** CustPaySetupVm object for the setup to add */
  custPaySetupVm: CustPaySetupVm;
};
export type ModifyCustPaySetupApiResponse = /** status 200 OK */ CustPaySetupVm;
export type ModifyCustPaySetupApiArg = {
  /** ID of the customer pay setup to update */
  setupId: number;
  /** CustPaySetupVm object for the setup to update */
  custPaySetupVm: CustPaySetupVm;
};
export type DeleteCustPaySetupApiResponse = unknown;
export type DeleteCustPaySetupApiArg = {
  /** ID of the customer pay setup to remove */
  setupId: number;
};
export type GetShipmentCountByStatusApiResponse =
  /** status 200 OK */ ShipmentCountByStatusVmRead[];
export type GetShipmentCountByStatusApiArg = void;
export type GetAgedInvoiceSummaryApiResponse =
  /** status 200 OK */ AgedInvoiceSummaryVmRead[];
export type GetAgedInvoiceSummaryApiArg = void;
export type GetDataEntryAdminInfoByCustomerApiResponse =
  /** status 200 OK */ DeAdminVm[];
export type GetDataEntryAdminInfoByCustomerApiArg = {
  /** ID of the customer to load data entry admin info for */
  customerId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetDataEntryAdminInfoForInvoiceApiResponse =
  /** status 200 OK */ DeAdminVm;
export type GetDataEntryAdminInfoForInvoiceApiArg = {
  /** ID of the customer to load data entry admin info for */
  customerId: string;
  /** ID of the carrier to load data entry admin info for */
  carrierId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type ModifyDataEntryAdminInfoApiResponse =
  /** status 200 OK */ DeAdminVm;
export type ModifyDataEntryAdminInfoApiArg = {
  /** ID of the customer whose DE Admin info to update */
  customerId: string;
  /** ID of the carrier whose DE Admin info to update */
  carrierId: string;
  /** DEAdminVm object for the admin info to update */
  deAdminVm: DeAdminVm;
};
export type DeleteDataEntryAdminInfoApiResponse = unknown;
export type DeleteDataEntryAdminInfoApiArg = {
  /** ID of the customer whose DE Admin info to delete */
  customerId: string;
  /** ID of the carrier whose DE Admin info to delete */
  carrierId: string;
};
export type CreateDataEntryAdminInfoApiResponse =
  /** status 200 OK */ DeAdminVm;
export type CreateDataEntryAdminInfoApiArg = {
  /** DEAdminVm object for the admin info to add */
  deAdminVm: DeAdminVm;
};
export type InvoiceResearchExportApiResponse =
  /** status 200 OK */ DataExportsVm[];
export type InvoiceResearchExportApiArg = {
  userJobName?: string;
  fileFormat?: ExportFileFormat;
  invoiceResearchOptionsVm: InvoiceResearchOptionsVm;
};
export type GetDataExportsApiResponse = /** status 200 OK */ DataExportsVm[];
export type GetDataExportsApiArg = void;
export type DeleteExportApiResponse = /** status 200 OK */ DataExportsVm[];
export type DeleteExportApiArg = {
  id: number;
};
export type SendMailWithOutAttachmentsApiResponse = unknown;
export type SendMailWithOutAttachmentsApiArg = {
  emailVm: EmailVm;
};
export type GetActiveEquipsForDropdownApiResponse =
  /** status 200 OK */ EquipmentVm[];
export type GetActiveEquipsForDropdownApiArg = void;
export type GetInvoiceHistoryApiResponse = /** status 200 OK */ CustFeesHdrVm[];
export type GetInvoiceHistoryApiArg = {
  /** ID of the customer to find invoices for */
  customerId: string;
  /** Start of the search range */
  startDate: string;
  /** End of the search range */
  endDate: string;
};
export type GetInvoiceRangeApiResponse =
  /** status 200 OK */ CustFeesRangeHdrVm[];
export type GetInvoiceRangeApiArg = {
  /** CustFeesRangeRequestVm object for search parameters */
  custFeesRangeRequestVm: CustFeesRangeRequestVm;
};
export type GetInvoiceHistoryDetailsApiResponse =
  /** status 200 OK */ CustFeesDetailVm[];
export type GetInvoiceHistoryDetailsApiArg = {
  /** ID of the customer to find invoice details for */
  customerId: string;
  /** ID of the invoice to find details for */
  invoiceId: string;
};
export type GetInvoiceRangeDetailsApiResponse =
  /** status 200 OK */ CustFeesDetailVm[];
export type GetInvoiceRangeDetailsApiArg = {
  /** ID of the customer to find invoice details for */
  customerId: string;
  /** ID of the invoice to find details for */
  invoiceId: string;
};
export type GenerateInvoiceDetailReportApiResponse =
  /** status 200 OK */ CustFeesDetailReportVm;
export type GenerateInvoiceDetailReportApiArg = {
  /** ID of the customer to make report for */
  customerId: string;
  /** ID of the invoice to make report for */
  invoiceId: string;
};
export type DeleteFeesInvoiceApiResponse = unknown;
export type DeleteFeesInvoiceApiArg = {
  /** ID of the invoice to delete */
  invoiceId: string;
};
export type RenameFeesInvoiceApiResponse = unknown;
export type RenameFeesInvoiceApiArg = {
  /** CustFeesChangeInvNumVm objcet for the invoice number change */
  custFeesChangeInvNumVm: CustFeesChangeInvNumVm;
};
export type ImportInvoicesApiResponse = unknown;
export type ImportInvoicesApiArg = {
  /** CustFeesImportRequestVm object for import information */
  custFeesImportRequestVm: CustFeesImportRequestVm;
};
export type GetImportDatesApiResponse = /** status 200 OK */ string[];
export type GetImportDatesApiArg = void;
export type GetImportReportsForDateApiResponse =
  /** status 200 OK */ CheckS3FileInfo[];
export type GetImportReportsForDateApiArg = {
  /** The date to search for import reports */
  importDate: string;
};
export type GetTermsCustomersApiResponse =
  /** status 200 OK */ BillToMinimalVmRead[];
export type GetTermsCustomersApiArg = {
  /** Do we want pay-to-terms customers, or non-pay-to-terms ones? */
  isPayToTerms: boolean;
};
export type TestNonPayInvoicesApiResponse =
  /** status 200 OK */ CustFeesInvoiceTestResultsVm;
export type TestNonPayInvoicesApiArg = {
  /** CustFeesMakeInvoiceRequestVm object for the invoice creation test parameters */
  custFeesMakeInvoiceRequestVm: CustFeesMakeInvoiceRequestVm;
};
export type MakeNonPayInvoicesApiResponse = unknown;
export type MakeNonPayInvoicesApiArg = {
  /** CustFeesMakeInvoiceRequestVm object for the invoice creation parameters */
  custFeesMakeInvoiceRequestVm: CustFeesMakeInvoiceRequestVm;
};
export type TestPayInvoicesApiResponse =
  /** status 200 OK */ CustFeesInvoiceTestResultsVm;
export type TestPayInvoicesApiArg = {
  /** CustFeesMakeInvoiceRequestVm object for the invoice creation test parameters */
  custFeesMakeInvoiceRequestVm: CustFeesMakeInvoiceRequestVm;
};
export type MakePayInvoicesApiResponse = unknown;
export type MakePayInvoicesApiArg = {
  /** CustFeesMakeInvoiceRequestVm object for the invoice creation parameters */
  custFeesMakeInvoiceRequestVm: CustFeesMakeInvoiceRequestVm;
};
export type GetCompareRulesApiResponse =
  /** status 200 OK */ CustFeesRuleComparisonVm;
export type GetCompareRulesApiArg = {
  /** ID of the customer to find rules for */
  customerId: string;
};
export type ConvertFeesAppRuleApiResponse = unknown;
export type ConvertFeesAppRuleApiArg = void;
export type GetCustomerRulesApiResponse =
  /** status 200 OK */ CustFeesRulesAndDetailsVm;
export type GetCustomerRulesApiArg = {
  /** ID of the customer to find rule data for */
  customerId: string;
};
export type GetRuleDataApiResponse = /** status 200 OK */ CustFeesRuleInfoVm;
export type GetRuleDataApiArg = {
  /** ID of the rule to load */
  ruleId: number;
};
export type DeleteFeesRuleApiResponse = unknown;
export type DeleteFeesRuleApiArg = {
  /** ID of the rule to delete */
  ruleId: number;
};
export type CreateFeesRuleApiResponse = /** status 200 OK */ CustFeesRuleInfoVm;
export type CreateFeesRuleApiArg = {
  /** CustFeesRuleInfoVm object for the rule to create */
  custFeesRuleInfoVm: CustFeesRuleInfoVm;
};
export type UpdateFeesRuleApiResponse = /** status 200 OK */ CustFeesRuleInfoVm;
export type UpdateFeesRuleApiArg = {
  /** CustFeesRuleInfoVm object for the updated rule info */
  custFeesRuleInfoVm: CustFeesRuleInfoVm;
};
export type SetFeesRuleDetailApiResponse =
  /** status 200 OK */ CustFeesRuleTypeDetailsVm;
export type SetFeesRuleDetailApiArg = {
  /** CustFeesRuleTypeDetailsVm object for the rule type detail to create/update */
  custFeesRuleTypeDetailsVm: CustFeesRuleTypeDetailsVm;
};
export type GetRuleTypesApiResponse = /** status 200 OK */ CustFeesCategoryVm[];
export type GetRuleTypesApiArg = void;
export type GetBillPerTypesApiResponse =
  /** status 200 OK */ CustFeesCategoryVm[];
export type GetBillPerTypesApiArg = {
  /** Search for periodic types? */
  periodic: boolean;
};
export type GetIntDomTypesApiResponse =
  /** status 200 OK */ CustFeesCategoryVm[];
export type GetIntDomTypesApiArg = void;
export type GetFunctionsApiResponse = /** status 200 OK */ FunctionsVm[];
export type GetFunctionsApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateFunctionApiResponse = /** status 200 OK */ FunctionsVm;
export type CreateFunctionApiArg = {
  /** FunctionsVm object for the function to add */
  functionsVm: FunctionsVm;
};
export type ModifyFunctionApiResponse = /** status 200 OK */ FunctionsVm;
export type ModifyFunctionApiArg = {
  /** ID of the function to update */
  functionId: string;
  /** FunctionsVm object for the function to update */
  functionsVm: FunctionsVm;
};
export type BulkCodingApiResponse = unknown;
export type BulkCodingApiArg = {
  glBulkCodingRequest: GlBulkCodingRequest;
};
export type GetGlCodeForInvoiceApiResponse = unknown;
export type GetGlCodeForInvoiceApiArg = {
  glCodingRequest: GlCodingRequest;
};
export type PostHopkinsDepartmentApiResponse = unknown;
export type PostHopkinsDepartmentApiArg = {
  hopkinsDepartmentVm: HopkinsDepartmentVm;
};
export type GetHealthCheckApiResponse = unknown;
export type GetHealthCheckApiArg = void;
export type $getApiResponse = unknown;
export type $getApiArg = void;
export type GetImageApiResponse =
  /** status 200 OK */ CarrierInvoiceImagesVmRead;
export type GetImageApiArg = {
  imageId: number;
};
export type DeleteImageApiResponse = unknown;
export type DeleteImageApiArg = {
  imageId: number;
};
export type DeleteMultipleImagesApiResponse = unknown;
export type DeleteMultipleImagesApiArg = {
  /** List of image IDs to delete */
  body: number[];
};
export type DisconnectImageApiResponse = unknown;
export type DisconnectImageApiArg = {
  imageId: number;
};
export type DisconnectMultipleImagesApiResponse = unknown;
export type DisconnectMultipleImagesApiArg = {
  /** List of image IDs to delete */
  body: number[];
};
export type GetDisconnectedImagesApiResponse =
  /** status 200 OK */ DisconnectedCarrInvImagesVm[];
export type GetDisconnectedImagesApiArg = void;
export type UploadDisconnectedImageApiResponse = unknown;
export type UploadDisconnectedImageApiArg = {
  carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type GetDisconnectedImagesQueryableApiResponse =
  /** status 200 OK */ DisconnectedCarrInvImagesVm[];
export type GetDisconnectedImagesQueryableApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetQueuesApiResponse = /** status 200 OK */ string[];
export type GetQueuesApiArg = void;
export type GetQueueImagesApiResponse =
  /** status 200 OK */ CarrierInvoiceImagesVmRead[];
export type GetQueueImagesApiArg = {
  /** The queue to load images for */
  queue: string;
};
export type IndexImageApiResponse =
  /** status 200 OK */ CarrierInvoiceImagesVmRead;
export type IndexImageApiArg = {
  /** The queue the target image is in */
  queue: string;
  /** The target image's CarrInvImages data */
  carrInvImages: CarrInvImages;
};
export type AddImageToQueueApiResponse = unknown;
export type AddImageToQueueApiArg = {
  /** The queue the target image should go into */
  queue: string;
  /** Image data to upload */
  carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type AddScannedImageApiResponse = unknown;
export type AddScannedImageApiArg = {
  /** Image data to upload */
  carrInvImageScanVm: CarrInvImageScanVm;
};
export type GetScannedImagesApiResponse =
  /** status 200 OK */ CarrInvImageScanVmRead[];
export type GetScannedImagesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type DeleteScannedImagesApiResponse = unknown;
export type DeleteScannedImagesApiArg = {
  /** List of scan IDs to delete */
  body: number[];
};
export type GetScannedImageCustomersApiResponse = /** status 200 OK */ string[];
export type GetScannedImageCustomersApiArg = void;
export type UpdateScannedImagesApiResponse = unknown;
export type UpdateScannedImagesApiArg = {
  /** List of image data to update */
  body: CarrInvImageScanVm[];
};
export type GetAllowedImageTypesApiResponse = /** status 200 OK */ {
  [key: string]: string;
};
export type GetAllowedImageTypesApiArg = void;
export type DeleteUnindexedImageApiResponse = unknown;
export type DeleteUnindexedImageApiArg = {
  /** The name of the queue to delete from */
  queue: string;
  /** The name of theimage to delete */
  image: string;
};
export type CustomerImageExtractApiResponse =
  /** status 200 OK */ ImageExtractResults;
export type CustomerImageExtractApiArg = {
  /** CustImageExtractVm object for extract parameters */
  custImageExtractVm: CustImageExtractVm;
};
export type ReleaseInvoiceApiResponse = unknown;
export type ReleaseInvoiceApiArg = {
  type: string;
  id: number;
};
export type GetBasicInvInfoApiResponse =
  /** status 200 OK */ BasicInfoVmGetResponse;
export type GetBasicInvInfoApiArg = {
  type: string;
  id: number;
};
export type GetDetailedChargesApiResponse =
  /** status 200 OK */ DetailedChargeListVmRead;
export type GetDetailedChargesApiArg = {
  type: InvType;
  id: number;
};
export type GetReferencesApiResponse = /** status 200 OK */ ReferenceListVm;
export type GetReferencesApiArg = {
  type: string;
  id: number;
};
export type UpdateReferencesApiResponse = /** status 200 OK */ ReferenceListVm;
export type UpdateReferencesApiArg = {
  type: string;
  id: number;
  referenceListVm: ReferenceListVm;
};
export type GetImagesApiResponse = /** status 200 OK */ ImageListVmRead;
export type GetImagesApiArg = {
  type: string;
  id: number;
};
export type UpdateCommentApiResponse = /** status 200 OK */ InvoiceComment;
export type UpdateCommentApiArg = {
  type: string;
  id: number;
  invoiceComment: InvoiceComment;
};
export type GetPurgableInvoiceListApiResponse =
  /** status 200 OK */ PurgableInvoiceVm[];
export type GetPurgableInvoiceListApiArg = void;
export type UnbatchReceivableBatchesApiResponse = unknown;
export type UnbatchReceivableBatchesApiArg = {
  /** The ID of the receivable batch to unbatch */
  batchId: number;
};
export type UnapproveApprovedBatchesApiResponse = unknown;
export type UnapproveApprovedBatchesApiArg = {
  /** The ID of the approved batch to unapprove */
  batchId: number;
  /** Whether or not to unapprove all linked invoices, even in-review ones */
  unapproveAll: boolean;
};
export type PurgeInvoiceApiResponse = unknown;
export type PurgeInvoiceApiArg = {
  /** InvoicePurgeRequestVm object for the invoice to remove */
  invoicePurgeRequestVm: InvoicePurgeRequestVm;
};
export type PurgeInvoicesFromFileApiResponse = unknown;
export type PurgeInvoicesFromFileApiArg = {
  /** Name of the import file responsible for invoices to purge */
  fileName: string;
};
export type GetInvoiceResearchPopulationDataApiResponse =
  /** status 200 OK */ InvoiceResearchOptionsVmRead;
export type GetInvoiceResearchPopulationDataApiArg = void;
export type SearchInvoicesApiResponse =
  /** status 200 OK */ CarrInvMinimalVmRead[];
export type SearchInvoicesApiArg = {
  invoiceResearchOptionsVm: InvoiceResearchOptionsVm;
};
export type ReactDataTableServerSideProcessingApiResponse =
  /** status 200 OK */ InvoiceResearchListVmPagingResponseRead;
export type ReactDataTableServerSideProcessingApiArg = {
  /** Search Options selected in the Invoice Research UI */
  invoiceResearchOptionsVm: InvoiceResearchOptionsVm;
};
export type GetMakeRealWorkaroundInvoicesApiResponse =
  /** status 200 OK */ MakeRealVm[];
export type GetMakeRealWorkaroundInvoicesApiArg = void;
export type PostMakeRealWorkaroundInvoicesApiResponse =
  /** status 200 OK */ MakeRealVm[];
export type PostMakeRealWorkaroundInvoicesApiArg = void;
export type GetStatusesForExceptionsApiResponse = /** status 200 OK */ string[];
export type GetStatusesForExceptionsApiArg = void;
export type GetExceptionsForGridApiResponse =
  /** status 200 OK */ ExceptionManagerListVm[];
export type GetExceptionsForGridApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type SaveCurrentRemarksApiResponse = /** status 200 OK */ boolean;
export type SaveCurrentRemarksApiArg = {
  /** Invoices to add an audit comment and the comment */
  exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type AcceptAsEnteredApiResponse = /** status 200 OK */ boolean;
export type AcceptAsEnteredApiArg = {
  /** Invoices to accept and an audit comment */
  exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type AcceptAsAuditedApiResponse = /** status 200 OK */ boolean;
export type AcceptAsAuditedApiArg = {
  /** Invoices to accept and an audit comment */
  exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type AcceptAsAdjustedApiResponse = /** status 200 OK */ boolean;
export type AcceptAsAdjustedApiArg = {
  /** Invoices to adjust/accept and an audit comment */
  exceptionManagerAcceptAsAdjustedVm: ExceptionManagerAcceptAsAdjustedVm;
};
export type RefuseInvoiceApiResponse = /** status 200 OK */ boolean;
export type RefuseInvoiceApiArg = {
  /** Invoices to refuse and an audit comment */
  exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type ExceptionManagerDeleteApiResponse = /** status 200 OK */ boolean;
export type ExceptionManagerDeleteApiArg = {
  /** Invoices to delete and an audit comment */
  exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type DeclineServiceFailApiResponse = /** status 200 OK */ boolean;
export type DeclineServiceFailApiArg = {
  /** Service-failed invoices to decline and an audit comment */
  exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type ApproveServiceFailApiResponse = /** status 200 OK */ boolean;
export type ApproveServiceFailApiArg = {
  /** Service-failed invoices to accept and an audit comment */
  exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type MassRefSearchApiResponse = /** status 200 OK */ MassUpdateVm[];
export type MassRefSearchApiArg = {
  /** Search parameters object */
  updateSearchParams: UpdateSearchParams;
};
export type MassRefUpdateApiResponse = /** status 200 OK */ MassUpdateVm[];
export type MassRefUpdateApiArg = {
  /** List of Mass Reference Update requests */
  body: MassUpdateVm[];
};
export type GetCentralSaltTicketsApiResponse =
  /** status 200 OK */ CentralSaltMatchVm[];
export type GetCentralSaltTicketsApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type UpdateCentralSaltTicketApiResponse = unknown;
export type UpdateCentralSaltTicketApiArg = {
  /** CentralSaltMatchVm for the ticket update */
  centralSaltMatchVm: CentralSaltMatchVm;
};
export type GetHarcrosTicketsApiResponse =
  /** status 200 OK */ HarcrosMatchVm[];
export type GetHarcrosTicketsApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetAscRefCodesApiResponse =
  /** status 200 OK */ AscReferenceCodeVm[];
export type GetAscRefCodesApiArg = void;
export type GetAscChargeCodesApiResponse =
  /** status 200 OK */ AscChargeCodeVm[];
export type GetAscChargeCodesApiArg = {
  sorted?: boolean;
};
export type GetTransportModesApiResponse = /** status 200 OK */ ModeVmRead[];
export type GetTransportModesApiArg = void;
export type GetAvailableAuditFailStatusesApiResponse =
  /** status 200 OK */ StatusMasterVm[];
export type GetAvailableAuditFailStatusesApiArg = void;
export type GetCarrierChargeCodeSourcesApiResponse =
  /** status 200 OK */ CarrierChargeCodeSourceGenericDropDownStruct[];
export type GetCarrierChargeCodeSourcesApiArg = void;
export type GetCustomerDataEntryCodesForUserApiResponse =
  /** status 200 OK */ CustomerReferenceCodeVmRead[];
export type GetCustomerDataEntryCodesForUserApiArg = void;
export type GetCustomerDataEntryCodesApiResponse =
  /** status 200 OK */ CustomerReferenceCodeVmRead[];
export type GetCustomerDataEntryCodesApiArg = {
  billToId: string;
};
export type GetIa360ReportingLinkApiResponse = /** status 200 OK */ string;
export type GetIa360ReportingLinkApiArg = {
  carrierId?: string;
  invoiceNum?: string;
};
export type GetInvoiceStatusCodesApiResponse =
  /** status 200 OK */ StatusCodeVm[];
export type GetInvoiceStatusCodesApiArg = void;
export type GetEntryMethodsApiResponse = /** status 200 OK */ EntryMethodVm[];
export type GetEntryMethodsApiArg = void;
export type GetActivityCodesApiResponse = /** status 200 OK */ CodeMasterVm[];
export type GetActivityCodesApiArg = void;
export type GetInvoiceTypeListApiResponse = /** status 200 OK */ string[];
export type GetInvoiceTypeListApiArg = void;
export type GetIbobsListApiResponse = /** status 200 OK */ string[];
export type GetIbobsListApiArg = void;
export type GetReportNameListApiResponse =
  /** status 200 OK */ CustFeesReportNamesVm[];
export type GetReportNameListApiArg = void;
export type GetQueueIsActiveApiResponse = /** status 200 OK */ boolean;
export type GetQueueIsActiveApiArg = {
  queue: string;
};
export type GetPartiesApiResponse = /** status 200 OK */ PartyVm[];
export type GetPartiesApiArg = {
  /** Which customer's parties we're searching through */
  customerId: string;
  /** What kind of party to search for (SH or CN) */
  partyType: string;
  /** Partial or Complete postal code to filter parties by */
  zipSearch: string;
};
export type GetUnMadeAchPaymentsApiResponse =
  /** status 200 OK */ AchPaymentVm[];
export type GetUnMadeAchPaymentsApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GenerateAcHesApiResponse = unknown;
export type GenerateAcHesApiArg = {
  /** Date to stamp on the generated ACHes */
  procDate?: string;
  /** List of batch IDs to process ACH payments for */
  body: number[];
};
export type GetAchDatesApiResponse = /** status 200 OK */ string[];
export type GetAchDatesApiArg = void;
export type GetAchFilesForDateApiResponse =
  /** status 200 OK */ CheckS3FileInfo[];
export type GetAchFilesForDateApiArg = {
  /** The date to search for ACH files */
  procDate: string;
};
export type GetCarrierPayableExceptionsByIdApiResponse =
  /** status 200 OK */ PayablesExceptionsVm[];
export type GetCarrierPayableExceptionsByIdApiArg = {
  /** ID of the carrier to load exceptions for */
  carrierId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateCarrierPayExceptionApiResponse =
  /** status 200 OK */ PayablesExceptionsVm;
export type CreateCarrierPayExceptionApiArg = {
  /** PayablesExceptionsVm object for the exception to add */
  payablesExceptionsVm: PayablesExceptionsVm;
};
export type ModifyCarrierPayExceptionApiResponse =
  /** status 200 OK */ PayablesExceptionsVm;
export type ModifyCarrierPayExceptionApiArg = {
  /** ID of the carrier contact to update */
  exceptionId: number;
  /** PayablesExceptionsVm object for the exception to update */
  payablesExceptionsVm: PayablesExceptionsVm;
};
export type DeleteCarrierPayExceptionApiResponse = unknown;
export type DeleteCarrierPayExceptionApiArg = {
  /** ID of the carrier payable exception to remove */
  exceptionId: number;
};
export type GetAllPayDayStartsApiResponse =
  /** status 200 OK */ PayDaysStartVm[];
export type GetAllPayDayStartsApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetPermittedValsByCustomerApiResponse =
  /** status 200 OK */ PermittedValuesVm[];
export type GetPermittedValsByCustomerApiArg = {
  /** ID of the customer to load permitted value info for */
  customerId: string;
  /** ID of the carrier to load permitted value info for */
  carrierId: string;
  /** ASC Ref Code to load permitted value info for */
  code: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type GetInvoicePermittedValuesApiResponse =
  /** status 200 OK */ PermittedValuesVm[];
export type GetInvoicePermittedValuesApiArg = {
  /** ID of the customer to load permitted value info for */
  customerId: string;
  /** ID of the carrier to load permitted value info for */
  carrierId: string;
};
export type CreatePermittedValueApiResponse =
  /** status 200 OK */ PermittedValuesVm;
export type CreatePermittedValueApiArg = {
  /** PermittedValuesVm object for the permitted value to add */
  permittedValuesVm: PermittedValuesVm;
};
export type ModifyPermittedValueApiResponse =
  /** status 200 OK */ PermittedValuesVm;
export type ModifyPermittedValueApiArg = {
  /** ID of the permitted value to update */
  valId: number;
  /** PermittedValuesVm object for the permitted value to update */
  permittedValuesVm: PermittedValuesVm;
};
export type DeletePermittedValueApiResponse = unknown;
export type DeletePermittedValueApiArg = {
  /** ID of the value to remove */
  valId: number;
};
export type GetPostalCodesApiResponse = /** status 200 OK */ PostalCodeVm[];
export type GetPostalCodesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreatePostalCodeApiResponse = unknown;
export type CreatePostalCodeApiArg = {
  /** PostalCodeVm object for the postal code to add */
  postalCodeVm: PostalCodeVm;
};
export type ModifyPostalCodeApiResponse = /** status 200 OK */ PostalCodeVm;
export type ModifyPostalCodeApiArg = {
  /** ID of the postal code to update */
  codeId: number;
  /** PostalCodeVm object for the postal code to update */
  postalCodeVm: PostalCodeVm;
};
export type DeletePostalCodeApiResponse = unknown;
export type DeletePostalCodeApiArg = {
  /** ID of the postal code to remove */
  codeId: number;
};
export type GetAllChecksApiResponse = /** status 200 OK */ PrintCheckVmRead[];
export type GetAllChecksApiArg = {
  /** Which account to search for checks */
  acctNum: string;
};
export type GetChecksForDateApiResponse =
  /** status 200 OK */ PrintCheckVmRead[];
export type GetChecksForDateApiArg = {
  /** Which account to search for checks */
  acctNum: string;
  /** The date to search for checks */
  searchDate: string;
};
export type GetReprintChecksForDateApiResponse =
  /** status 200 OK */ PrintCheckVmRead[];
export type GetReprintChecksForDateApiArg = {
  /** Which account to search for checks */
  acctNum: string;
  /** The pay date to search for checks */
  payDate: string;
};
export type MakeNewBatchesApiResponse = unknown;
export type MakeNewBatchesApiArg = void;
export type PrintChecksApiResponse = unknown;
export type PrintChecksApiArg = {
  /** PrintCheckRequestVm object for check printing info */
  printCheckRequestVm: PrintCheckRequestVm;
};
export type ReprintChecksApiResponse = unknown;
export type ReprintChecksApiArg = {
  /** ReprintCheckRequestVm object for check printing info */
  reprintCheckRequestVm: ReprintCheckRequestVm;
};
export type GetCheckDatesApiResponse = /** status 200 OK */ string[];
export type GetCheckDatesApiArg = void;
export type GetPrintedChecksForDateApiResponse =
  /** status 200 OK */ CheckS3FileInfo[];
export type GetPrintedChecksForDateApiArg = {
  /** The date to search for checks */
  checkDate: string;
};
export type GetReceiptsApiResponse = /** status 200 OK */ CashReceiptsVm[];
export type GetReceiptsApiArg = {
  /** ID of the customer (or * for "all") to find receipts for */
  customerId: string;
  /** Starting date for the receipt range */
  startDate: string;
  /** End date for the receipt range */
  endDate: string;
};
export type MergeReceiptsApiResponse = {
  resultCashReceiptId?: number | null;
  status?: string | null;
  errorMessage?: string | null;
};
export type MergeReceiptsApiArg = {
  /** List of receipt IDs to merge */
  body: number[];
  /** Idempotency key to prevent duplicate merges */
  transactionId: string;
};
export type GetApprovedInvoicesApiResponse =
  /** status 200 OK */ ReceiveFundsInvoiceVm[];
export type GetApprovedInvoicesApiArg = {
  customerId: string;
};
export type GetUnappliedCashApiResponse = /** status 200 OK */ CashReceiptsVm[];
export type GetUnappliedCashApiArg = {
  customerId: string;
};
export type ReceiveFundsApiResponse = unknown;
export type ReceiveFundsApiArg = {
  receiveFundsVm: ReceiveFundsVm;
};
export type UseUnappliedCashApiResponse = unknown;
export type UseUnappliedCashApiArg = {
  useUnappliedCashVm: UseUnappliedCashVm;
  /** Idempotency key to prevent duplicate allocations */
  transactionId: string;
};
export type DepositFundsApiResponse = unknown;
export type DepositFundsApiArg = {
  depositFundsVm: DepositFundsVm;
};
export type CreateCreditApiResponse = unknown;
export type CreateCreditApiArg = {
  receiveCreditVm: ReceiveCreditVm;
};
export type GetApiReportingApiResponse = /** status 200 OK */ EmbedParamsRead;
export type GetApiReportingApiArg = void;
export type GetBookmarksForUserApiResponse =
  /** status 200 OK */ ReportBookmarkVm[];
export type GetBookmarksForUserApiArg = void;
export type CreateBookmarkApiResponse = /** status 200 OK */ ReportBookmarkVm[];
export type CreateBookmarkApiArg = {
  createReportBookmarkVm: CreateReportBookmarkVm;
};
export type DeleteBookmarkApiResponse = /** status 200 OK */ ReportBookmarkVm[];
export type DeleteBookmarkApiArg = {
  id: number;
};
export type GetStatesApiResponse = /** status 200 OK */ StatesVm[];
export type GetStatesApiArg = {
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateStatesApiResponse = /** status 200 OK */ StatesVm;
export type CreateStatesApiArg = {
  /** StatesVm object for the state to add */
  statesVm: StatesVm;
};
export type ModifyStatesApiResponse = /** status 200 OK */ StatesVm;
export type ModifyStatesApiArg = {
  /** ID of the state to update */
  stateId: number;
  /** StatesVm object for the state to update */
  statesVm: StatesVm;
};
export type DeleteStatesApiResponse = unknown;
export type DeleteStatesApiArg = {
  /** ID of the state to remove */
  stateId: number;
};
export type GetConfigApiResponse = /** status 200 OK */ {
  [key: string]: string;
};
export type GetConfigApiArg = void;
export type GetAppconfigApiResponse = /** status 200 OK */ AppSettings;
export type GetAppconfigApiArg = void;
export type GetTimecardForUserIdApiResponse =
  /** status 200 OK */ UserTimeCardVm;
export type GetTimecardForUserIdApiArg = {
  userId?: string;
  date?: string;
};
export type AddTimeCardApiResponse = unknown;
export type AddTimeCardApiArg = {
  userTimeCardVm: UserTimeCardVm;
};
export type DeleteTimeCardApiResponse = unknown;
export type DeleteTimeCardApiArg = {
  id: string;
};
export type GetUserBillToInfoByCustomerApiResponse =
  /** status 200 OK */ UserVmRead[];
export type GetUserBillToInfoByCustomerApiArg = {
  /** ID of the customer to load linked user info for */
  customerId: string;
  /** The max number of records. */
  $top?: string;
  /** The number of records to skip. */
  $skip?: string;
  /** A function that must evaluate to true for a record to be returned. */
  $filter?: string;
  /** Determines what values are used to order a collection of records. */
  $orderby?: string;
  /** Use to add related query data. */
  $expand?: string;
  /** Determines if a count of total records is returned along with data. */
  $count?: string;
};
export type CreateUserBillToInfoApiResponse = /** status 200 OK */ UserBillToVm;
export type CreateUserBillToInfoApiArg = {
  /** UserBillToVm object for the customer/user link to add */
  userBillToVm: UserBillToVm;
};
export type DeleteUserBillToInfoApiResponse = unknown;
export type DeleteUserBillToInfoApiArg = {
  /** ID of the customer to remove the user from */
  customerId: string;
  /** ID of the user to unlink from the customer */
  userId: string;
};
export type GetMyConfigApiResponse =
  /** status 200 OK */ UserConfigurationVmRead;
export type GetMyConfigApiArg = void;
export type SaveMyConfigApiResponse =
  /** status 200 OK */ UserConfigurationVmRead;
export type SaveMyConfigApiArg = {
  userConfigurationVm: UserConfigurationVm;
};
export type GetUserConfigurationApiResponse =
  /** status 200 OK */ UserConfigurationVmRead;
export type GetUserConfigurationApiArg = {
  userId: string;
};
export type SaveUserConfigApiResponse =
  /** status 200 OK */ UserConfigurationVmRead;
export type SaveUserConfigApiArg = {
  userId: string;
  userConfigurationVm: UserConfigurationVm;
};
export type GetRoleAuthsApiResponse = /** status 200 OK */ FunctionalAuthVm[];
export type GetRoleAuthsApiArg = {
  /** The role to look up data for */
  role: string;
};
export type CreateNewRoleApiResponse = unknown;
export type CreateNewRoleApiArg = {
  /** UserRoleDefinitionVm for the new role */
  userRoleDefinitionVm: UserRoleDefinitionVm;
};
export type UpdateRoleApiResponse = unknown;
export type UpdateRoleApiArg = {
  /** FunctionalAuthVm for the updated role definition */
  functionalAuthVm: FunctionalAuthVm;
};
export type CopyRoleApiResponse = unknown;
export type CopyRoleApiArg = {
  /** Name of the role we're copying from */
  copyRole?: string;
  /** UserRoleDefinitionVm of the new target role */
  userRoleDefinitionVm: UserRoleDefinitionVm;
};
export type GetAllUsersApiResponse = /** status 200 OK */ UserVmRead[];
export type GetAllUsersApiArg = void;
export type UpdateUserApiResponse = /** status 200 OK */ UserAdminVm;
export type UpdateUserApiArg = {
  /** UserAdminVm for the updated user admin info */
  userAdminVm: UserAdminVm;
};
export type GetFullUserListApiResponse = /** status 200 OK */ UserVmRead[];
export type GetFullUserListApiArg = void;
export type GetUserAdminInfoApiResponse = /** status 200 OK */ UserAdminVm;
export type GetUserAdminInfoApiArg = {
  /** ID of the user to load */
  userId: string;
};
export type GetKnownCompaniesApiResponse = /** status 200 OK */ string[];
export type GetKnownCompaniesApiArg = void;
export type AddUserApiResponse = unknown;
export type AddUserApiArg = {
  /** ID of the user to add */
  userId: string;
};
export type ChangePasswordApiResponse = unknown;
export type ChangePasswordApiArg = {
  /** UserAdminPasswordVm for the necessary password info */
  userAdminPasswordVm: UserAdminPasswordVm;
};
export type SuspendUserApiResponse = /** status 200 OK */ UserAdminVm;
export type SuspendUserApiArg = {
  /** UserAdminSuspendVm for suspension info */
  userAdminSuspendVm: UserAdminSuspendVm;
};
export type GetTimeCardUsersApiResponse = /** status 200 OK */ UserVmRead[];
export type GetTimeCardUsersApiArg = void;
export type GetUserSessionsForUserApiResponse =
  /** status 200 OK */ UserSessionsVm[];
export type GetUserSessionsForUserApiArg = {
  userId: string;
  lastWorkDay?: string;
};
export type GetMyUserSessionsApiResponse =
  /** status 200 OK */ UserSessionsVm[];
export type GetMyUserSessionsApiArg = {
  lastWorkDay?: string;
};
export type GetCarrInvStatsForUserApiResponse =
  /** status 200 OK */ CarrInvUserStatsVm[];
export type GetCarrInvStatsForUserApiArg = {
  userId: string;
  lastWorkDay?: string;
};
export type GetMyCarrInvStatsApiResponse =
  /** status 200 OK */ CarrInvUserStatsVm[];
export type GetMyCarrInvStatsApiArg = {
  lastWorkDay?: string;
};
export type AppDefaultVm = {
  parmID: string;
  parmGroup: string;
  parmDescrip?: string | null;
  parmValue?: string | null;
  longValue?: string | null;
};
export type SecureDefaultVm = {
  parmID?: string | null;
  parmGroup?: string | null;
  parmDescrip?: string | null;
  parmValue?: string | null;
};
export type BillToMinimalVm = {
  btId: string;
  name?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  sfremail?: string | null;
  isParent?: boolean;
  address1?: string | null;
  city?: string | null;
  stateProv?: string | null;
  postal?: string | null;
  phone1Num?: string | null;
};
export type BillToMinimalVmRead = {
  btId: string;
  name?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  sfremail?: string | null;
  isParent?: boolean;
  address1?: string | null;
  city?: string | null;
  stateProv?: string | null;
  postal?: string | null;
  phone1Num?: string | null;
  /** get only property to match CarrierMinimalVm */
  phones?: string | null;
};
export type CurrencyVm = {
  code?: string | null;
  display?: string | null;
};
export type DateTimeDropdown = {
  value?: string | null;
  display?: string | null;
};
export type InvoiceApprovalOptionsVm = {
  billTos?: BillToMinimalVm[] | null;
  currencies?: CurrencyVm[] | null;
  batchDate?: DateTimeDropdown[] | null;
  selectedBillTo?: BillToMinimalVm;
  selectedCurrency?: CurrencyVm;
  selectedBatchDate?: DateTimeDropdown;
  onlyPendingFundsRequests?: boolean | null;
};
export type InvoiceApprovalOptionsVmRead = {
  billTos?: BillToMinimalVmRead[] | null;
  currencies?: CurrencyVm[] | null;
  batchDate?: DateTimeDropdown[] | null;
  selectedBillTo?: BillToMinimalVmRead;
  selectedCurrency?: CurrencyVm;
  selectedBatchDate?: DateTimeDropdown;
  onlyPendingFundsRequests?: boolean | null;
};
export type ApproveInvoicesCarrInvLineVm = {
  airBillApprNetDue?: number;
  airBillAuditNetDue?: number;
  airBillSavings?: number | null;
  airBillComment?: string | null;
  airBillMode?: string | null;
  airBillNetDue?: number;
  airBillNum?: string | null;
  airBillRev?: number;
  airBillSelected?: boolean;
  airBillStatus?: string | null;
  currency?: string | null;
  lineIdx?: number;
  lineSeq?: number;
  service?: string | null;
  modified?: boolean;
};
export type ApproveInvoicesInvoiceVm = {
  invIdx?: number;
  invMode?: string | null;
  invoiceApprNetDue?: number | null;
  invoiceAuditNetDue?: number | null;
  invoiceSavings?: number | null;
  invoiceComment?: string | null;
  currency?: string | null;
  invoiceDate?: string | null;
  invoiceNetDue?: number | null;
  invoiceNum?: string | null;
  selected?: boolean;
  invRev?: number;
  invStatus?: string | null;
  invType?: string | null;
  isaSenderId?: string | null;
  airBills?: ApproveInvoicesCarrInvLineVm[] | null;
  modified?: boolean;
};
export type ApproveInvoicesCarrierVm = {
  carrierApprNetDue?: number | null;
  carrierAuditNetDue?: number | null;
  carrierSavings?: number | null;
  carrierId?: string | null;
  selected?: boolean;
  carrierName?: string | null;
  carrierNetDue?: number | null;
  currency?: string | null;
  comment?: string | null;
  invoiceCount?: number;
  invoices?: ApproveInvoicesInvoiceVm[] | null;
};
export type ApproveInvoicesCustomerVm = {
  btId?: string | null;
  masterBtId?: string | null;
  btName?: string | null;
  rcvBatchId?: number;
  rcvBatchDate?: string;
  customerInvoiceNetDue?: number | null;
  customerSavings?: number | null;
  customerInvoiceAuditNetDue?: number | null;
  customerInvoiceApprNetDue?: number | null;
  comment?: string | null;
  currency?: string | null;
  selected?: boolean;
  carrInvoices?: ApproveInvoicesCarrierVm[] | null;
  invoiceCount?: number;
  processingApprovedBatch?: boolean;
};
export type ApproveInvoicesSearchResponse = {
  /** Invoices that are returned due to the selected search options. */
  invoices?: ApproveInvoicesCustomerVm[] | null;
};
export type ApproveInvoicesSearchResponseRead = {
  /** Invoices that are returned due to the selected search options. */
  invoices?: ApproveInvoicesCustomerVm[] | null;
  /** Sets whether the Approve Button and other Edit Mode items should be enabled or disabled because of business logic
    around the invoices in the return data.
    Does not respect permissions and permissions will still need to be checked. */
  showApprove?: boolean;
};
export type CarrierMinimalVm = {
  carrId: string;
  name?: string | null;
  scac?: string | null;
  tracingUrl?: string | null;
  defaultInvType?: string | null;
  address1?: string | null;
  city?: string | null;
  stateProv?: string | null;
  postal?: string | null;
  phones?: string | null;
  faxnums?: string | null;
};
export type PartyVm = {
  /** Internal ID of the party */
  id?: number;
  /** ID of the customer this party setup is for */
  btId?: string | null;
  /** ID of the carrier this party setup is for */
  carrierId?: string | null;
  /** Party's public name */
  name?: string | null;
  /** Party's extended name (not really used) */
  name2?: string | null;
  /** Party's extended name (not really used) */
  name3?: string | null;
  /** Is this a SHipper or a CoNsignee? */
  partyType?: string | null;
  /** Party's main address info */
  addr1?: string | null;
  /** Party's extended address info (line 2) */
  addr2?: string | null;
  /** Party's extended address info (line 3) */
  addr3?: string | null;
  /** Party's extended address info (line 4) */
  addr4?: string | null;
  /** Party's city */
  city?: string | null;
  /** Party's state or province code */
  stateProv?: string | null;
  /** Party's postal code */
  postalCode?: string | null;
  /** Party's country code */
  countryCode?: string | null;
  /** Party's country subcode */
  countrySub?: string | null;
  /** ID of the customer using this party */
  fpsCustId?: string | null;
  /** GUID of the represented record */
  partyGuid?: string;
};
export type CarrInvLineRcVm = {
  advances?: number | null;
  approvedAmt?: number | null;
  auditedAmt?: number | null;
  auditMsg?: string | null;
  billedQty?: number | null;
  billedQtyQual?: string | null;
  bolamt?: number | null;
  bolauditedAmt?: number | null;
  carrierId?: string | null;
  charge?: number | null;
  chgMethPay?: string | null;
  currencyCode?: string | null;
  declaredValue?: number | null;
  declValQual?: string | null;
  entitleCode?: string | null;
  freightRate?: number | null;
  invIdx?: number | null;
  invoiceNum?: string | null;
  invRev?: number;
  ladingLine?: number;
  ladingVal?: number | null;
  ladLiabCode?: string | null;
  lineIdx?: number | null;
  lineSeq?: number;
  originalChargeCode?: string | null;
  originalChargeDescr?: string | null;
  originAmt?: number | null;
  paidAmt?: number | null;
  pct?: number | null;
  prepaidAmt?: number | null;
  rateClassCode?: string | null;
  rateCombPointCode?: string | null;
  rateQual?: string | null;
  rcSeq?: number;
  recType?: string | null;
  specChargeCode?: string | null;
  specChgDescr?: string | null;
  tariffAppCode?: string | null;
  totalsColumn?: string | null;
};
export type CarrInvLineTariffVm = {
  agencyCode?: string | null;
  carrierId?: string | null;
  carrSvcLevCode?: string | null;
  cityName?: string | null;
  commodCode?: string | null;
  custSvcLevCode?: string | null;
  distQual?: string | null;
  dscode?: string | null;
  effectiveDate?: string | null;
  exParte?: string | null;
  exParteDate?: string | null;
  /** A 0 freight class is returned as an empty string */
  freightClass?: string | null;
  intDomCode?: string | null;
  invIdx?: number | null;
  invoiceNum?: string | null;
  invRev?: number;
  ladingLine?: number;
  lineIdx?: number | null;
  lineSeq?: number;
  rateBasisNum?: string | null;
  recType?: string | null;
  scale?: string | null;
  shipMop?: string | null;
  stateProv?: string | null;
  tariffCol?: string | null;
  tariffDist?: number | null;
  tariffItem?: string | null;
  tariffNum?: string | null;
  tariffPart?: number | null;
  tariffSection?: string | null;
  tariffSeq?: number;
  tariffSuppId?: string | null;
};
export type CarrInvLineQwVm = {
  billAsQty?: number | null;
  billAsQual?: string | null;
  carrierId?: string | null;
  dunnageDescr?: string | null;
  invIdx?: number | null;
  invoiceNum?: string | null;
  invRev?: number;
  ladingLine?: number;
  ladingQuant?: number | null;
  lineIdx?: number | null;
  lineSeq?: number;
  pkgFormCode?: string | null;
  pkgFormCode2?: string | null;
  quantity?: number | null;
  qwSeq?: number;
  recType?: string | null;
  svcTypeCode?: string | null;
  volQual?: string | null;
  volume?: number | null;
  weight?: number | null;
  wgtQual?: string | null;
  /** Make sure the default here is always L even if its empty in the database */
  wgtUnitCode?: string | null;
  wtKilos?: number | null;
  wtPounds?: number | null;
  wtTons?: number | null;
  yesNoCode?: string | null;
};
export type CarrInvLineMarksVm = {
  carrierId?: string | null;
  commCode?: string | null;
  commCode2?: string | null;
  commCodeQual?: string | null;
  commCodeQual2?: string | null;
  compartIdcode?: string | null;
  descrip?: string | null;
  idx?: number;
  invIdx?: number | null;
  invoiceNum?: string | null;
  invRev?: number;
  ladingLine?: number;
  lineIdx?: number | null;
  lineSeq?: number;
  marks?: string | null;
  marksQual?: string | null;
  marksSeq?: number;
  pkgCode?: string | null;
  recType?: string | null;
};
export type LineRcTariffQwMarksVm = {
  lineIndex?: number;
  empty?: boolean;
  rcVm?: CarrInvLineRcVm;
  tariffVm?: CarrInvLineTariffVm;
  qwVm?: CarrInvLineQwVm;
  marksVm?: CarrInvLineMarksVm;
};
export type InvoiceSummaryVm = {
  invoiceNum?: string | null;
  airBillNum?: string | null;
  invType?: string | null;
  carrier?: CarrierMinimalVm;
  shippedDate?: string | null;
  deliveredDate?: string | null;
  shipper?: PartyVm;
  consignee?: PartyVm;
  chargeDetails?: LineRcTariffQwMarksVm[] | null;
};
export type ApproveInvoicesRequestVm = {
  searchOptions?: InvoiceApprovalOptionsVm;
  invoices?: ApproveInvoicesCustomerVm[] | null;
};
export type ApproveInvoicesRequestVmRead = {
  searchOptions?: InvoiceApprovalOptionsVmRead;
  invoices?: ApproveInvoicesCustomerVm[] | null;
};
export type AscChargeCodeVm = {
  /** The ASC Charge Code */
  code: string;
  /** Description of the ASC Charge Code */
  description: string;
  /** Is the Charge Code currently in use? 'Y' or 'N' */
  inUse: string;
  /** Alternate version of the code to use in certain places */
  cmCode?: string | null;
  /** 1 or -1 */
  dbSign: number;
  /** Associated Invoice Charge Type */
  totalsColumn: string;
  /** Shorter description of the ASC Charge Code */
  shortDescription: string;
  /** 0 or 1 */
  backRef?: boolean | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type InvoiceChargeTypeVm = {
  /** Internal ID */
  id?: number;
  /** Name of the charge type */
  name?: string | null;
  /** Description of the charge type */
  description?: string | null;
};
export type AscReferenceCodeVm = {
  /** The specific ASC ref code being defined */
  code?: string | null;
  /** Description of the ASC ref code */
  description?: string | null;
  /** Is the code currently in use? (Y/N) */
  inUse?: string | null;
};
export type AuditMilesRequestVm = {
  originZip?: string | null;
  originCountryCode?: string | null;
  destinationZip?: string | null;
  destinationCountryCode?: string | null;
};
export type LoginVm = {
  userName?: string | null;
  password?: string | null;
};
export type ScreenSize = "sm" | "md" | "lg" | "xl";
export type CustomerReferenceCodeVm = {
  sortable?: boolean;
  id?: number;
  customerDescription?: string | null;
  displayOrder?: number;
  inUse?: string | null;
  hide?: ScreenSize;
  /** The specific ASC ref code being defined */
  code?: string | null;
  /** Description of the ASC ref code */
  description?: string | null;
};
export type CustomerReferenceCodeVmRead = {
  sortable?: boolean;
  id?: number;
  customerDescription?: string | null;
  displayOrder?: number;
  inUse?: string | null;
  name?: string | null;
  hide?: ScreenSize;
  /** The specific ASC ref code being defined */
  code?: string | null;
  /** Description of the ASC ref code */
  description?: string | null;
};
export type ColumnStateVm = {
  /** The aggregation function applied to the column (e.g., sum, avg). */
  aggFunction?: string | null;
  /** The unique identifier for the column. */
  colId?: string | null;
  /** The flex grow factor for the column width. */
  flex?: number | null;
  /** Indicates whether the column is hidden. */
  hide?: boolean | null;
  /** The pinned state of the column (e.g., left, right, or null for not pinned). */
  pinned?: string | null;
  /** Indicates whether the column is used as a pivot. */
  pivot?: boolean | null;
  /** The index of the column in the pivot configuration. */
  pivotIndex?: number | null;
  /** Indicates whether the column is used for row grouping. */
  rowGroup?: boolean | null;
  /** The index of the column in the row group configuration. */
  rowGroupIndex?: number | null;
  /** The sort direction for the column (e.g., asc, desc). */
  sort?: string | null;
  /** The index of the column in the sort order. */
  sortIndex?: number | null;
  /** The width of the column in pixels. */
  width?: number | null;
};
export type FilterStateVm = {
  /** The unique identifier for the filter. */
  filterId?: string | null;
  /** The type of the filter (e.g., text, number). */
  filterType?: string | null;
  /** The value of the filter. */
  filterValue?: string | null;
};
export type GridStateVm = {
  /** The unique identifier for the grid. */
  gridId?: string | null;
  /** The state of the columns in the grid. */
  columnState?: ColumnStateVm[] | null;
  /** The state of the filters applied to the grid. */
  filterState?: FilterStateVm[] | null;
};
export type UserConfigurationVm = {
  invoiceResearchCustomColumns?: CustomerReferenceCodeVm[] | null;
  gridStates?: GridStateVm[] | null;
};
export type UserConfigurationVmRead = {
  invoiceResearchCustomColumns?: CustomerReferenceCodeVmRead[] | null;
  gridStates?: GridStateVm[] | null;
};
export type UserPermissionVm = {
  functionId?: string | null;
  viewOk?: boolean;
  addOk?: boolean;
  editOk?: boolean;
  deleteOk?: boolean;
  exportOk?: boolean;
  logging?: boolean;
};
export type UserVm = {
  userConfiguration?: UserConfigurationVm;
  userID?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  displayName?: string | null;
  company?: string | null;
  email?: string | null;
  allowedBillToIds?: string[] | null;
  allowedCarrierIds?: string[] | null;
  permissions?: UserPermissionVm[] | null;
};
export type UserVmRead = {
  userConfiguration?: UserConfigurationVmRead;
  userID?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  displayName?: string | null;
  company?: string | null;
  email?: string | null;
  allowedBillToIds?: string[] | null;
  allowedCarrierIds?: string[] | null;
  permissions?: UserPermissionVm[] | null;
};
export type LoginResponseVm = {
  jwt?: string | null;
  user?: UserVm;
};
export type LoginResponseVmRead = {
  jwt?: string | null;
  user?: UserVmRead;
};
export type BankAccountVm = {
  /** DB ID for the bank account */
  id: number;
  /** Bank's Name */
  bankName?: string | null;
  /** Account # used at the bank */
  acctNum?: string | null;
  /** Informational nickname for the bank account */
  nickName?: string | null;
  /** Which "checkbook" to use */
  gpCheckbook?: string | null;
  /** Cash Account # */
  cashAcctGL?: string | null;
  /** Disbursement Account # */
  disbAcctGL?: string | null;
  /** Is this account for deposits? Uses -1 for True and 0 for False, so stored as an int */
  isDeposAcct?: number;
  /** Is this account for disbursements (aka writing checks)? Uses -1 for True and 0 for False, so stored as an int */
  isDisbursAcct?: number;
  /** Info on the account's purpose */
  purpose?: string | null;
  /** Which currency the account uses */
  currency?: string | null;
  /** Last check # used for the account */
  lastCheckNum?: number;
  /** Location of the template file used to print checks */
  checkTemplate?: string | null;
  /** Date format token to use when generating checks */
  dateFormat?: string | null;
  /** Number format token to use when generating check #s */
  checkNumFmt?: string | null;
};
export type BankAccountVmRead = {
  /** DB ID for the bank account */
  id: number;
  /** Bank's Name */
  bankName?: string | null;
  /** Account # used at the bank */
  acctNum?: string | null;
  /** Informational nickname for the bank account */
  nickName?: string | null;
  /** Which "checkbook" to use */
  gpCheckbook?: string | null;
  /** Cash Account # */
  cashAcctGL?: string | null;
  /** Disbursement Account # */
  disbAcctGL?: string | null;
  /** Is this account for deposits? Uses -1 for True and 0 for False, so stored as an int */
  isDeposAcct?: number;
  /** Is this account for disbursements (aka writing checks)? Uses -1 for True and 0 for False, so stored as an int */
  isDisbursAcct?: number;
  /** Info on the account's purpose */
  purpose?: string | null;
  /** Which currency the account uses */
  currency?: string | null;
  /** Last check # used for the account */
  lastCheckNum?: number;
  /** Location of the template file used to print checks */
  checkTemplate?: string | null;
  /** Date format token to use when generating checks */
  dateFormat?: string | null;
  /** Number format token to use when generating check #s */
  checkNumFmt?: string | null;
  /** Display name to use for bank accounts */
  displayName?: string | null;
};
export type BankAccountChangeVm = {
  /** DB ID for the bank account */
  id: number;
  /** Last check # used for the account */
  lastCheckNum: number;
  /** Reason for changing the last check number */
  changeReason: string;
};
export type BillToVm = {
  /** Is this Bill-To record active?
    Remapped from int to string through Automapper */
  active?: string | null;
  /** Bill-To ID to use for auto-billing */
  actualBtid?: string | null;
  /** Line 1 of the Bill-To's address */
  address1?: string | null;
  /** Line 2 of the Bill-To's address */
  address2?: string | null;
  /** The status to assign when max charge is exceeded */
  auditChargeStatus?: string | null;
  /** The status to assign when max class is exceeded */
  auditClassStatus?: string | null;
  /** The maximum total charge allowed by auto-audit */
  auditMaxCharge?: number;
  /** The maximum class allowed by auto-audit */
  auditMaxClass?: string | null;
  /** The maximum variance allowed by auto-audit */
  auditVarAllow?: number | null;
  /** The status to assign when maximum variance is exceeded */
  auditVarStatus?: string | null;
  /** Currently unused */
  autoWithdraw?: string | null;
  /** Internal bill-to ID */
  btId: string;
  /** Bill-To's city */
  city?: string | null;
  /** CM ID used for auditing */
  cmCustId?: number | null;
  /** ID of the customer to pay for Comdata */
  comDataCustId?: string | null;
  /** Bill-To-level comments */
  comments?: string | null;
  /** "Main" Bill-To contact email */
  contactEmail?: string | null;
  /** "Main" Bill-To contact name */
  contactName?: string | null;
  /** Bill-To's country */
  countryCode?: string | null;
  /** User who created this Bill-To record */
  createdBy?: string | null;
  /** When this Bill-To record was created */
  createdDate?: string | null;
  /** Bill-To ID of the parent customer
    If left blank, will be copy of current customer ID */
  customerId?: string | null;
  /** Name of the parent customer */
  parentName?: string | null;
  /** # of days to wait before paying by default */
  defaultPayDays?: number | null;
  /** What event to use as the "start" of wait time calculations
    Defined as a Category List */
  defaultPayDaysStart?: number | null;
  /** Default service to use in GL coding for all carriers */
  defCarrSvc?: string | null;
  /** Is the fee invoice emailed? */
  emailFeeInvoice?: boolean | null;
  /** Is IA import customer review enabled? */
  enableIaCustReview?: boolean;
  /** Is Match Pay enabled at the accessorial level? */
  enableMatchPayAccessorial?: boolean;
  /** Is Match Pay enabled at the liability level? */
  enableMatchPayLiability?: boolean;
  /** Is Match Pay enabled at the weight level? */
  enableMatchPayWeight?: boolean;
  /** FBO GL account # */
  fbogl?: string | null;
  /** Bill-To ID to use in fee reports (?) */
  feesRptBtid?: string | null;
  /** # of days to offset pay delay calculations to account for funding delays */
  fundsOffsetDays?: number | null;
  /** Function to use for GL Coding */
  glcodingFunction?: string | null;
  /** Is the fee invoice imported? */
  importFeeInvoice?: boolean | null;
  /** Is this Bill-To record flagged as a parent? */
  isParent?: boolean;
  /** When this record was last updated */
  lastUsed?: string | null;
  /** Are receivables made on Friday? */
  makeRecFri?: boolean;
  /** Are receivables made on Monday? */
  makeRecMon?: boolean;
  /** Are receivables made on Saturday? */
  makeRecSat?: boolean;
  /** Are receivables made on Sunday? */
  makeRecSun?: boolean;
  /** Are receivables made on Thursday? */
  makeRecThu?: boolean;
  /** Are receivables made on Tuesday? */
  makeRecTue?: boolean;
  /** Are receivables made on Wednesday? */
  makeRecWed?: boolean;
  /** Which Match Pay program does this customer use?
    Only defined for Harcros */
  matchPayProgram?: string | null;
  /** Freight Class Variance for Match Pay */
  matchPayWeightFreightClassVariance?: number;
  /** Total Weight Variance for Match Pay */
  matchPayWeightTotalVariance?: number;
  /** Lookup table to use for Match Pay
    Only defined for Harcros and Central Salt */
  matchTable?: string | null;
  /** Are miles required to be logged? */
  milesRequired?: boolean | null;
  /** Bill-To name */
  name: string;
  /** "Main" phone # for Bill-To */
  phone1Num?: string | null;
  /** Bill-To's postal code */
  postal?: string | null;
  /** Is the fee invoice printed? */
  printFeeInvoice?: boolean | null;
  /** A rating code */
  ratingCode?: string | null;
  /** Email addresses to use for SFR */
  sfremail?: string | null;
  /** Bill-To's state/province */
  stateProv?: string | null;
  /** Are CI and BI synced (?) */
  synchCibi?: boolean | null;
  /** T-n-C Date */
  tandCdate?: string | null;
  /** Who last updated this Bill-To record */
  updatedBy?: string | null;
  /** When this Bill-To was last updated */
  updatedDate?: string | null;
  /** Is audit benchmarking enabled? */
  useBenchmarking?: boolean | null;
  /** Is auditing enabled? */
  useCm?: string | null;
  /** Do we use pay-to-terms? */
  usePayToTerms?: boolean | null;
  /** Do we send Paper Invoices (as opposed to using SFR)? */
  useInvoice?: string | null;
  /** Do we send SFR (as opposed to Invoices)? */
  useSfr?: string | null;
  /** What user updated the carrier record's active status */
  activationStatusChangedBy?: string | null;
  /** When the carrier record's active status was last updated */
  activationStatusChangeDate?: string | null;
  /** Why the carrier record's active status was last updated */
  activationStatusChangeReason?: string | null;
};
export type CustomerDataEntryVm = {
  /** Internal ID for this ref-def entry */
  id: number;
  /** ID of the Bill-To this ref-def entry is for */
  btid: string;
  /** ID of the carrier this ref-def entry is for */
  carrierId: string;
  /** Which ASC Ref Code this ref-def entry is for */
  ascrefCode: string;
  /** Ordering number for fields in Data Entry.
    Main number controls which section of the form the field appears in
    Decimal value controls order within a sub-field area */
  dispOrder?: number;
  /** Bill-To-specific description of the ASC Ref Code */
  customerDescription?: string | null;
  /** Does this code allow multiple values in Data Entry? */
  allowMulti?: string | null;
  /** Does this code require a value in Data Entry? */
  requiredFieldIndicator?: string | null;
  /** Where this code is used in Carrier Invoices (?)
    Appears to be a legacy field */
  detailLocation?: string | null;
  /** Which mask pattern (if any) defines a valid value for this field */
  fieldFormat?: string | null;
  /** Which validation method (if any) is used for this field
    "Permitted Values" is the only extant option */
  validationTechnique?: string | null;
  /** Tooltip text for the field */
  tipText?: string | null;
};
export type BillToMatchTableVm = {
  /** Internal bill-to ID */
  btId: string;
  /** Lookup table to use for Match Pay */
  matchTable?: string | null;
  /** Bill-To name */
  name: string;
};
export type BillToActiveVm = {
  /** Internal bill-to ID */
  btId: string;
  /** Is this Bill-To record active? */
  active: number;
  /** What user updated the carrier record's active status */
  activationStatusChangedBy?: string | null;
  /** When the carrier record's active status was last updated */
  activationStatusChangeDate?: string | null;
  /** Why the carrier record's active status was last updated */
  activationStatusChangeReason: string;
};
export type BillToFeeInvoiceVm = {
  /** ID of the Bill-To this Fee Invoice setup is for */
  btid: string;
  /** Do parent-level Fee Invoices combine child Fee Invoices? */
  parentLevelInvoice?: boolean | null;
  /** Primary Bill-To to use for Sunset Child Bill-Tos */
  primaryBillTo?: string | null;
  /** Comment explaining primary bill-to linkage */
  internalComment?: string | null;
  /** Name of the report to use for combined parent/child Fee Invoices */
  reportName?: string | null;
  /** Date to stop applying fee invoices */
  stopDate?: string | null;
  /** Does a Child Bill-To use the Parent Bill-To's rules? */
  parentRules?: boolean | null;
};
export type BillToModeDefaultVm = {
  /** GUID for this default setup */
  id?: string | null;
  /** Which customer this default is for */
  btid: string;
  /** Which carrier (if not ANY) this default is for */
  carrierId?: string | null;
  /** Name of the carrier this default is for */
  carrierName?: string | null;
  /** Which mode to default in for this customer/carrier combo */
  mode: string;
  /** How many net-due days to default in for this customer/carrier combo */
  netDueDays: number;
  /** Which net-due start date to default in for this customer/carrier combo */
  netDueStart: number;
};
export type BtAccountRulesVm = {
  /** Internal ID for a rule entry */
  idx?: number;
  /** ID of the Bill-To this GL Coding rule is for */
  btId: string;
  /** ID of the Carrier (or * for 'any') that must exist on the Carrier Invoice to match the rule */
  carrierId?: string | null;
  /** An origin postal code that, if defined, must exist on the Carrier Invoice to match the rule
    This property supports SQL wildcards */
  originPostal?: string | null;
  /** An origin country that, if defined, must exist on the Carrier Invoice to match the rule */
  originCountry?: string | null;
  /** A destination postal code that, if defined, must exist on the Carrier Invoice to match the rule
    This property supports SQL wildcards */
  destPostal?: string | null;
  /** A destination country that, if defined, must exist on the Carrier Invoice to match the rule */
  destCountry?: string | null;
  /** A shipper name that, if defined, must exist on the Carrier Invoice to match the rule
    This property supports SQL wildcards */
  shipName?: string | null;
  /** A consignee name that, if defined, must exist on the Carrier Invoice to match the rule
    This property supports SQL wildcards */
  cnsname?: string | null;
  /** The date at which this rule comes into effect */
  effectiveDate?: string;
  /** The GL code to apply to the Carrier Invoice if the rule passes */
  accountNumber: string;
  /** An ASC Ref Code that, if defined, must exist with an associated value on the Carrier Invoice to match the rule */
  refCol?: string | null;
  /** The value that the linked ASC Ref Code must have on the Carrier Invoice to match the rule
    This property supports SQL wildcards */
  refVal?: string | null;
  /** What order these GL Coding rules are run for the Bill-To */
  rank?: number;
  /** A PURPOSE value that, if defined, must exist on the Carrier Invoice to match the rule */
  purpose?: string | null;
  /** A SERVICE value that, if defined, must exist on the Carrier Invoice to match the rule */
  service?: string | null;
};
export type BtCodingGridVm = {
  /** Internal ID for a Carrier Invoice to be GL Coded */
  invIdx?: number;
  /** Internal ID for a Carrier Invoice Line to be GL Coded */
  lineIdx?: number | null;
  /** Batch date (if any) for a Carrier Invoice */
  batchDate?: string | null;
  /** Name of the Carrier the Carrier Invoice is for */
  carrierName?: string | null;
  /** The Invoice # on the Carrier Invoice */
  invNum?: string | null;
  /** The Shipment # (if any) on the Carrier Invoice */
  shipNum?: string | null;
  /** The Purpose set on the Carrier Invoice */
  purpose?: string | null;
  /** The Service set on the Carrier Invoice */
  service?: string | null;
  /** Information about the GL Coding rule applied to the Carrier Invoice */
  ruleInfo?: string | null;
  /** The GL code type (if any) on the Carrier Invoice */
  glCodeRef?: string | null;
  /** The GL code (if any) on the Carrier Invoice */
  glCode?: string | null;
};
export type BtCodingRequestVm = {
  /** Internal ID for a Carrier Invoice to be GL Coded */
  invIdx: number;
  /** Internal ID for a Carrier Invoice Line to be GL Coded */
  lineIdx?: number | null;
};
export type BtCodingQueueVm = {
  /** ID of the Customer to GL Code Carrier Invoices for */
  customerId: string;
  /** Start date for Carrier Invoices to locate for GL Coding */
  startDate: string;
  /** If recoding a date range, the end of the range */
  endDate?: string | null;
};
export type CarrBtMapVm = {
  /** ID of the Carrier this mapping is for */
  carrierId: string;
  /** Account # the carrier is mapping to a customer */
  carrAcct: string;
  /** ID of the customer the account is mapped to */
  btId: string;
  /** Name of the customer the account is mapped to (display only) */
  btName?: string | null;
  /** Shipper Customer ID */
  fpsCustId?: string | null;
  /** Is this mapping live? */
  isProduction?: boolean | null;
};
export type CheckInfoVm = {
  /** The check's number */
  checkNum?: number;
  /** The account ID the check draws from */
  acctNum?: string | null;
  /** How much the check is for */
  checkAmt?: number;
  /** When the check was sent out */
  checkDate?: string;
  /** ID of the customer the check is for */
  billToId?: string | null;
  /** Name of the customer the check is for */
  billToName?: string | null;
  /** ID of the carrier the check is for */
  paidToCarrierId?: string | null;
  /** Name of the carrier the check is for */
  carrierName?: string | null;
  /** The customer's FBO GL code */
  fbogl?: string | null;
  /** ID of the user who voided the check */
  voidBy?: string | null;
  /** When the check was voided */
  voidDate?: string;
  /** Is this check currently selected in the client grid? */
  selected?: boolean;
};
export type CheckInfoSearchVm = {
  /** ID of the account to search for checks */
  paidFromAccount: string;
  /** Check # to start including from */
  startCheckNumber?: number | null;
  /** Check # to stop including from */
  endCheckNumber?: number | null;
  /** Date to start including from */
  startDate?: string | null;
  /** Date to stop including from */
  endDate?: string | null;
};
export type CarrierCheckRemitViewModel = {
  carrier?: string | null;
  checkAmt?: number;
  checkCurrency?: string | null;
  checkDate?: string;
  checkNum?: number;
  isaCtrlNum820?: number;
  paidToCarrierId?: string | null;
  rcvID820?: string | null;
  rcvIDQual820?: string | null;
  remitDeliverHow?: string | null;
  remitDirectory?: string | null;
  remitS3Key?: string | null;
  remitEffective?: string;
  remitEmail?: string | null;
  remitFormat?: string | null;
  shipperAccount?: string | null;
  customerName?: string | null;
  fileNameMask?: string | null;
};
export type ProcessCheckProcessedArgs = {
  carrierName?: string | null;
  remitDirectory?: string | null;
  remitFormat?: string | null;
  checkAmount?: number;
  checkNumber?: number;
  succeeded?: boolean;
  errorMessage?: string | null;
};
export type CheckS3FileInfo = {
  fileName?: string | null;
  lastModified?: string;
  fileSize?: number;
};
export type CarrEdiMasterVm = {
  /** EDI Sender Qualifier */
  ediSenderQual: string;
  /** EDI Sender ID */
  ediSenderId: string;
  /** EDI Type */
  ediXactType: string;
  /** EDI Receiver Qualifier */
  ediRcvQual: string;
  /** EDI Receiver ID */
  ediRcvId: string;
  /** ID of the Carrier EDI files are received from */
  carrierId: string;
  /** ID of the default customer to assign EDI files to */
  fpsCarrId?: string | null;
  /** Does this EDI use the C2 segment? Y or N
    This identifies the account number used to map to a Bill-To via CarrBtMap */
  useC2?: string | null;
  /** What kind of 820 info does this EDI send */
  send820?: string | null;
  /** Does this EDI get processed (or is it a dummy location for recieving)? Y or N */
  procFps?: string | null;
};
export type CarrFamVm = {
  /** Carrier Family ID
    Often just the name */
  carrierFam: string;
  /** Carrier Family Description */
  description?: string | null;
  /** Parent Family ID (for hierarchical relationships) */
  parentFamilyId?: string | null;
  /** Is the carrier family active */
  isActive?: boolean;
  /** Number of carriers in this family */
  memberCount?: number;
  /** Parent family name (for display) */
  parentFamilyName?: string | null;
};
export type CarrierFamilyMemberVm = {
  carrierId?: string | null;
  carrierName?: string | null;
  isActive?: boolean;
  familyId?: string | null;
};
export type CarrFamTreeNodeVm = {
  familyId?: string | null;
  familyName?: string | null;
  description?: string | null;
  parentFamilyId?: string | null;
  isActive?: boolean;
  memberCount?: number;
  children?: CarrFamTreeNodeVm[] | null;
  carriers?: CarrierFamilyMemberVm[] | null;
};
export type CreateCarrFamRequest = {
  familyName: string;
  description?: string | null;
  parentFamilyId?: string | null;
  isActive?: boolean;
};
export type UpdateCarrFamRequest = {
  familyId: string;
  description?: string | null;
  parentFamilyId?: string | null;
  isActive?: boolean;
};
export type AssignCarrierToFamilyRequest = {
  familyId: string;
  carrierId: string;
};
export type CarrierChargeCodeSource = "L108" | "L112" | "Ia";
export type CarrierChargeCodeMappingVm = {
  carrierId: string;
  description?: string | null;
  id?: number;
  carrier?: CarrierMinimalVm;
  carrierName?: string | null;
  originalChargeCode: string;
  source: CarrierChargeCodeSource;
  mappedChargeCode: string;
  mappedCode?: AscChargeCodeVm;
};
export type CarrierChargeCodeMappingVmRead = {
  carrierId: string;
  description?: string | null;
  id?: number;
  carrier?: CarrierMinimalVm;
  carrierName?: string | null;
  originalChargeCode: string;
  source: CarrierChargeCodeSource;
  mappedChargeCode: string;
  mappedCode?: AscChargeCodeVm;
  /** AscChargeCode property, pulled up to make display logic easier */
  codeDescription?: string | null;
  /** AscChargeCode property, pulled up to make display logic easier */
  totalsColumn?: string | null;
  /** AscChargeCode property, pulled up to make display logic easier */
  dbSign?: number | null;
  /** AscChargeCode property, pulled up to make display logic easier */
  cmCode?: string | null;
};
export type PipeWriter = {};
export type PipeWriterRead = {
  canGetUnflushedBytes?: boolean;
  unflushedBytes?: number;
};
export type IResponseCookies = object;
export type HttpResponse = {
  httpContext?: HttpContext;
  statusCode?: number;
  body?: Blob | null;
  bodyWriter?: PipeWriter;
  contentLength?: number | null;
  contentType?: string | null;
  cookies?: IResponseCookies;
};
export type HttpResponseRead = {
  httpContext?: HttpContext;
  statusCode?: number;
  headers?: {
    [key: string]: string[];
  } | null;
  body?: Blob | null;
  bodyWriter?: PipeWriterRead;
  contentLength?: number | null;
  contentType?: string | null;
  cookies?: IResponseCookies;
  hasStarted?: boolean;
};
export type AddressFamily =
  | "Unspecified"
  | "Unix"
  | "InterNetwork"
  | "ImpLink"
  | "Pup"
  | "Chaos"
  | "Ipx"
  | "Osi"
  | "Ecma"
  | "DataKit"
  | "Ccitt"
  | "Sna"
  | "DecNet"
  | "DataLink"
  | "Lat"
  | "HyperChannel"
  | "AppleTalk"
  | "NetBios"
  | "VoiceView"
  | "FireFox"
  | "Banyan"
  | "Atm"
  | "InterNetworkV6"
  | "Cluster"
  | "Ieee12844"
  | "Irda"
  | "NetworkDesigners"
  | "Max"
  | "Packet"
  | "ControllerAreaNetwork"
  | "Unknown";
export type IpAddress = {
  addressFamily?: AddressFamily;
  scopeId?: number;
  address?: number;
};
export type IpAddressRead = {
  addressFamily?: AddressFamily;
  scopeId?: number;
  isIPv6Multicast?: boolean;
  isIPv6LinkLocal?: boolean;
  isIPv6SiteLocal?: boolean;
  isIPv6Teredo?: boolean;
  isIPv6UniqueLocal?: boolean;
  isIPv4MappedToIPv6?: boolean;
  address?: number;
};
export type AsymmetricAlgorithm = {
  keySize?: number;
};
export type KeySizes = {
  minSize?: number;
  maxSize?: number;
  skipSize?: number;
};
export type AsymmetricAlgorithmRead = {
  keySize?: number;
  legalKeySizes?: KeySizes[] | null;
  signatureAlgorithm?: string | null;
  keyExchangeAlgorithm?: string | null;
};
export type Oid = {
  value?: string | null;
  friendlyName?: string | null;
};
export type X500DistinguishedName = {
  oid?: Oid;
  rawData?: string | null;
};
export type X500DistinguishedNameRead = {
  name?: string | null;
  oid?: Oid;
  rawData?: string | null;
};
export type AsnEncodedData = {
  oid?: Oid;
  rawData?: string | null;
};
export type PublicKey = {
  encodedKeyValue?: AsnEncodedData;
  encodedParameters?: AsnEncodedData;
  key?: AsymmetricAlgorithm;
  oid?: Oid;
};
export type PublicKeyRead = {
  encodedKeyValue?: AsnEncodedData;
  encodedParameters?: AsnEncodedData;
  key?: AsymmetricAlgorithmRead;
  oid?: Oid;
};
export type ByteReadOnlyMemory = {
  length?: number;
};
export type ByteReadOnlyMemoryRead = {
  length?: number;
  isEmpty?: boolean;
};
export type X509Certificate2 = {
  archived?: boolean;
  friendlyName?: string | null;
  privateKey?: AsymmetricAlgorithm;
  issuerName?: X500DistinguishedName;
  publicKey?: PublicKey;
  rawData?: string | null;
  rawDataMemory?: ByteReadOnlyMemory;
  signatureAlgorithm?: Oid;
  subjectName?: X500DistinguishedName;
  handle?: any;
  serialNumberBytes?: ByteReadOnlyMemory;
};
export type X509Extension = {
  critical?: boolean;
  oid?: Oid;
  rawData?: string | null;
};
export type X509Certificate2Read = {
  archived?: boolean;
  extensions?: X509Extension[] | null;
  friendlyName?: string | null;
  hasPrivateKey?: boolean;
  privateKey?: AsymmetricAlgorithmRead;
  issuerName?: X500DistinguishedNameRead;
  notAfter?: string;
  notBefore?: string;
  publicKey?: PublicKeyRead;
  rawData?: string | null;
  rawDataMemory?: ByteReadOnlyMemoryRead;
  serialNumber?: string | null;
  signatureAlgorithm?: Oid;
  subjectName?: X500DistinguishedNameRead;
  thumbprint?: string | null;
  version?: number;
  handle?: any;
  issuer?: string | null;
  subject?: string | null;
  serialNumberBytes?: ByteReadOnlyMemoryRead;
};
export type ConnectionInfo = {
  id?: string | null;
  remoteIpAddress?: IpAddress;
  remotePort?: number;
  localIpAddress?: IpAddress;
  localPort?: number;
  clientCertificate?: X509Certificate2;
};
export type ConnectionInfoRead = {
  id?: string | null;
  remoteIpAddress?: IpAddressRead;
  remotePort?: number;
  localIpAddress?: IpAddressRead;
  localPort?: number;
  clientCertificate?: X509Certificate2Read;
};
export type WebSocketManager = {};
export type WebSocketManagerRead = {
  isWebSocketRequest?: boolean;
  webSocketRequestedProtocols?: string[] | null;
};
export type Claim = {
  issuer?: string | null;
  originalIssuer?: string | null;
  subject?: ClaimsIdentity;
  type?: string | null;
  value?: string | null;
  valueType?: string | null;
};
export type ClaimRead = {
  issuer?: string | null;
  originalIssuer?: string | null;
  properties?: {
    [key: string]: string;
  } | null;
  subject?: ClaimsIdentity;
  type?: string | null;
  value?: string | null;
  valueType?: string | null;
};
export type ClaimsIdentity = {
  authenticationType?: string | null;
  actor?: ClaimsIdentity;
  bootstrapContext?: any | null;
  claims?: Claim[] | null;
  label?: string | null;
};
export type ClaimsIdentityRead = {
  authenticationType?: string | null;
  isAuthenticated?: boolean;
  actor?: ClaimsIdentityRead;
  bootstrapContext?: any | null;
  claims?: ClaimRead[] | null;
  label?: string | null;
  name?: string | null;
  nameClaimType?: string | null;
  roleClaimType?: string | null;
};
export type IIdentity = {};
export type IIdentityRead = {
  name?: string | null;
  authenticationType?: string | null;
  isAuthenticated?: boolean;
};
export type ClaimsPrincipal = {
  identities?: ClaimsIdentity[] | null;
  identity?: IIdentity;
};
export type ClaimsPrincipalRead = {
  claims?: ClaimRead[] | null;
  identities?: ClaimsIdentityRead[] | null;
  identity?: IIdentityRead;
};
export type IServiceProvider = object;
export type SafeWaitHandle = {};
export type SafeWaitHandleRead = {
  isInvalid?: boolean;
  isClosed?: boolean;
};
export type WaitHandle = {
  handle?: any;
  safeWaitHandle?: SafeWaitHandle;
};
export type WaitHandleRead = {
  handle?: any;
  safeWaitHandle?: SafeWaitHandleRead;
};
export type CancellationToken = {
  waitHandle?: WaitHandle;
};
export type CancellationTokenRead = {
  isCancellationRequested?: boolean;
  canBeCanceled?: boolean;
  waitHandle?: WaitHandleRead;
};
export type ISession = {};
export type ISessionRead = {
  isAvailable?: boolean;
  id?: string | null;
  keys?: string[] | null;
};
export type HttpContext = {
  request?: HttpRequest;
  response?: HttpResponse;
  connection?: ConnectionInfo;
  webSockets?: WebSocketManager;
  user?: ClaimsPrincipal;
  items?: {
    [key: string]: any | null;
  } | null;
  requestServices?: IServiceProvider;
  requestAborted?: CancellationToken;
  traceIdentifier?: string | null;
  session?: ISession;
};
export type TypeObjectKeyValuePair = {
  key?: string | null;
  value?: any | null;
};
export type HttpContextRead = {
  features?: TypeObjectKeyValuePair[] | null;
  request?: HttpRequest;
  response?: HttpResponseRead;
  connection?: ConnectionInfoRead;
  webSockets?: WebSocketManagerRead;
  user?: ClaimsPrincipalRead;
  items?: {
    [key: string]: any | null;
  } | null;
  requestServices?: IServiceProvider;
  requestAborted?: CancellationTokenRead;
  traceIdentifier?: string | null;
  session?: ISessionRead;
};
export type HostString = {
  value?: string | null;
  host?: string | null;
  port?: number | null;
};
export type HostStringRead = {
  value?: string | null;
  hasValue?: boolean;
  host?: string | null;
  port?: number | null;
};
export type QueryString = {
  value?: string | null;
};
export type QueryStringRead = {
  value?: string | null;
  hasValue?: boolean;
};
export type StringStringValuesKeyValuePair = {
  key?: string | null;
  value?: string[];
};
export type StringStringKeyValuePair = {
  key?: string | null;
  value?: string | null;
};
export type HttpRequest = {
  httpContext?: HttpContext;
  method?: string | null;
  scheme?: string | null;
  isHttps?: boolean;
  host?: HostString;
  pathBase?: string;
  path?: string;
  queryString?: QueryString;
  query?: StringStringValuesKeyValuePair[] | null;
  protocol?: string | null;
  cookies?: StringStringKeyValuePair[] | null;
  contentLength?: number | null;
  contentType?: string | null;
  body?: Blob | null;
  form?: StringStringValuesKeyValuePair[] | null;
  routeValues?: {
    [key: string]: any;
  } | null;
};
export type HttpRequestRead = {
  httpContext?: HttpContextRead;
  method?: string | null;
  scheme?: string | null;
  isHttps?: boolean;
  host?: HostStringRead;
  pathBase?: string;
  path?: string;
  queryString?: QueryStringRead;
  query?: StringStringValuesKeyValuePair[] | null;
  protocol?: string | null;
  headers?: {
    [key: string]: string[];
  } | null;
  cookies?: StringStringKeyValuePair[] | null;
  contentLength?: number | null;
  contentType?: string | null;
  body?: Blob | null;
  bodyReader?: Blob | null;
  hasFormContentType?: boolean;
  form?: StringStringValuesKeyValuePair[] | null;
  routeValues?: {
    [key: string]: any;
  } | null;
};
export type DefaultQueryConfigurations = {
  enableExpand?: boolean;
  enableSelect?: boolean;
  enableCount?: boolean;
  enableOrderBy?: boolean;
  enableFilter?: boolean;
  maxTop?: number | null;
  enableSkipToken?: boolean;
};
export type IEdmDirectValueAnnotationsManager = object;
export type EdmSchemaElementKind =
  | "None"
  | "TypeDefinition"
  | "Term"
  | "Action"
  | "EntityContainer"
  | "Function";
export type IEdmEntityContainer = {
  schemaElementKind?: EdmSchemaElementKind;
};
export type EdmContainerElementKind =
  | "None"
  | "EntitySet"
  | "ActionImport"
  | "FunctionImport"
  | "Singleton";
export type IEdmEntityContainerElement = {
  containerElementKind?: EdmContainerElementKind;
  container?: IEdmEntityContainer;
};
export type IEdmEntityContainerElementRead = {
  containerElementKind?: EdmContainerElementKind;
  container?: IEdmEntityContainerRead;
  name?: string | null;
};
export type IEdmEntityContainerRead = {
  elements?: IEdmEntityContainerElementRead[] | null;
  schemaElementKind?: EdmSchemaElementKind;
  namespace?: string | null;
  name?: string | null;
};
export type IEdmModel = {
  directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager;
  entityContainer?: IEdmEntityContainer;
};
export type IEdmSchemaElement = {
  schemaElementKind?: EdmSchemaElementKind;
};
export type IEdmSchemaElementRead = {
  schemaElementKind?: EdmSchemaElementKind;
  namespace?: string | null;
  name?: string | null;
};
export type EdmTypeKind =
  | "None"
  | "Primitive"
  | "Entity"
  | "Complex"
  | "Collection"
  | "EntityReference"
  | "Enum"
  | "TypeDefinition"
  | "Untyped"
  | "Path";
export type IEdmType = {
  typeKind?: EdmTypeKind;
};
export type IEdmTypeReference = {
  definition?: IEdmType;
};
export type IEdmTypeReferenceRead = {
  isNullable?: boolean;
  definition?: IEdmType;
};
export type IEdmTerm = {
  type?: IEdmTypeReference;
  schemaElementKind?: EdmSchemaElementKind;
};
export type IEdmTermRead = {
  type?: IEdmTypeReferenceRead;
  appliesTo?: string | null;
  defaultValue?: string | null;
  schemaElementKind?: EdmSchemaElementKind;
  namespace?: string | null;
  name?: string | null;
};
export type IEdmVocabularyAnnotatable = object;
export type EdmExpressionKind =
  | "None"
  | "BinaryConstant"
  | "BooleanConstant"
  | "DateTimeOffsetConstant"
  | "DecimalConstant"
  | "FloatingConstant"
  | "GuidConstant"
  | "IntegerConstant"
  | "StringConstant"
  | "DurationConstant"
  | "Null"
  | "Record"
  | "Collection"
  | "Path"
  | "If"
  | "Cast"
  | "IsOf"
  | "FunctionApplication"
  | "LabeledExpressionReference"
  | "Labeled"
  | "PropertyPath"
  | "NavigationPropertyPath"
  | "DateConstant"
  | "TimeOfDayConstant"
  | "EnumMember"
  | "AnnotationPath";
export type IEdmExpression = {
  expressionKind?: EdmExpressionKind;
};
export type IEdmVocabularyAnnotation = {
  term?: IEdmTerm;
  target?: IEdmVocabularyAnnotatable;
  value?: IEdmExpression;
};
export type IEdmVocabularyAnnotationRead = {
  qualifier?: string | null;
  term?: IEdmTermRead;
  target?: IEdmVocabularyAnnotatable;
  value?: IEdmExpression;
  usesDefault?: boolean;
};
export type IEdmModelRead = {
  schemaElements?: IEdmSchemaElementRead[] | null;
  vocabularyAnnotations?: IEdmVocabularyAnnotationRead[] | null;
  referencedModels?: IEdmModelRead[] | null;
  declaredNamespaces?: string[] | null;
  directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager;
  entityContainer?: IEdmEntityContainerRead;
};
export type IEdmPathExpression = {
  expressionKind?: EdmExpressionKind;
};
export type IEdmPathExpressionRead = {
  pathSegments?: string[] | null;
  path?: string | null;
  expressionKind?: EdmExpressionKind;
};
export type IEdmStructuredType = {
  baseType?: IEdmStructuredType;
  typeKind?: EdmTypeKind;
};
export type EdmPropertyKind = "None" | "Structural" | "Navigation";
export type IEdmProperty = {
  propertyKind?: EdmPropertyKind;
  type?: IEdmTypeReference;
  declaringType?: IEdmStructuredType;
};
export type IEdmPropertyRead = {
  propertyKind?: EdmPropertyKind;
  type?: IEdmTypeReferenceRead;
  declaringType?: IEdmStructuredTypeRead;
  name?: string | null;
};
export type IEdmStructuredTypeRead = {
  isAbstract?: boolean;
  isOpen?: boolean;
  baseType?: IEdmStructuredTypeRead;
  declaredProperties?: IEdmPropertyRead[] | null;
  typeKind?: EdmTypeKind;
};
export type IEdmEntityType = {
  baseType?: IEdmStructuredType;
  typeKind?: EdmTypeKind;
  schemaElementKind?: EdmSchemaElementKind;
};
export type IEdmStructuralProperty = {
  propertyKind?: EdmPropertyKind;
  type?: IEdmTypeReference;
  declaringType?: IEdmStructuredType;
};
export type IEdmStructuralPropertyRead = {
  defaultValueString?: string | null;
  propertyKind?: EdmPropertyKind;
  type?: IEdmTypeReferenceRead;
  declaringType?: IEdmStructuredTypeRead;
  name?: string | null;
};
export type IEdmEntityTypeRead = {
  declaredKey?: IEdmStructuralPropertyRead[] | null;
  hasStream?: boolean;
  isAbstract?: boolean;
  isOpen?: boolean;
  baseType?: IEdmStructuredTypeRead;
  declaredProperties?: IEdmPropertyRead[] | null;
  typeKind?: EdmTypeKind;
  schemaElementKind?: EdmSchemaElementKind;
  namespace?: string | null;
  name?: string | null;
};
export type IEdmNavigationSource = {
  path?: IEdmPathExpression;
  type?: IEdmType;
  entityType?: IEdmEntityType;
};
export type EdmOnDeleteAction = "None" | "Cascade";
export type IEdmReferentialConstraint = {};
export type EdmReferentialConstraintPropertyPair = {
  dependentProperty?: IEdmStructuralProperty;
  principalProperty?: IEdmStructuralProperty;
};
export type EdmReferentialConstraintPropertyPairRead = {
  dependentProperty?: IEdmStructuralPropertyRead;
  principalProperty?: IEdmStructuralPropertyRead;
};
export type IEdmReferentialConstraintRead = {
  propertyPairs?: EdmReferentialConstraintPropertyPairRead[] | null;
};
export type IEdmNavigationProperty = {
  partner?: IEdmNavigationProperty;
  onDelete?: EdmOnDeleteAction;
  referentialConstraint?: IEdmReferentialConstraint;
  propertyKind?: EdmPropertyKind;
  type?: IEdmTypeReference;
  declaringType?: IEdmStructuredType;
};
export type IEdmNavigationPropertyRead = {
  partner?: IEdmNavigationPropertyRead;
  onDelete?: EdmOnDeleteAction;
  containsTarget?: boolean;
  referentialConstraint?: IEdmReferentialConstraintRead;
  propertyKind?: EdmPropertyKind;
  type?: IEdmTypeReferenceRead;
  declaringType?: IEdmStructuredTypeRead;
  name?: string | null;
};
export type IEdmNavigationPropertyBinding = {
  navigationProperty?: IEdmNavigationProperty;
  target?: IEdmNavigationSource;
  path?: IEdmPathExpression;
};
export type IEdmNavigationPropertyBindingRead = {
  navigationProperty?: IEdmNavigationPropertyRead;
  target?: IEdmNavigationSourceRead;
  path?: IEdmPathExpressionRead;
};
export type IEdmNavigationSourceRead = {
  navigationPropertyBindings?: IEdmNavigationPropertyBindingRead[] | null;
  path?: IEdmPathExpressionRead;
  type?: IEdmType;
  entityType?: IEdmEntityTypeRead;
  name?: string | null;
};
export type ODataPathSegment = {
  edmType?: IEdmType;
  identifier?: string | null;
};
export type ODataQueryContext = {
  defaultQueryConfigurations?: DefaultQueryConfigurations;
  model?: IEdmModel;
  elementType?: IEdmType;
  navigationSource?: IEdmNavigationSource;
  elementClrType?: string | null;
  path?: ODataPathSegment[] | null;
  requestContainer?: IServiceProvider;
};
export type ODataQueryContextRead = {
  defaultQueryConfigurations?: DefaultQueryConfigurations;
  model?: IEdmModelRead;
  elementType?: IEdmType;
  navigationSource?: IEdmNavigationSourceRead;
  elementClrType?: string | null;
  path?: ODataPathSegment[] | null;
  requestContainer?: IServiceProvider;
};
export type ODataRawQueryOptions = {};
export type ODataRawQueryOptionsRead = {
  filter?: string | null;
  apply?: string | null;
  compute?: string | null;
  search?: string | null;
  orderBy?: string | null;
  top?: string | null;
  skip?: string | null;
  select?: string | null;
  expand?: string | null;
  count?: string | null;
  format?: string | null;
  skipToken?: string | null;
  deltaToken?: string | null;
};
export type QueryNodeKind =
  | "None"
  | "Constant"
  | "Convert"
  | "NonResourceRangeVariableReference"
  | "BinaryOperator"
  | "UnaryOperator"
  | "SingleValuePropertyAccess"
  | "CollectionPropertyAccess"
  | "SingleValueFunctionCall"
  | "Any"
  | "CollectionNavigationNode"
  | "SingleNavigationNode"
  | "SingleValueOpenPropertyAccess"
  | "SingleResourceCast"
  | "All"
  | "CollectionResourceCast"
  | "ResourceRangeVariableReference"
  | "SingleResourceFunctionCall"
  | "CollectionFunctionCall"
  | "CollectionResourceFunctionCall"
  | "NamedFunctionParameter"
  | "ParameterAlias"
  | "EntitySet"
  | "KeyLookup"
  | "SearchTerm"
  | "CollectionOpenPropertyAccess"
  | "CollectionComplexNode"
  | "SingleComplexNode"
  | "Count"
  | "SingleValueCast"
  | "CollectionPropertyNode"
  | "AggregatedCollectionPropertyNode"
  | "In"
  | "CollectionConstant"
  | "RootPath"
  | "CustomQueryOption";
export type SingleValueNode = {
  typeReference?: IEdmTypeReference;
  kind?: QueryNodeKind;
};
export type SingleValueNodeRead = {
  typeReference?: IEdmTypeReferenceRead;
  kind?: QueryNodeKind;
};
export type ComputeExpression = {
  expression?: SingleValueNode;
  alias?: string | null;
  typeReference?: IEdmTypeReference;
};
export type ComputeExpressionRead = {
  expression?: SingleValueNodeRead;
  alias?: string | null;
  typeReference?: IEdmTypeReferenceRead;
};
export type ComputeClause = {
  computedItems?: ComputeExpression[] | null;
};
export type ComputeClauseRead = {
  computedItems?: ComputeExpressionRead[] | null;
};
export type IComputeQueryValidator = object;
export type ComputeQueryOption = {
  context?: ODataQueryContext;
  computeClause?: ComputeClause;
  rawValue?: string | null;
  validator?: IComputeQueryValidator;
};
export type ComputeQueryOptionRead = {
  context?: ODataQueryContextRead;
  resultClrType?: string | null;
  computeClause?: ComputeClauseRead;
  rawValue?: string | null;
  validator?: IComputeQueryValidator;
};
export type ISelectExpandQueryValidator = object;
export type SelectItem = object;
export type SelectExpandClause = {
  selectedItems?: SelectItem[] | null;
  allSelected?: boolean;
};
export type SelectExpandQueryOption = {
  context?: ODataQueryContext;
  compute?: ComputeQueryOption;
  validator?: ISelectExpandQueryValidator;
  selectExpandClause?: SelectExpandClause;
  levelsMaxLiteralExpansionDepth?: number;
};
export type SelectExpandQueryOptionRead = {
  context?: ODataQueryContextRead;
  rawSelect?: string | null;
  rawExpand?: string | null;
  compute?: ComputeQueryOptionRead;
  validator?: ISelectExpandQueryValidator;
  selectExpandClause?: SelectExpandClause;
  levelsMaxLiteralExpansionDepth?: number;
};
export type TransformationNodeKind =
  | "Aggregate"
  | "GroupBy"
  | "Filter"
  | "Compute"
  | "Expand";
export type TransformationNode = {
  kind?: TransformationNodeKind;
};
export type ApplyClause = {
  transformations?: TransformationNode[] | null;
};
export type ApplyQueryOption = {
  context?: ODataQueryContext;
  applyClause?: ApplyClause;
  rawValue?: string | null;
};
export type ApplyQueryOptionRead = {
  context?: ODataQueryContextRead;
  resultClrType?: string | null;
  applyClause?: ApplyClause;
  rawValue?: string | null;
};
export type IFilterQueryValidator = object;
export type RangeVariable = {
  typeReference?: IEdmTypeReference;
};
export type RangeVariableRead = {
  name?: string | null;
  typeReference?: IEdmTypeReferenceRead;
  kind?: number;
};
export type FilterClause = {
  expression?: SingleValueNode;
  rangeVariable?: RangeVariable;
  itemType?: IEdmTypeReference;
};
export type FilterClauseRead = {
  expression?: SingleValueNodeRead;
  rangeVariable?: RangeVariableRead;
  itemType?: IEdmTypeReferenceRead;
};
export type FilterQueryOption = {
  context?: ODataQueryContext;
  validator?: IFilterQueryValidator;
  compute?: ComputeQueryOption;
  filterClause?: FilterClause;
  rawValue?: string | null;
};
export type FilterQueryOptionRead = {
  context?: ODataQueryContextRead;
  validator?: IFilterQueryValidator;
  compute?: ComputeQueryOptionRead;
  filterClause?: FilterClauseRead;
  rawValue?: string | null;
};
export type SearchClause = {
  expression?: SingleValueNode;
};
export type SearchClauseRead = {
  expression?: SingleValueNodeRead;
};
export type SearchQueryOption = {
  context?: ODataQueryContext;
  searchClause?: SearchClause;
  rawValue?: string | null;
};
export type SearchQueryOptionRead = {
  context?: ODataQueryContextRead;
  resultClrType?: string | null;
  searchClause?: SearchClauseRead;
  rawValue?: string | null;
};
export type IOrderByQueryValidator = object;
export type OrderByDirection = "Ascending" | "Descending";
export type OrderByClause = {
  thenBy?: OrderByClause;
  expression?: SingleValueNode;
  direction?: OrderByDirection;
  rangeVariable?: RangeVariable;
  itemType?: IEdmTypeReference;
};
export type OrderByClauseRead = {
  thenBy?: OrderByClauseRead;
  expression?: SingleValueNodeRead;
  direction?: OrderByDirection;
  rangeVariable?: RangeVariableRead;
  itemType?: IEdmTypeReferenceRead;
};
export type OrderByQueryOption = {
  context?: ODataQueryContext;
  rawValue?: string | null;
  validator?: IOrderByQueryValidator;
  compute?: ComputeQueryOption;
  orderByClause?: OrderByClause;
};
export type OrderByNode = {
  direction?: OrderByDirection;
};
export type OrderByQueryOptionRead = {
  context?: ODataQueryContextRead;
  orderByNodes?: OrderByNode[] | null;
  rawValue?: string | null;
  validator?: IOrderByQueryValidator;
  compute?: ComputeQueryOptionRead;
  orderByClause?: OrderByClauseRead;
};
export type ISkipQueryValidator = object;
export type SkipQueryOption = {
  context?: ODataQueryContext;
  rawValue?: string | null;
  validator?: ISkipQueryValidator;
};
export type SkipQueryOptionRead = {
  context?: ODataQueryContextRead;
  rawValue?: string | null;
  value?: number;
  validator?: ISkipQueryValidator;
};
export type ISkipTokenQueryValidator = object;
export type SkipTokenHandler = object;
export type SkipTokenQueryOption = {
  rawValue?: string | null;
  context?: ODataQueryContext;
  validator?: ISkipTokenQueryValidator;
  handler?: SkipTokenHandler;
};
export type SkipTokenQueryOptionRead = {
  rawValue?: string | null;
  context?: ODataQueryContextRead;
  validator?: ISkipTokenQueryValidator;
  handler?: SkipTokenHandler;
};
export type ITopQueryValidator = object;
export type TopQueryOption = {
  context?: ODataQueryContext;
  rawValue?: string | null;
  validator?: ITopQueryValidator;
};
export type TopQueryOptionRead = {
  context?: ODataQueryContextRead;
  rawValue?: string | null;
  value?: number;
  validator?: ITopQueryValidator;
};
export type ICountQueryValidator = object;
export type CountQueryOption = {
  context?: ODataQueryContext;
  rawValue?: string | null;
  validator?: ICountQueryValidator;
};
export type CountQueryOptionRead = {
  context?: ODataQueryContextRead;
  rawValue?: string | null;
  value?: boolean;
  validator?: ICountQueryValidator;
};
export type IoDataQueryValidator = object;
export type CarrierChargeCodeMappingVmODataQueryOptions = {
  request?: HttpRequest;
  context?: ODataQueryContext;
  rawValues?: ODataRawQueryOptions;
  selectExpand?: SelectExpandQueryOption;
  apply?: ApplyQueryOption;
  compute?: ComputeQueryOption;
  filter?: FilterQueryOption;
  search?: SearchQueryOption;
  orderBy?: OrderByQueryOption;
  skip?: SkipQueryOption;
  skipToken?: SkipTokenQueryOption;
  top?: TopQueryOption;
  count?: CountQueryOption;
  validator?: IoDataQueryValidator;
};
export type CarrierChargeCodeMappingVmODataQueryOptionsRead = {
  ifMatch?: any | null;
  ifNoneMatch?: any | null;
  request?: HttpRequestRead;
  context?: ODataQueryContextRead;
  rawValues?: ODataRawQueryOptionsRead;
  selectExpand?: SelectExpandQueryOptionRead;
  apply?: ApplyQueryOptionRead;
  compute?: ComputeQueryOptionRead;
  filter?: FilterQueryOptionRead;
  search?: SearchQueryOptionRead;
  orderBy?: OrderByQueryOptionRead;
  skip?: SkipQueryOptionRead;
  skipToken?: SkipTokenQueryOptionRead;
  top?: TopQueryOptionRead;
  count?: CountQueryOptionRead;
  validator?: IoDataQueryValidator;
};
export type CarrierChargeCodesCustomerModeOverrideVm = {
  billToId: string;
  mode?: string | null;
  reason?: string | null;
  carrierId: string;
  description?: string | null;
  id?: number;
  carrier?: CarrierMinimalVm;
  carrierName?: string | null;
  originalChargeCode: string;
  source: CarrierChargeCodeSource;
  mappedChargeCode: string;
  mappedCode?: AscChargeCodeVm;
};
export type CarrierChargeCodesCustomerModeOverrideVmRead = {
  billToId: string;
  mode?: string | null;
  reason?: string | null;
  carrierId: string;
  description?: string | null;
  id?: number;
  carrier?: CarrierMinimalVm;
  carrierName?: string | null;
  originalChargeCode: string;
  source: CarrierChargeCodeSource;
  mappedChargeCode: string;
  mappedCode?: AscChargeCodeVm;
  /** AscChargeCode property, pulled up to make display logic easier */
  codeDescription?: string | null;
  /** AscChargeCode property, pulled up to make display logic easier */
  totalsColumn?: string | null;
  /** AscChargeCode property, pulled up to make display logic easier */
  dbSign?: number | null;
  /** AscChargeCode property, pulled up to make display logic easier */
  cmCode?: string | null;
};
export type CarrierVm = {
  /** ID used for the carrier */
  carrId: string;
  /** Is the carrier currently active and selectable?
    Originally: 0 for No, -1 for Yes
    Now: N for No, Y for Yes
    Thanks Automapper for making this possible */
  active?: string | null;
  /** Carrier's Name */
  name: string;
  /** Standard Carrier Alpha Code */
  scac?: string | null;
  /** Line 1 of address info */
  address1?: string | null;
  /** Line 2 of address info */
  address2?: string | null;
  /** Line 3 of address info */
  address3?: string | null;
  /** City the carrier is located in */
  city?: string | null;
  /** State or Province the carrier is located in */
  stateProv?: string | null;
  /** Postal code for the carrier */
  postal?: string | null;
  /** Country code for the carrier */
  countryCode?: string | null;
  /** Phone # for carrier
    Can include more than one */
  phones?: string | null;
  /** Email address for carrier
    Can include more than one */
  emails?: string | null;
  /** Fax # for carrier
    Can include more than one */
  faxnums?: string | null;
  /** Default mode to use for invoices */
  defaultMode?: string | null;
  /** Unused */
  fpscarrId?: string | null;
  /** Default type to use for invoices */
  defaultInvType?: string | null;
  /** Denotes carriers that allow remits
    These will have a value of REMIT */
  useFor?: string | null;
  /** When the carrier record was last used */
  lastUsed?: string | null;
  /** When the carrier record was created */
  createdDate?: string | null;
  /** What user created the carrier record */
  createdBy?: string | null;
  /** When the carrier record was last updated */
  updatedDate?: string | null;
  /** What user updated the carrier record */
  updatedBy?: string | null;
  /** Default family to use for invoices */
  family?: string | null;
  /** Unused */
  payableGl?: string | null;
  /** Incoming FTP Site */
  inftpsite?: string | null;
  /** Incoming FTP site user contact info */
  inftpcontacts?: string | null;
  /** Incoming FTP User ID */
  inftpUserId?: string | null;
  /** Incoming FTP Password */
  inFtppassword?: string | null;
  /** Unused, set aside for outgoing FTP */
  outFtpsite?: string | null;
  /** Unused, set aside for outgoing FTP */
  outFtpcontacts?: string | null;
  /** Unused, set aside for outgoing FTP */
  outFtpuserId?: string | null;
  /** Unused, set aside for outgoing FTP */
  outFtppassword?: string | null;
  /** URL for tracking info */
  tracingUrl?: string | null;
  /** Are duplicate ABs allowed? */
  allowDupAb?: boolean;
  /** Is service checked? */
  checkService?: boolean;
  /** Name of a function used for default service */
  defSvcFn?: string | null;
  /** Email address for disputes */
  disputeEmail?: string | null;
  /** Prefix to use for scanned Carrier Invoice image IDs */
  imagingId?: string | null;
  /** What user updated the carrier record's active status */
  activationStatusChangedBy?: string | null;
  /** When the carrier record's active status was last updated */
  activationStatusChangeDate?: string | null;
  /** Why the carrier record's active status was last updated */
  activationStatusChangeReason?: string | null;
};
export type CarrierActiveVm = {
  /** ID used for the carrier */
  carrId: string;
  /** Is the carrier currently active and selectable?
    0 for No, -1 for Yes */
  active: number;
  /** What user updated the carrier record's active status */
  activationStatusChangedBy?: string | null;
  /** When the carrier record's active status was last updated */
  activationStatusChangeDate?: string | null;
  /** Why the carrier record's active status was last updated */
  activationStatusChangeReason: string;
};
export type BillToCarrierModeOverrideVm = {
  /** Which customer this default is for */
  btid?: string | null;
  /** Which customer this default is for */
  customerName?: string | null;
  /** Which carrier (if not ANY) this default is for */
  carrierId?: string | null;
  /** Name of the carrier this default is for */
  carrierName?: string | null;
  /** Which mode to default in for this customer/carrier combo */
  mode?: string | null;
};
export type CarrierContactVm = {
  /** Internal record ID */
  id: number;
  /** ID of the Carrier this contact is for */
  carrierId: string;
  /** What kind of contact this is */
  type?: string | null;
  /** The contact person's title */
  ctitle?: string | null;
  /** The contact person's name */
  name?: string | null;
  /** Line 1 of the contact person's address */
  address1?: string | null;
  /** Line 2 of the contact person's address */
  address2?: string | null;
  /** The contact person's city */
  city?: string | null;
  /** The contact person's state or province */
  stateProv?: string | null;
  /** The contact person's postal code */
  postal?: string | null;
  /** What kind of phone contact #1 is */
  phone1Type?: string | null;
  /** Phone number 1 */
  phone1Num?: string | null;
  /** What kind of phone contact #2 is */
  phone2Type?: string | null;
  /** Phone number 2 */
  phone2Num?: string | null;
  /** Email address #1 */
  email1?: string | null;
  /** Email address #2 */
  email2?: string | null;
  /** Who added this contact to the carrier record? */
  createdBy?: string | null;
  /** When this contact was added to the carrier record? */
  createdDate?: string | null;
  /** Who last updated this contact on the carrier record? */
  updatedBy?: string | null;
  /** When this contact was updated on the carrier record? */
  updatedDate?: string | null;
  /** When the contact was last used */
  lastUsed?: string | null;
};
export type CarrierModeMapVm = {
  /** Internal ID for a particular mode map */
  id: number;
  /** ID of the carrier whose mode map this is */
  carrierId: string;
  /** Carrier mode to map */
  carrierMode: string;
  /** PayLogik mode mapping */
  plMode: string;
};
export type CarrierPaymentRemitVm = {
  /** Internal ID for pay/remit data */
  id: number;
  /** ID of the carrier this data is for */
  carrierId: string;
  /** The currency the carrier uses */
  payCurrency: string;
  /** What payment method the carrier uses */
  payHow: string;
  /** Is this particular payment method the carrier's default? */
  isDefaultPayMethod?: boolean | null;
  /** Which Sunset account the carrier's paid from */
  payFromAcct: string;
  /** The Sunset account's nickname, if applicable */
  nickName?: string | null;
  /** How long the payment term is */
  payTermDays?: number | null;
  /** ACH Routing # */
  achrouting?: string | null;
  /** ACH Account # */
  achaccount?: string | null;
  /** Name to use for remits */
  remitName?: string | null;
  /** Address line 1 for remits */
  remitAddr1?: string | null;
  /** Address line 2 for remits */
  remitAddr2?: string | null;
  /** City for remits */
  remitCity?: string | null;
  /** State/province for remits */
  remitStateProv?: string | null;
  /** Postal code for remits */
  remitPostal?: string | null;
  /** Email address for remits */
  remitEmail?: string | null;
  /** When the remit info became effective */
  remitEffective?: string;
  /** When the remit info expires */
  remitExpire?: string | null;
  /** How to send remits */
  remitDeliverHow: string;
  /** What kind of format to send remits in */
  remitFormat?: string | null;
  /** Directory for electronic remits */
  remitDirectory?: string | null;
  /** EDI info */
  isactrlNum820?: number | null;
  /** EDI info */
  rcvIdqual820?: string | null;
  /** EDI info */
  rcvId820?: string | null;
  /** Security code (?) */
  seccode?: string | null;
  /** Unused */
  fileNameMask?: string | null;
  /** EDI info */
  edi820SenderIdQual?: string | null;
  /** EDI info */
  edi820SenderId?: string | null;
  /** Override name for PayHow field */
  remitConfigName?: string | null;
  /** Key to use when saving remit files to S3 */
  remitS3Key?: string | null;
};
export type ApprovedBatchMinimalVm = {
  batchId?: number;
  approvedDate?: string;
};
export type CarrInvRemarkVm = {
  invIdx?: number | null;
  remarkSeq?: number;
  longComment?: string | null;
};
export type CarrInvRefVm = {
  id?: number;
  carrierId?: string | null;
  grpNum?: number | null;
  invIdx?: number | null;
  invoiceNum?: string | null;
  invRev?: number;
  recType?: string | null;
  refDate?: string | null;
  refDescrip?: string | null;
  refId?: string | null;
  refIdQual?: string | null;
  refSeq?: number;
  refTimecode?: string | null;
  ruleUsed?: number;
  fpsCustId?: string | null;
  ascCodeDescription?: string | null;
};
export type CarrInvCwtVm = {
  actualClass?: number;
  carrierId?: string | null;
  cube?: number;
  id?: string;
  invIdx?: number;
  invoiceNum?: string | null;
  invRev?: number;
  lineItemSeq?: number;
  pcs?: number;
  rate?: number;
  ratedAmt?: number | null;
  ratedClass?: number;
  recType?: string | null;
  weight?: number;
};
export type CarrInvDatesVm = {
  /** Key column handled by the API */
  recType?: string | null;
  /** Key column handled by the API */
  carrierId?: string | null;
  /** Key column handled by the API */
  invoiceNum?: string | null;
  /** Key column handled by the API */
  invRev?: number;
  /** Key column handled by the API */
  invIdx?: number | null;
  /** Key column handled by the API */
  dateSeq?: number;
  /** X12 EDI Date Type Code */
  dateQual?: string | null;
  /** Date of the stop */
  stopDate?: string | null;
  /** X12 EDI Time Type Code */
  timeCode?: string | null;
  /** Time of the stop */
  stopTime?: string | null;
  /** Timezone of the time */
  timeQual?: string | null;
};
export type CarrInvLineMeasVm = {
  carrierId?: string | null;
  height?: number | null;
  industry?: string | null;
  invIdx?: number | null;
  invoiceNum?: string | null;
  invRev?: number;
  length?: number | null;
  lineIdx?: number | null;
  lineSeq?: number;
  measSeq?: number;
  measUom?: string | null;
  quantity?: number | null;
  recType?: string | null;
  width?: number | null;
};
export type CarrInvLinePartyVm = {
  addr1?: string | null;
  addr2?: string | null;
  addr3?: string | null;
  addr4?: string | null;
  btid?: string | null;
  carrierId?: string | null;
  city?: string | null;
  countryCode?: string | null;
  countrySub?: string | null;
  entityIdcode?: string | null;
  entRelCode?: string | null;
  entRelIdcode?: string | null;
  idcode?: string | null;
  idcodeQual?: string | null;
  idx?: number;
  invIdx?: number | null;
  invoiceNum?: string | null;
  invRev?: number;
  lineIdx?: number | null;
  lineSeq?: number;
  locId?: string | null;
  locQual?: string | null;
  name?: string | null;
  name2?: string | null;
  name3?: string | null;
  partyType?: string | null;
  postalCode?: string | null;
  recType?: string | null;
  stateProv?: string | null;
  sysLocId?: string | null;
  fpsCustId?: string | null;
};
export type CarrInvLineRefVm = {
  carrierId?: string | null;
  grpNum?: number | null;
  invIdx?: number | null;
  invoiceNum?: string | null;
  invRev?: number;
  lineIdx?: number | null;
  lineSeq?: number;
  recType?: string | null;
  refDate?: string | null;
  refDescrip?: string | null;
  refId?: string | null;
  refIdQual?: string | null;
  refSeq?: number;
  refTimecode?: string | null;
  ruleUsed?: number;
  ascCodeDescription?: string | null;
  fpsCustId?: string | null;
};
export type CarrInvLineVm = {
  airbillNum?: string | null;
  airbillRev?: number;
  apprAccessorial?: number | null;
  apprBatchId?: number;
  auditContract?: number | null;
  auditDate?: string;
  auditFlag?: boolean;
  auditMiles?: number;
  auditRateIs?: string | null;
  auditResult?: string | null;
  auditVariance?: number;
  autoAuditResult?: string | null;
  bmAccessorial?: number;
  bmDeficit?: number;
  bmDiscount?: number;
  bmFuel?: number;
  bmGross?: number;
  bmNetDue?: number;
  bundleNum?: string | null;
  carrInvLineMarks?: CarrInvLineMarksVm[] | null;
  carrInvLineMeas?: CarrInvLineMeasVm[] | null;
  carrInvLineParty?: CarrInvLinePartyVm[] | null;
  carrInvLineQw?: CarrInvLineQwVm[] | null;
  carrInvLineRc?: CarrInvLineRcVm[] | null;
  carrInvLineRef?: CarrInvLineRefVm[] | null;
  carrInvLineTariff?: CarrInvLineTariffVm[] | null;
  cashReceiptId?: number | null;
  checkNumber?: number | null;
  createDate?: string | null;
  currAccessorial?: number;
  currAmtDue?: number;
  currDeficit?: number;
  currDiscount?: number;
  currFuel?: number;
  currGross?: number;
  custSvcDescr?: string | null;
  decomment?: string | null;
  dupeFlag?: boolean;
  entryTime?: number;
  equipment?: string | null;
  estDelivDate?: string | null;
  estDelivDays?: number;
  evcity?: string | null;
  evcode?: string | null;
  evcountry?: string | null;
  evdate?: string;
  evdelayHrs?: number;
  event?: string | null;
  evfuelGal?: number;
  evmessage?: string | null;
  evnumCars?: number;
  evnumEmpty?: number;
  evnumLoaded?: number;
  evsecSplc?: string | null;
  evsplc?: string | null;
  evstateProv?: string | null;
  evstatReasCode?: string | null;
  evtime?: string | null;
  evtimeZone?: string | null;
  evtotGross?: number;
  evtotLen?: number;
  evtrainDelayReasCode?: string | null;
  fundedAmt?: number;
  ibob?: string | null;
  invIdx?: number | null;
  invRev?: number;
  lane?: string | null;
  lastUpdateDate?: string | null;
  lastUpdateUser?: string | null;
  lineSeq?: number;
  mode?: string | null;
  payBatchId?: number;
  payStatus?: string | null;
  poddate?: string;
  podname?: string | null;
  podtime?: string | null;
  podzone?: string | null;
  pudate?: string;
  pudateQual?: string | null;
  pudelCode?: string | null;
  puequipInit?: string | null;
  puequipNum?: string | null;
  punumShip?: number;
  purpose?: string | null;
  putime?: string | null;
  rcvBatchId?: number;
  recType?: string | null;
  serviceLevel?: string | null;
  shipDate?: string;
  svcFail?: boolean;
  termsDescrip?: string | null;
  totalAccum1?: number;
  totalAccum2?: number;
  totalAccum3?: number;
  totalAccum4?: number;
  totalAccum5?: number;
  totalAccum6?: number;
  totalAccum7?: number;
  totalAccum8?: number;
  totalAccum9?: number;
  totWgt?: number | null;
  totWgtKilos?: number | null;
  totwgtPounds?: number | null;
  totWgtQual?: string | null;
  totWgtTons?: number | null;
  verifyNetDue?: number | null;
  btId?: string | null;
  customerId?: string | null;
  fpsCustId?: string | null;
  parties?: CarrInvLinePartyVm[] | null;
  references?: CarrInvLineRefVm[] | null;
  custComment?: string | null;
  reviewStatus?: string | null;
  carrier?: CarrierMinimalVm;
  shipper?: PartyVm;
  consignee?: PartyVm;
  apprDeficit?: number | null;
  apprDiscount?: number | null;
  apprFuel?: number | null;
  apprGross?: number | null;
  apprNetDue?: number | null;
  auditAccess?: number | null;
  auditDeficit?: number | null;
  auditDiscount?: number | null;
  auditFuel?: number | null;
  auditGross?: number | null;
  auditNet?: number | null;
  netDue?: number | null;
  paidAccessorial?: number | null;
  paidDeficit?: number | null;
  paidDiscount?: number | null;
  paidFuel?: number | null;
  paidGross?: number | null;
  paidNetDue?: number | null;
  totalAccessorial?: number | null;
  totalDeficit?: number | null;
  totalDiscount?: number | null;
  totalFuel?: number | null;
  totalGross?: number | null;
  carrierId?: string | null;
  idx?: number;
  invoiceNum?: string | null;
};
export type ChargeTotalsVm = {
  totalType?: string | null;
  freight?: number;
  deficit?: number;
  fuel?: number;
  accessorial?: number;
  discount?: number;
  net?: number;
  date?: string;
};
export type CarrInvLineVmRead = {
  airbillNum?: string | null;
  airbillRev?: number;
  apprAccessorial?: number | null;
  apprBatchId?: number;
  apprNet?: number | null;
  auditContract?: number | null;
  auditDate?: string;
  auditFlag?: boolean;
  auditMiles?: number;
  auditRateIs?: string | null;
  auditResult?: string | null;
  auditVariance?: number;
  autoAuditResult?: string | null;
  bmAccessorial?: number;
  bmDeficit?: number;
  bmDiscount?: number;
  bmFuel?: number;
  bmGross?: number;
  bmNetDue?: number;
  bundleNum?: string | null;
  carrInvLineMarks?: CarrInvLineMarksVm[] | null;
  carrInvLineMeas?: CarrInvLineMeasVm[] | null;
  carrInvLineParty?: CarrInvLinePartyVm[] | null;
  carrInvLineQw?: CarrInvLineQwVm[] | null;
  carrInvLineRc?: CarrInvLineRcVm[] | null;
  carrInvLineRef?: CarrInvLineRefVm[] | null;
  carrInvLineTariff?: CarrInvLineTariffVm[] | null;
  cashReceiptId?: number | null;
  checkNumber?: number | null;
  createDate?: string | null;
  currAccessorial?: number;
  currAmtDue?: number;
  currDeficit?: number;
  currDiscount?: number;
  currFuel?: number;
  currGross?: number;
  custSvcDescr?: string | null;
  decomment?: string | null;
  dupeFlag?: boolean;
  entryTime?: number;
  equipment?: string | null;
  estDelivDate?: string | null;
  estDelivDays?: number;
  evcity?: string | null;
  evcode?: string | null;
  evcountry?: string | null;
  evdate?: string;
  evdelayHrs?: number;
  event?: string | null;
  evfuelGal?: number;
  evmessage?: string | null;
  evnumCars?: number;
  evnumEmpty?: number;
  evnumLoaded?: number;
  evsecSplc?: string | null;
  evsplc?: string | null;
  evstateProv?: string | null;
  evstatReasCode?: string | null;
  evtime?: string | null;
  evtimeZone?: string | null;
  evtotGross?: number;
  evtotLen?: number;
  evtrainDelayReasCode?: string | null;
  fundedAmt?: number;
  ibob?: string | null;
  invIdx?: number | null;
  invRev?: number;
  lane?: string | null;
  lastUpdateDate?: string | null;
  lastUpdateUser?: string | null;
  lineSeq?: number;
  mode?: string | null;
  paidAccess?: number | null;
  paidNet?: number | null;
  payBatchId?: number;
  payStatus?: string | null;
  poddate?: string;
  podname?: string | null;
  podtime?: string | null;
  podzone?: string | null;
  pudate?: string;
  pudateQual?: string | null;
  pudelCode?: string | null;
  puequipInit?: string | null;
  puequipNum?: string | null;
  punumShip?: number;
  purpose?: string | null;
  putime?: string | null;
  rcvBatchId?: number;
  recType?: string | null;
  serviceLevel?: string | null;
  shipDate?: string;
  svcFail?: boolean;
  termsDescrip?: string | null;
  totalAccum1?: number;
  totalAccum2?: number;
  totalAccum3?: number;
  totalAccum4?: number;
  totalAccum5?: number;
  totalAccum6?: number;
  totalAccum7?: number;
  totalAccum8?: number;
  totalAccum9?: number;
  totWgt?: number | null;
  totWgtKilos?: number | null;
  totwgtPounds?: number | null;
  totWgtQual?: string | null;
  totWgtTons?: number | null;
  verifyNetDue?: number | null;
  btId?: string | null;
  customerId?: string | null;
  fpsCustId?: string | null;
  parties?: CarrInvLinePartyVm[] | null;
  references?: CarrInvLineRefVm[] | null;
  chargeTotals?: ChargeTotalsVm[] | null;
  chargeDetails?: LineRcTariffQwMarksVm[] | null;
  custComment?: string | null;
  reviewStatus?: string | null;
  carrier?: CarrierMinimalVm;
  shipper?: PartyVm;
  consignee?: PartyVm;
  apprAccess?: number | null;
  apprDeficit?: number | null;
  apprDiscount?: number | null;
  apprFuel?: number | null;
  apprGross?: number | null;
  apprNetDue?: number | null;
  auditAccess?: number | null;
  auditDeficit?: number | null;
  auditDiscount?: number | null;
  auditFuel?: number | null;
  auditGross?: number | null;
  auditNet?: number | null;
  netDue?: number | null;
  paidAccessorial?: number | null;
  paidDeficit?: number | null;
  paidDiscount?: number | null;
  paidFuel?: number | null;
  paidGross?: number | null;
  paidNetDue?: number | null;
  totalAccessorial?: number | null;
  totalDeficit?: number | null;
  totalDiscount?: number | null;
  totalFuel?: number | null;
  totalGross?: number | null;
  carrierId?: string | null;
  idx?: number;
  invoiceNum?: string | null;
};
export type CarrInvPartyVm = {
  addr1?: string | null;
  addr2?: string | null;
  addr3?: string | null;
  addr4?: string | null;
  btId?: string | null;
  carrierId?: string | null;
  city?: string | null;
  countryCode?: string | null;
  countrySub?: string | null;
  entIdCode?: string | null;
  entRelCode?: string | null;
  entRelIdCode?: string | null;
  idCode?: string | null;
  idCodeQual?: string | null;
  idx?: number;
  invIdx?: number | null;
  invoiceNum?: string | null;
  invRev?: number;
  locId?: string | null;
  locQual?: string | null;
  name?: string | null;
  name2?: string | null;
  name3?: string | null;
  partyType?: string | null;
  postalCode?: string | null;
  recType?: string | null;
  stateProv?: string | null;
  sysLocId?: string | null;
  fpsCustId?: string | null;
};
export type CarrierInvoiceImagesVm = {
  id?: number;
  carrInvIdx?: number;
  invoiceNum?: string | null;
  carrInvLineIdx?: number | null;
  carrierId?: string | null;
  imageType?: string | null;
  originalFileName?: string | null;
  imageName?: string | null;
  source?: string | null;
  s3Path?: string | null;
  subKey?: string | null;
  fileDate?: string;
  dateLinked?: string;
  image?: string | null;
};
export type CarrierInvoiceImagesVmRead = {
  id?: number;
  carrInvIdx?: number;
  invoiceNum?: string | null;
  carrInvLineIdx?: number | null;
  carrierId?: string | null;
  imageType?: string | null;
  originalFileName?: string | null;
  imageName?: string | null;
  source?: string | null;
  s3Path?: string | null;
  subKey?: string | null;
  fileDate?: string;
  dateLinked?: string;
  image?: string | null;
  contentType?: string | null;
};
export type CarrInvVm = {
  apprBatchId?: number | null;
  auditContract?: number | null;
  auditDate?: string;
  auditFlag?: boolean;
  auditMiles?: number | null;
  auditRateIs?: string | null;
  auditResult?: string | null;
  auditVariance?: number;
  autoAuditResult?: string | null;
  bankAccountNum?: string | null;
  bankClientCode?: string | null;
  billingContract?: number;
  billingCurrency?: string | null;
  billingDate?: string | null;
  biNum?: number | null;
  bmAccessorial?: number | null;
  bmDeficit?: number | null;
  bmDiscount?: number | null;
  bmFuel?: number | null;
  bmGross?: number | null;
  bmNetDue?: number | null;
  calcDueDate?: string | null;
  calcReqDate?: string | null;
  cashReceiptId?: number | null;
  checkNumber?: number | null;
  ciNum?: number | null;
  clientBankNum?: string | null;
  contactFcode?: string | null;
  contactInqRef?: string | null;
  contactName?: string | null;
  contactNum1?: string | null;
  contactNum2?: string | null;
  contactNum3?: string | null;
  contactNum4?: string | null;
  correction?: string | null;
  createDate?: string | null;
  createUser?: string | null;
  currAccessorial?: number | null;
  currAmtDue?: number | null;
  currDeficit?: number | null;
  currDiscount?: number | null;
  currFuel?: number | null;
  currGross?: number | null;
  custChange?: boolean;
  custSvcDescr?: string | null;
  dateQual?: string | null;
  delDate?: string | null;
  deleteDate?: string | null;
  deleteUser?: string | null;
  dupeFlag?: boolean;
  ediCustId?: string | null;
  effectivePayDate?: string | null;
  entryTime?: number;
  equipment?: string | null;
  estDelivDate?: string | null;
  estDelivDays?: number | null;
  exchRate?: number | null;
  firstBtId?: string | null;
  fpsCarrId?: string | null;
  fpsCustId?: string | null;
  fpsFileName?: string | null;
  fundedAmt?: number | null;
  fundedDate?: string | null;
  gsCtlNum?: number | null;
  gsRecvId?: string | null;
  gsSendId?: string | null;
  gsTrans?: string | null;
  ibob?: string | null;
  idCode?: string | null;
  idCodeQual?: string | null;
  ieaGrpIncl?: number | null;
  inFileName?: string | null;
  invDate2?: string | null;
  invRev?: number;
  invType?: string | null;
  isaAckReq?: string | null;
  isaAuthInfo?: string | null;
  isaAuthQual?: string | null;
  isaControlNum?: number | null;
  isaDate?: string | null;
  isaRecvId?: string | null;
  isaRecvQual?: string | null;
  isaRepSep?: string | null;
  isaSecInfo?: string | null;
  isaSecInfoQual?: string | null;
  isaSenderId?: string | null;
  isaSenderIdQual?: string | null;
  isaTestInd?: string | null;
  isaTime?: string | null;
  isaVersionId?: string | null;
  lane?: string | null;
  lastUpdateDate?: string | null;
  lastUpdateUser?: string | null;
  mode?: string | null;
  numQual1?: string | null;
  numQual2?: string | null;
  numQual3?: string | null;
  numQual4?: string | null;
  numShipments?: number | null;
  payBatchId?: number | null;
  payCurrency?: string | null;
  payMeth?: string | null;
  payStatus?: string | null;
  projReqDate?: string | null;
  purpose?: string | null;
  ratedCurrency?: string | null;
  rcvBatchDate?: string | null;
  rcvBatchId?: number | null;
  recType?: string | null;
  scac?: string | null;
  serviceLevel?: string | null;
  seSegIncl?: number | null;
  shipDate?: string | null;
  shipIdNum?: string | null;
  shipmentCount?: number | null;
  shipMethPay?: string | null;
  shipperAccount?: string | null;
  shipQual?: string | null;
  source?: string | null;
  stControlNum?: number | null;
  stTransType?: string | null;
  svcFail?: boolean;
  tariffSvcCode?: string | null;
  termsBasisDateCode?: string | null;
  termsDayOfMon?: number | null;
  termsDefAmtDue?: number | null;
  termsDefDueDate?: string | null;
  termsDescrip?: string | null;
  termsDiscAmt?: number | null;
  termsDiscDaysDue?: number | null;
  termsDiscDueDate?: string | null;
  termsDiscountPct?: number | null;
  termsNetDays?: number | null;
  termsNetDueDate?: string | null;
  termsPayMethCode?: string | null;
  termsPct?: number | null;
  termsPctpayable?: number | null;
  termsTypeCode?: string | null;
  test?: string | null;
  totAdv?: number | null;
  totalAccum1?: number | null;
  totalAccum2?: number | null;
  totalAccum3?: number | null;
  totalAccum4?: number | null;
  totalAccum5?: number | null;
  totalAccum6?: number | null;
  totalAccum7?: number | null;
  totalAccum8?: number | null;
  totalAccum9?: number | null;
  totChg?: number | null;
  totDeclVal?: number | null;
  totDeclValQual?: string | null;
  totFrtRate?: number | null;
  totFrtRateQual?: string | null;
  totLadQty?: number | null;
  totPrepaid?: number | null;
  totSpecChgCode?: string | null;
  totTariffNum?: string | null;
  totVol?: number | null;
  totVolUom?: string | null;
  totWgt?: number | null;
  totWgtKilos?: number | null;
  totWgtPounds?: number | null;
  totWgtQual?: string | null;
  totWgtTons?: number | null;
  totWgtUom?: string | null;
  transpTermsCode?: string | null;
  transTypeCode?: string | null;
  underCarr?: string | null;
  vdabCarrId?: string | null;
  verifyNetDue?: number | null;
  wgtUnitCode?: string | null;
  approvedBatch?: ApprovedBatchMinimalVm;
  billTo?: BillToMinimalVm;
  carrInvRemark?: CarrInvRemarkVm[] | null;
  carrInvRef?: CarrInvRefVm[] | null;
  references?: CarrInvRefVm[] | null;
  carrInvCwt?: CarrInvCwtVm[] | null;
  carrInvDates?: CarrInvDatesVm[] | null;
  carrInvLine?: CarrInvLineVm[] | null;
  carrInvParty?: CarrInvPartyVm[] | null;
  carrInvImages?: CarrierInvoiceImagesVm[] | null;
  parties?: CarrInvPartyVm[] | null;
  custComment?: string | null;
  reviewStatus?: string | null;
  carrier?: CarrierMinimalVm;
  shipper?: PartyVm;
  consignee?: PartyVm;
  apprAccess?: number | null;
  apprDeficit?: number | null;
  apprDiscount?: number | null;
  apprFuel?: number | null;
  apprGross?: number | null;
  apprNetDue?: number | null;
  auditAccess?: number | null;
  auditDeficit?: number | null;
  auditDiscount?: number | null;
  auditFuel?: number | null;
  auditGross?: number | null;
  auditNet?: number | null;
  netDue?: number | null;
  paidAccessorial?: number | null;
  paidDeficit?: number | null;
  paidDiscount?: number | null;
  paidFuel?: number | null;
  paidGross?: number | null;
  paidNetDue?: number | null;
  totalAccessorial?: number | null;
  totalDeficit?: number | null;
  totalDiscount?: number | null;
  totalFuel?: number | null;
  totalGross?: number | null;
  carrierId?: string | null;
  idx?: number;
  invoiceNum?: string | null;
};
export type CarrInvVmRead = {
  apprBatchId?: number | null;
  auditContract?: number | null;
  auditDate?: string;
  auditFlag?: boolean;
  auditMiles?: number | null;
  auditRateIs?: string | null;
  auditResult?: string | null;
  auditVariance?: number;
  autoAuditResult?: string | null;
  bankAccountNum?: string | null;
  bankClientCode?: string | null;
  billingContract?: number;
  billingCurrency?: string | null;
  billingDate?: string | null;
  biNum?: number | null;
  bmAccessorial?: number | null;
  bmDeficit?: number | null;
  bmDiscount?: number | null;
  bmFuel?: number | null;
  bmGross?: number | null;
  bmNetDue?: number | null;
  calcDueDate?: string | null;
  calcReqDate?: string | null;
  cashReceiptId?: number | null;
  checkNumber?: number | null;
  ciNum?: number | null;
  clientBankNum?: string | null;
  contactFcode?: string | null;
  contactInqRef?: string | null;
  contactName?: string | null;
  contactNum1?: string | null;
  contactNum2?: string | null;
  contactNum3?: string | null;
  contactNum4?: string | null;
  correction?: string | null;
  createDate?: string | null;
  createUser?: string | null;
  currAccessorial?: number | null;
  currAmtDue?: number | null;
  currDeficit?: number | null;
  currDiscount?: number | null;
  currFuel?: number | null;
  currGross?: number | null;
  custChange?: boolean;
  custSvcDescr?: string | null;
  dateQual?: string | null;
  delDate?: string | null;
  deleteDate?: string | null;
  deleteUser?: string | null;
  dupeFlag?: boolean;
  ediCustId?: string | null;
  effectivePayDate?: string | null;
  entryTime?: number;
  equipment?: string | null;
  estDelivDate?: string | null;
  estDelivDays?: number | null;
  exchRate?: number | null;
  firstBtId?: string | null;
  fpsCarrId?: string | null;
  fpsCustId?: string | null;
  fpsFileName?: string | null;
  fundedAmt?: number | null;
  fundedDate?: string | null;
  gsCtlNum?: number | null;
  gsRecvId?: string | null;
  gsSendId?: string | null;
  gsTrans?: string | null;
  ibob?: string | null;
  idCode?: string | null;
  idCodeQual?: string | null;
  ieaGrpIncl?: number | null;
  inFileName?: string | null;
  invDate2?: string | null;
  invRev?: number;
  invType?: string | null;
  isaAckReq?: string | null;
  isaAuthInfo?: string | null;
  isaAuthQual?: string | null;
  isaControlNum?: number | null;
  isaDate?: string | null;
  isaRecvId?: string | null;
  isaRecvQual?: string | null;
  isaRepSep?: string | null;
  isaSecInfo?: string | null;
  isaSecInfoQual?: string | null;
  isaSenderId?: string | null;
  isaSenderIdQual?: string | null;
  isaTestInd?: string | null;
  isaTime?: string | null;
  isaVersionId?: string | null;
  lane?: string | null;
  lastUpdateDate?: string | null;
  lastUpdateUser?: string | null;
  mode?: string | null;
  numQual1?: string | null;
  numQual2?: string | null;
  numQual3?: string | null;
  numQual4?: string | null;
  numShipments?: number | null;
  payBatchId?: number | null;
  payCurrency?: string | null;
  payMeth?: string | null;
  payStatus?: string | null;
  projReqDate?: string | null;
  purpose?: string | null;
  ratedCurrency?: string | null;
  rcvBatchDate?: string | null;
  rcvBatchId?: number | null;
  recType?: string | null;
  scac?: string | null;
  serviceLevel?: string | null;
  seSegIncl?: number | null;
  shipDate?: string | null;
  shipIdNum?: string | null;
  shipmentCount?: number | null;
  shipMethPay?: string | null;
  shipperAccount?: string | null;
  shipQual?: string | null;
  source?: string | null;
  stControlNum?: number | null;
  stTransType?: string | null;
  svcFail?: boolean;
  tariffSvcCode?: string | null;
  termsBasisDateCode?: string | null;
  termsDayOfMon?: number | null;
  termsDefAmtDue?: number | null;
  termsDefDueDate?: string | null;
  termsDescrip?: string | null;
  termsDiscAmt?: number | null;
  termsDiscDaysDue?: number | null;
  termsDiscDueDate?: string | null;
  termsDiscountPct?: number | null;
  termsNetDays?: number | null;
  termsNetDueDate?: string | null;
  termsPayMethCode?: string | null;
  termsPct?: number | null;
  termsPctpayable?: number | null;
  termsTypeCode?: string | null;
  test?: string | null;
  totAdv?: number | null;
  totalAccum1?: number | null;
  totalAccum2?: number | null;
  totalAccum3?: number | null;
  totalAccum4?: number | null;
  totalAccum5?: number | null;
  totalAccum6?: number | null;
  totalAccum7?: number | null;
  totalAccum8?: number | null;
  totalAccum9?: number | null;
  totChg?: number | null;
  totDeclVal?: number | null;
  totDeclValQual?: string | null;
  totFrtRate?: number | null;
  totFrtRateQual?: string | null;
  totLadQty?: number | null;
  totPrepaid?: number | null;
  totSpecChgCode?: string | null;
  totTariffNum?: string | null;
  totVol?: number | null;
  totVolUom?: string | null;
  totWgt?: number | null;
  totWgtKilos?: number | null;
  totWgtPounds?: number | null;
  totWgtQual?: string | null;
  totWgtTons?: number | null;
  totWgtUom?: string | null;
  transpTermsCode?: string | null;
  transTypeCode?: string | null;
  underCarr?: string | null;
  vdabCarrId?: string | null;
  verifyNetDue?: number | null;
  wgtUnitCode?: string | null;
  approvedBatch?: ApprovedBatchMinimalVm;
  billTo?: BillToMinimalVmRead;
  carrInvRemark?: CarrInvRemarkVm[] | null;
  needsEdiInvoice?: boolean;
  carrInvRef?: CarrInvRefVm[] | null;
  references?: CarrInvRefVm[] | null;
  carrInvCwt?: CarrInvCwtVm[] | null;
  carrInvDates?: CarrInvDatesVm[] | null;
  carrInvLine?: CarrInvLineVmRead[] | null;
  carrInvParty?: CarrInvPartyVm[] | null;
  carrInvImages?: CarrierInvoiceImagesVmRead[] | null;
  parties?: CarrInvPartyVm[] | null;
  chargeTotals?: ChargeTotalsVm[] | null;
  chargeDetails?: LineRcTariffQwMarksVm[] | null;
  custComment?: string | null;
  reviewStatus?: string | null;
  carrier?: CarrierMinimalVm;
  shipper?: PartyVm;
  consignee?: PartyVm;
  apprAccess?: number | null;
  apprDeficit?: number | null;
  apprDiscount?: number | null;
  apprFuel?: number | null;
  apprGross?: number | null;
  apprNetDue?: number | null;
  auditAccess?: number | null;
  auditDeficit?: number | null;
  auditDiscount?: number | null;
  auditFuel?: number | null;
  auditGross?: number | null;
  auditNet?: number | null;
  netDue?: number | null;
  paidAccessorial?: number | null;
  paidDeficit?: number | null;
  paidDiscount?: number | null;
  paidFuel?: number | null;
  paidGross?: number | null;
  paidNetDue?: number | null;
  totalAccessorial?: number | null;
  totalDeficit?: number | null;
  totalDiscount?: number | null;
  totalFuel?: number | null;
  totalGross?: number | null;
  carrierId?: string | null;
  idx?: number;
  invoiceNum?: string | null;
};
export type CarrInvLineBundleVm = {
  /** Airbill # */
  airbillNum?: string | null;
  /** Package Code */
  pkgCode?: string | null;
  /** Description */
  descrip?: string | null;
  /** Service Level */
  serviceLevel?: string | null;
  /** Service Description */
  serviceDescription?: string | null;
  /** Shipment Weight */
  weight?: number | null;
  /** Total Fuel Charge */
  totalFuel?: number | null;
  /** Current Payment Due */
  currAmtDue?: number;
  /** Shipment date */
  shipDate?: string;
  /** Pickup date */
  poddate?: string;
  /** Pickup Time */
  podtime?: string | null;
};
export type CarrInvLineMinimalVm = {
  airbillNum?: string | null;
  apprNetDue?: number;
  auditNet?: number;
  custComment?: string | null;
  invIdx?: number;
  invRev?: number;
  lineIdx?: number;
  lineSeq?: number;
  mode?: string | null;
  netDue?: number;
  selected?: boolean;
  serviceLevel?: string | null;
  status?: string | null;
  carrInvLineRc?: CarrInvLineRcVm[] | null;
  carrInvLineQw?: CarrInvLineQwVm[] | null;
  carrInvLineTariff?: CarrInvLineTariffVm[] | null;
  carrInvLineMarks?: CarrInvLineMarksVm[] | null;
};
export type CarrInvMinimalVm = {
  apprNetDue?: number;
  auditNetDue?: number;
  billingCurrency?: string | null;
  billTo?: BillToMinimalVm;
  carrierId?: string | null;
  carrier?: CarrierMinimalVm;
  comment?: string | null;
  fpsCustId?: string | null;
  idx?: number;
  billingDate?: string;
  createDate?: string;
  createUser?: string | null;
  shipDate?: string;
  invoiceNum?: string | null;
  source?: string | null;
  purpose?: string | null;
  invRev?: number;
  invType?: string | null;
  isaSenderID?: string | null;
  mode?: string | null;
  netDue?: number;
  selected?: boolean;
  status?: string | null;
  recType?: string | null;
  ibob?: string | null;
  reviewStatus?: string | null;
  carrInvLine?: CarrInvLineMinimalVm[] | null;
};
export type CarrInvMinimalVmRead = {
  apprNetDue?: number;
  auditNetDue?: number;
  billingCurrency?: string | null;
  billTo?: BillToMinimalVmRead;
  carrierId?: string | null;
  carrier?: CarrierMinimalVm;
  comment?: string | null;
  fpsCustId?: string | null;
  idx?: number;
  billingDate?: string;
  createDate?: string;
  createUser?: string | null;
  shipDate?: string;
  invoiceNum?: string | null;
  source?: string | null;
  purpose?: string | null;
  invRev?: number;
  invType?: string | null;
  isaSenderID?: string | null;
  mode?: string | null;
  netDue?: number;
  selected?: boolean;
  status?: string | null;
  recType?: string | null;
  ibob?: string | null;
  reviewStatus?: string | null;
  carrInvLine?: CarrInvLineMinimalVm[] | null;
};
export type InitiateMultiPartInvoiceCreationResponse = {
  invoiceId?: number;
  creationId?: string | null;
};
export type InitiateMultiPartInvoiceCreationRequest = {
  invoice?: CarrInvVm;
};
export type InitiateMultiPartInvoiceCreationRequestRead = {
  invoice?: CarrInvVmRead;
};
export type InvoicePartResponse = {
  tag?: string | null;
  partNumber?: number;
};
export type InvoicePartRequest = {
  invoiceId?: number;
  creationId?: string | null;
  partNumber?: number;
  lineItems?: CarrInvLineVm[] | null;
};
export type InvoicePartRequestRead = {
  invoiceId?: number;
  creationId?: string | null;
  partNumber?: number;
  lineItems?: CarrInvLineVmRead[] | null;
};
export type CompleteMultiPartInvoiceCreationResponse = {
  invoiceId?: number;
  errorMessage?: string | null;
  serverTrackedCompletedParts?: InvoicePartResponse[] | null;
};
export type CompleteMultiPartInvoiceCreationRequest = {
  invoiceId?: number;
  creationId?: string | null;
  completedParts?: InvoicePartResponse[] | null;
};
export type AbortMultiPartInvoiceCreationRequest = {
  invoiceId?: number;
  creationId?: string | null;
};
export type QueuedInvoiceCreationResponse = {
  queueId?: string | null;
};
export type InvoiceCreationStatusResponse = {
  queueId?: string | null;
  status?: string | null;
};
export type InvoiceCreationStatusRequest = {
  invoiceId?: number;
  queueId?: string | null;
  multiPart?: boolean;
  creationId?: string | null;
};
export type CarrInvCustChangeVm = {
  /** ID of the Carrier whose Carrier Invoice we're updating */
  carrierId: string;
  /** ID of the Bill-To we're assigning the Carrier Invoice to */
  newCustomerId: string;
  /** Invoice # of the Carrier Invoice we're updating */
  invoiceNum: string;
};
export type CarrInvNumberChangeVm = {
  /** ID of the Carrier whose Carrier Invoice we're updating */
  carrierId: string;
  /** New Invoice # to use */
  newInvoiceNum: string;
  /** Invoice # of the Carrier Invoice we're updating */
  invoiceNum: string;
};
export type CarrInvEdiVm = {
  /** EDI Text to show */
  ediText?: string | null;
};
export type WhatIfChargeCodeMapVm = {
  originalChargeDescr?: string | null;
  originalChargeCode?: string | null;
  specChargeCode?: string | null;
  specChgDescr?: string | null;
  totalsColumn?: string | null;
  rcSeq?: number;
  lineIdx?: number | null;
  invIdx?: number | null;
};
export type GetBatchableInvoicesCustomerVm = {
  customer?: string | null;
  invoices?: number;
  netDue?: number;
  payCurrency?: string | null;
  shipments?: number;
};
export type CarrServicesVm = {
  /** ID of the carrier we're mapping */
  carrierId: string;
  /** Service Code the carrier uses */
  serviceCode: string;
  /** Description of the service code */
  serviceDescription?: string | null;
  /** Unused */
  svcAuditFunction?: string | null;
  /** Is this the default service for this carrier? */
  isDefault?: boolean | null;
  /** Check for duplicate services */
  checkForDuplicate?: boolean;
  /** Is this service shown in Invoice Entry? */
  displayForInvoiceEntry?: boolean;
};
export type CentralSaltMatchVm = {
  /** GUID for an individual ticket import entry */
  idx?: string;
  /** Description of the item included on the ticket */
  itemCode?: string | null;
  /** Is this a transferred load? "Yes" for yes */
  transferLoad?: string | null;
  /** # of the associated contract */
  contractNumber?: string | null;
  /** Amount of freight included on the ticket */
  statedQty?: number;
  /** Unit of Measurement for the freight amount */
  um?: string | null;
  /** Vendor code used to match the Carrier */
  vendorCode?: string | null;
  /** Internal number for the pickup */
  pickupNumber?: string | null;
  /** Ticket # (external ID) */
  ticketNumber?: string | null;
  /** Identification code for the shipper depot */
  depotCode?: string | null;
  /** Which Central Salt company the ticket is for */
  company?: string | null;
  /** Shipper depot's city */
  depotCity?: string | null;
  /** Shipper depot's state */
  depotState?: string | null;
  /** Shipper depot's postal code */
  depotZip?: string | null;
  /** What kind of freight this is */
  freightType?: string | null;
  /** Per-unit cost of the freight */
  freightRate?: number;
  /** Total freight cost for this ticket */
  freightTypeTotal?: number;
  /** Additional charge description */
  fscitem?: string | null;
  /** Total fuel cost for this ticket */
  fsctotal?: number;
  /** Combined freight and charge amount */
  invoiceAmountShouldBe?: number;
  /** When the transaction for this ticket occurred */
  ticketDate?: string;
  /** Internal name for the customer to ship to */
  customerName?: string | null;
  /** Name of the destination to ship to */
  shipToName?: string | null;
  /** Destination postal code */
  shipToZip?: string | null;
  /** Destination city */
  shipToCity?: string | null;
  /** Destination state */
  shipToState?: string | null;
  /** How far the shipment will go */
  miles?: number;
  /** Has this ticket been matched to a Carrier Invoice via Match Pay? */
  matched?: boolean;
  /** When the ticket was imported */
  importDate?: string;
};
export type CentralSaltTicketVm = {
  /** Ticket # */
  ticketNum?: string | null;
  /** Depot Code for shipping */
  depotCode?: string | null;
  /** How much freight is on this ticket */
  qty?: number;
  /** Weight unit for the ticket's freight */
  uom?: string | null;
  /** Portion of the Carrier Invoice amount assigned to freight costs */
  freightAmt?: number;
  /** Portion of the Carrier Invoice amount assigned to fuel costs */
  fuelAmt?: number;
};
export type CentralSaltVm = {
  /** Which Bill-To this Carrier Invoice is for */
  customerId?: string | null;
  /** Which Carrier this Carrier Invoice is for */
  carrierId?: string | null;
  /** Carrier Invoice Date */
  invoiceDate?: string;
  /** Carrier Invoice # */
  invoiceNum?: string | null;
  /** Invoice Net Due (total amount billed by Carrier) */
  invoiceAmt?: number;
  /** Fuel cost on the Carrier Invoice */
  fuelAmt?: number;
  /** Calculated freight cost on the Carrier Invoice */
  freightTotal?: number;
  /** Calculated fuel cost on the Carrier Invoice */
  fuelTotal?: number;
  /** List of tickets on this Carrier Invoice */
  tickets?: CentralSaltTicketVm[] | null;
};
export type CheckRegisterVm = {
  /** Date a transaction was recorded */
  transactDate?: string;
  /** Info about how the transaction was processed */
  transactInfo?: string | null;
  /** Info about the transaction customer */
  fboInfo?: string | null;
  /** Info about the transaction payee */
  carrierInfo?: string | null;
  /** Amount paid in the transaction */
  payAmt?: number;
  /** Info about potential voiding of a check */
  voidBy?: string | null;
  checkNum?: number;
};
export type CheckRegisterRequestVm = {
  /** ID of the FBO we're filtering to - skip to load all */
  fboid?: string | null;
  /** Which bank account we're loading info for - skip to load all */
  acctId?: string | null;
  /** Number of the first check to look for - skip to load all */
  startingCheckNumber?: number | null;
  /** Number of the Last check to look for - skip to load all */
  endingCheckNumber?: number | null;
  /** Starting date for filtering transaction info */
  startDate: string;
  /** End date for filtering transaction info */
  endDate: string;
};
export type CmContractVm = {
  /** ID of the carrier linked to this contract */
  carrierId: string;
  /** Name of the carrier linked to this contract
    Pulled from the DB as linked data to Carrier ID - client never sends this */
  carrierName?: string | null;
  /** ID of the customer linked to this contract */
  billToId: string;
  /** Name of the customer linked to this contract
    Pulled from the DB as linked data to Customer ID - client never sends this */
  billToName?: string | null;
  /** Type of service for the contract */
  service: string;
  /** Is the contract rate audited? */
  rateAudit: boolean;
  /** Is the service audited? */
  svcAudit: boolean;
  /** ID for a CM Billing contract */
  cmBillContractId: number;
  /** ID for a CM Cost contract */
  cmCostContractId: number;
  /** Is Billing Contract Class required? */
  bcClassReq: boolean;
  /** Is Billing Contract Weight required? */
  bcWeightReq: boolean;
  /** Is Cost Contract Class required? */
  ccClassReq: boolean;
  /** Is Cost Contract Weight required? */
  ccWeightReq: boolean;
  /** # of days a contract can be net due */
  netDueDays: number;
  /** # of days a contract can have a discount */
  netDiscountDays: number;
  /** Discount % */
  netDiscountPct: number;
};
export type CodeMasterVm = {
  /** Which element the codes are sorted into */
  element: string;
  /** The actual code */
  code: string;
  /** A human-understandable description of the code */
  description: string;
  /** Alternate code used for sorting */
  preferredOrder?: string | null;
};
export type CodeMasterElements = {
  /** List of the elements to include in the filter list */
  elementList?: string[] | null;
  /** Which element to start filtering to */
  defaultElement?: string | null;
};
export type StatusMasterVm = {
  status?: string | null;
  sequence?: number | null;
  statGroup?: string | null;
  showInWeb?: boolean | null;
  showInDashboard?: boolean;
  id?: number;
  isAuditFailStatus?: boolean;
};
export type StatusCodeVm = {
  code: string;
  description?: string | null;
};
export type ContactsVm = {
  /** Internal record ID */
  id: number;
  /** ID of the Bill-To this contact is for */
  btid: string;
  /** What kind of contact this is */
  type?: string | null;
  /** The contact person's title */
  ctitle?: string | null;
  /** Unused field */
  code?: string | null;
  /** The contact person's name */
  name?: string | null;
  /** Line 1 of the contact person's address */
  address1?: string | null;
  /** Line 2 of the contact person's address */
  address2?: string | null;
  /** The contact person's city */
  city?: string | null;
  /** The contact person's state or province */
  stateProv?: string | null;
  /** The contact person's postal code */
  postal?: string | null;
  /** What kind of phone contact #1 is */
  phone1Type?: string | null;
  /** Phone number 1 */
  phone1Num?: string | null;
  /** What kind of phone contact #2 is */
  phone2Type?: string | null;
  /** Phone number 2 */
  phone2Num?: string | null;
  /** Email address #1 */
  email1?: string | null;
  /** Email address #2 */
  email2?: string | null;
  /** Unused field */
  comments?: string | null;
  /** Who added this contact to the Bill-To record? */
  createdBy?: string | null;
  /** When this contact was added to the Bill-To record? */
  createdDate?: string;
  /** Who last updated this contact on the Bill-To record? */
  updatedBy?: string | null;
  /** When this contact was updated on the Bill-To record? */
  updatedDate?: string;
  /** When the contact was last used */
  lastUsed?: string;
  /** Is this contact used on fee invoices? */
  useOnFeeInvoice?: boolean | null;
};
export type CurrenciesVm = {
  /** Code for the currency's home country */
  countryCode: string;
  /** Currency ID */
  id: string;
  /** Name of the currency's country */
  countryName?: string | null;
  /** Currency description */
  description?: string | null;
  /** Currency symbol */
  symbol?: string | null;
  /** Is the currency in use? */
  inUse?: boolean;
};
export type CustomerDataEntryGridVm = {
  /** Internal ID for this ref-def entry */
  id?: number;
  /** ID of the Bill-To this ref-def entry is for */
  btid?: string | null;
  /** ID of the carrier this ref-def entry is for */
  carrierId?: string | null;
  /** Which ASC Ref Code this ref-def entry is for */
  ascrefCode?: string | null;
  /** Ordering number for fields in Data Entry.
    Main number controls which section of the form the field appears in
    Decimal value controls order within a sub-field area */
  dispOrder?: number;
  /** Bill-To-specific description of the ASC Ref Code */
  customerDescription?: string | null;
  /** Does this code allow multiple values in Data Entry? */
  allowMulti?: string | null;
  /** Does this code require a value in Data Entry? */
  requiredFieldIndicator?: string | null;
  /** Where this code is used in Carrier Invoices (?)
    Appears to be a legacy field */
  detailLocation?: string | null;
  /** Which mask pattern (if any) defines a valid value for this field */
  fieldFormat?: string | null;
  /** Which validation method (if any) is used for this field
    "Permitted Values" is the only extant option */
  validationTechnique?: string | null;
  /** Tooltip text for the field */
  tipText?: string | null;
  /** Y/N boolean for if this ref-def code is selected for this Bill-To */
  selected?: string | null;
  /** Full description of an ASC Ref Code */
  longDescription?: string | null;
  /** Y/N boolean for if this ASC ref code is in use */
  inUse?: string | null;
};
export type CustomerDataEntryCodeListVm = {
  /** Which ASC Ref Code this ref-def entry is for */
  ascrefCode: string;
  /** Bill-To-specific description of the ASC Ref Code */
  customerDescription?: string | null;
};
export type CreateReceivableBatchesForCustomersVm = {
  /** The date of the batch */
  batchDate?: string;
  /** Included invoices with a Projected Request Date before this */
  projectedRequestDatesToInclude?: string | null;
  /** List of customers to process */
  customers?: string[] | null;
};
export type ChildBatchResultVm = {
  /** ID of the Parent Bill-To */
  parentId?: string | null;
  /** Name of the Child Bill-To */
  billTo?: string | null;
  /** # of Carrier Invoices linked to the Bill-To */
  invoices?: number;
  /** # of shipments linked to the Bill-To */
  shipments?: number | null;
  /** Total Approved Net Due for the Bill-To */
  netDue?: number | null;
  /** Which currency the Bill-To will be paid in */
  currency?: string | null;
};
export type AgedReceivablesVm = {
  batchID?: number;
  name?: string | null;
  sfrEmail?: string | null;
  description?: string | null;
  totalAmt?: number;
  approvedAmt?: number;
  fundedAmt?: number;
  openAmt?: number;
  status?: string | null;
  invoiceCount?: number;
  createDate?: string;
  batchDate?: string;
};
export type CustPaySetupVm = {
  /** Is this setup currently active? */
  active?: boolean;
  /** ID of the Bill-To this setup is for */
  btId: string;
  /** ID of the Carrier this setup is for */
  carrId: string;
  /** When this setup was added to the Bill-To record? */
  createDate?: string;
  /** Who added this setup to the Bill-To record? */
  createUser?: string | null;
  /** Internal record ID */
  id: number;
  /** When this setup was updated on the Bill-To record? */
  lastUpdateDate?: string;
  /** Who last updated this setup on the Bill-To record? */
  lastUpdateUser?: string | null;
  /** Shipping mode this setup is for */
  mode?: string | null;
};
export type ShipmentCountByStatusVm = {
  status?: string | null;
  invoiceCount?: number;
  invoiceAmount?: number;
};
export type ShipmentCountByStatusVmRead = {
  status?: string | null;
  invoiceCount?: number;
  invoiceAmount?: number;
  currency?: string | null;
};
export type AgedInvoiceSummaryVm = {
  invoices?: number;
  shipments?: number | null;
  amountDue?: number | null;
};
export type AgedInvoiceSummaryVmRead = {
  requestDate?: string | null;
  invoices?: number;
  shipments?: number | null;
  amountDue?: number | null;
  currency?: string | null;
};
export type DeAdminVm = {
  /** ID of the Bill-To this mapping is for */
  btid: string;
  /** Name of the Bill-To this mapping is for */
  btName?: string | null;
  /** ID of the Carrier this Bill-To setup is for */
  carrierId: string;
  /** Name of the Carrier this mapping is for */
  carrierName?: string | null;
  /** Is the Invoice Detail's Currency Selection shown?
    -1 for True, 0 for False */
  invDetCurrSelShow?: number | null;
  /** Is the Invoice Detail's Currency Selection required?
    -1 for True, 0 for False */
  invDetCurrSelReq?: number | null;
  /** Is the Invoice Detail's Exchange Rate shown?
    -1 for True, 0 for False */
  invDetCurrExchShow?: number | null;
  /** Is the Invoice Detail's Exchange Rate required?
    -1 for True, 0 for False */
  invDetCurrExchReq?: number | null;
  /** Is the Invoice Detail's Delivery Date shown?
    -1 for True, 0 for False */
  invDetDelDateShow?: number | null;
  /** Is the Invoice Detail's Delivery Date required?
    -1 for True, 0 for False */
  invDetDelDateReq?: number | null;
  /** Is the Invoice Detail's Terms shown?
    -1 for True, 0 for False */
  invDetTermsShow?: number | null;
  /** Is the Invoice Detail's Terms required?
    -1 for True, 0 for False */
  invDetTermsReq?: number | null;
  /** Is the Invoice Detail's Inbound/Outbound shown?
    -1 for True, 0 for False */
  invDetIbobshow?: number | null;
  /** Is the Invoice Detail's Inbound/Outbound required?
    -1 for True, 0 for False */
  invDetIbobreq?: number | null;
  /** Is the Totals group included at all?
    -1 for True, 0 for False */
  grpTotalsShow?: number | null;
  /** Is the Total Gross shown?
    -1 for True, 0 for False */
  totalsGrossShow?: number | null;
  /** Is the Total Gross required?
    -1 for True, 0 for False */
  totalsGrossReq?: number | null;
  /** Is the Total Deficit shown?
    -1 for True, 0 for False */
  totalsDeficitShow?: number | null;
  /** Is the Total Deficit required?
    -1 for True, 0 for False */
  totalsDeficitReq?: number | null;
  /** Is the Fuel Total shown?
    -1 for True, 0 for False */
  totalsFuelShow?: number | null;
  /** Is the Fuel Total required?
    -1 for True, 0 for False */
  totalsFuelReq?: number | null;
  /** Is the Accessorial Total shown?
    -1 for True, 0 for False */
  totalsAccessShow?: number | null;
  /** Is the Accessorial Total required?
    -1 for True, 0 for False */
  totalsAccessReq?: number | null;
  /** Is the Discount Total shown?
    -1 for True, 0 for False */
  totalsDiscShow?: number | null;
  /** Is the Discount Total required?
    -1 for True, 0 for False */
  totalsDiscReq?: number | null;
  /** Is the Shipper Details group included at all?
    -1 for True, 0 for False */
  grpShipperShow?: number | null;
  /** Do Shipper Details use autofill?
    -1 for True, 0 for False */
  shipperAutoFill?: number | null;
  /** Is the Shipper's Postal Code shown?
    -1 for True, 0 for False */
  shipperPostalShow?: number | null;
  /** Is the Shipper's Postal Code required?
    -1 for True, 0 for False */
  shipperPostalReq?: number | null;
  /** Is the Shipper's Name shown?
    -1 for True, 0 for False */
  shipperNameShow?: number | null;
  /** Is the Shipper's Name required?
    -1 for True, 0 for False */
  shipperNameReq?: number | null;
  /** Is the Shipper's Address line 1 shown?
    -1 for True, 0 for False */
  shipperAddr1Show?: number | null;
  /** Is the Shipper's Address line 1 required?
    -1 for True, 0 for False */
  shipperAddr1Req?: number | null;
  /** Is the Shipper's Address line 2 shown?
    -1 for True, 0 for False */
  shipperAddr2Show?: number | null;
  /** Is the Shipper's Address line 2 required?
    -1 for True, 0 for False */
  shipperAddr2Req?: number | null;
  /** Is the Shipper's Address line 3 shown?
    -1 for True, 0 for False */
  shipperAddr3Show?: number | null;
  /** Is the Shipper's Address line 3 required?
    -1 for True, 0 for False */
  shipperAddr3Req?: number | null;
  /** Is the Shipper's Address line 4 shown?
    -1 for True, 0 for False */
  shipperAddr4Show?: number | null;
  /** Is the Shipper's Address line 4 required?
    -1 for True, 0 for False */
  shipperAddr4Req?: number | null;
  /** Is the Shipper's City shown?
    -1 for True, 0 for False */
  shipperCityShow?: number | null;
  /** Is the Shipper's City required?
    -1 for True, 0 for False */
  shipperCityReq?: number | null;
  /** Is the Shipper's State/Province shown?
    -1 for True, 0 for False */
  shipperStateShow?: number | null;
  /** Is the Shipper's State/Province required?
    -1 for True, 0 for False */
  shipperStateReq?: number | null;
  /** Is the Consignee Details group included at all?
    -1 for True, 0 for False */
  grpCnsShow?: number | null;
  /** Do Consignee Details use autofill?
    -1 for True, 0 for False */
  cnsAutoFill?: number | null;
  /** Is the Consignee's Postal Code shown?
    -1 for True, 0 for False */
  cnsPostalShow?: number | null;
  /** Is the Consignee's Postal Code required?
    -1 for True, 0 for False */
  cnsPostalReq?: number | null;
  /** Is the Consignee's Name shown?
    -1 for True, 0 for False */
  cnsNameShow?: number | null;
  /** Is the Consignee's Name required?
    -1 for True, 0 for False */
  cnsNameReq?: number | null;
  /** Is the Consignee's address line 1 shown?
    -1 for True, 0 for False */
  cnsAddr1Show?: number | null;
  /** Is the Consignee's address line 1 required?
    -1 for True, 0 for False */
  cnsAddr1Req?: number | null;
  /** Is the Consignee's address line 2 shown?
    -1 for True, 0 for False */
  cnsAddr2Show?: number | null;
  /** Is the Consignee's address line 2 required?
    -1 for True, 0 for False */
  cnsAddr2Req?: number | null;
  /** Is the Consignee's address line 3 shown?
    -1 for True, 0 for False */
  cnsAddr3Show?: number | null;
  /** Is the Consignee's address line 3 required?
    -1 for True, 0 for False */
  cnsAddr3Req?: number | null;
  /** Is the Consignee's address line 4 shown?
    -1 for True, 0 for False */
  cnsAddr4Show?: number | null;
  /** Is the Consignee's address line 4 required?
    -1 for True, 0 for False */
  cnsAddr4Req?: number | null;
  /** Is the Consignee's city shown?
    -1 for True, 0 for False */
  cnsCityShow?: number | null;
  /** Is the Consignee's city required?
    -1 for True, 0 for False */
  cnsCityReq?: number | null;
  /** Is the Consignee's state/province shown?
    -1 for True, 0 for False */
  cnsStateShow?: number | null;
  /** Is the Consignee's state/province required?
    -1 for True, 0 for False */
  cnsStateReq?: number | null;
  /** Is the Charge Item Detail group included at all?
    -1 for True, 0 for False */
  grpLidshow?: number | null;
  /** Is the Charge Item Pieces shown?
    -1 for True, 0 for False */
  lidpiecesShow?: number | null;
  /** Is the Charge Item Pieces required?
    -1 for True, 0 for False */
  lidpiecesReq?: number | null;
  /** Is the Charge Item Packing Unit of Measurement shown?
    -1 for True, 0 for False */
  lidpackShow?: number | null;
  /** Is the Charge Item Packing Unit of Measurement required?
    -1 for True, 0 for False */
  lidpackReq?: number | null;
  /** Is the Charge Item Lading Unit of Measurement shown?
    -1 for True, 0 for False */
  lidunitsShow?: number | null;
  /** Is the Charge Item Lading Unit of Measurement required?
    -1 for True, 0 for False */
  lidunitsReq?: number | null;
  /** Is the Charge Item Lading Quantity shown?
    -1 for True, 0 for False */
  lidqtyShow?: number | null;
  /** Is the Charge Item Lading Quantity required?
    -1 for True, 0 for False */
  lidqtyReq?: number | null;
  /** Is the Charge Item Weight shown?
    -1 for True, 0 for False */
  lidweightShow?: number | null;
  /** Is the Charge Item Weight required?
    -1 for True, 0 for False */
  lidweightReq?: number | null;
  /** Is the Charge Item Class shown?
    -1 for True, 0 for False */
  lidclassShow?: number | null;
  /** Is the Charge Item Class required?
    -1 for True, 0 for False */
  lidclassReq?: number | null;
  /** Is the Charge Item Hazmat code shown?
    -1 for True, 0 for False */
  lidhazShow?: number | null;
  /** Is the Charge Item Hazmat code required?
    -1 for True, 0 for False */
  lidhazReq?: number | null;
  /** Is the Charge Item Charge Code shown?
    -1 for True, 0 for False */
  lidchgCodeShow?: number | null;
  /** Is the Charge Item Charge Code required?
    -1 for True, 0 for False */
  lidchgCodeReq?: number | null;
  /** Is the Charge Item Charge Amount shown?
    -1 for True, 0 for False */
  lidchgAmtShow?: number | null;
  /** Is the Charge Item Charge Amount required?
    -1 for True, 0 for False */
  lidchgAmtReq?: number | null;
  /** Is the Charge Item Description shown?
    -1 for True, 0 for False */
  liddescrShow?: number | null;
  /** Is the Charge Item Description required?
    -1 for True, 0 for False */
  liddescrReq?: number | null;
  /** Is the Charge Item Commodity code shown?
    -1 for True, 0 for False */
  lidcommodityShow?: number | null;
  /** Is the Charge Item Commodity code required?
    -1 for True, 0 for False */
  lidcommodityReq?: number | null;
  /** Is the Reference information group visible?
    -1 for True, 0 for False */
  grpRefDataShow?: number | null;
  /** Is the Customer Account shown?
    -1 for True, 0 for False */
  custAcctShow?: number | null;
  /** Is the Customer Account required?
    -1 for True, 0 for False */
  custAcctReq?: number | null;
  /** Is the Carrier Invoice Equipment shown?
    -1 for True, 0 for False */
  invEquipShow?: number | null;
  /** Is the Carrier Invoice Equipment required?
    -1 for True, 0 for False */
  invEquipReq?: number | null;
  /** Is the Carrier Invoice Mode shown?
    -1 for True, 0 for False */
  invModeShow?: number | null;
  /** Is the Carrier Invoice Mode required?
    -1 for True, 0 for False */
  invModeReq?: number | null;
  /** Is the Carrier Invoice Service shown?
    -1 for True, 0 for False */
  invServiceShow?: number | null;
  /** Is the Carrier Invoice Service required?
    -1 for True, 0 for False */
  invServiceReq?: number | null;
  /** Is the shipment details's Mode required?
    -1 for True, 0 for False */
  shipModeReq?: number | null;
  /** Is the shipment details's Mode visible?
    -1 for True, 0 for False */
  shipModeShow?: number | null;
  /** Is the shipment details's Equipment required?
    -1 for True, 0 for False */
  shipEquipReq?: number | null;
  /** Is the shipment details's Equipment visible?
    -1 for True, 0 for False */
  shipEquipShow?: number | null;
  /** Is the shipment details's Service visible?
    -1 for True, 0 for False */
  shipServiceShow?: number | null;
  /** Is the shipment details's Service required?
    -1 for True, 0 for False */
  shipServiceReq?: number | null;
  /** Is the shipment details's Terms visible?
    -1 for True, 0 for False */
  shipTermsShow?: number | null;
  /** Is the shipment details's Terms required?
    -1 for True, 0 for False */
  shipTermsReq?: number | null;
  /** Is the shipment details's Inbound/Outbound visible?
    -1 for True, 0 for False */
  shipIbobshow?: number | null;
  /** Is the shipment details's Inbound/Outbound required?
    -1 for True, 0 for False */
  shipIbobreq?: number | null;
  /** Is the shipment details's Delivery date/time visible?
    -1 for True, 0 for False */
  shipDelDateShow?: number | null;
  /** Is the shipment details's Delivery date/time required?
    -1 for True, 0 for False */
  shipDelDateReq?: number | null;
};
export type DateExportStatus = "Pending" | "Processing" | "Done";
export type DataExportsVm = {
  id?: number;
  statusId?: DateExportStatus;
  statusIdDisplay?: string | null;
  userJobName?: string | null;
  s3Bucket?: string | null;
  s3Key?: string | null;
  jobCreatedDate?: string;
  jobCompletedDate?: string | null;
};
export type ExportFileFormat = "csv" | "xlsx";
export type ModeVm = {
  code: string;
  description?: string | null;
};
export type ModeVmRead = {
  code: string;
  value?: string | null;
  description?: string | null;
  label?: string | null;
};
export type EntryMethodVm = {
  code: string;
  description?: string | null;
  selected?: boolean;
};
export type DateTimeRangeVm = {
  start?: string | null;
  end?: string | null;
};
export type InvoiceResearchOptionsVm = {
  /** Carriers to search by */
  carriers?: CarrierMinimalVm[] | null;
  /** Bill-Tos to search by */
  billTos?: BillToMinimalVm[] | null;
  /** Modes to search by */
  mode?: ModeVm[] | null;
  /** StatusCodes to search by */
  statusCodes?: StatusCodeVm[] | null;
  /** ReferenceCodes to search by */
  referenceCodes?: AscReferenceCodeVm[] | null;
  /** Entry methods to search by (paper, EDI, etc.) */
  entryMethods?: EntryMethodVm[] | null;
  /** Carrier Invoice types to search by (active, memo, deleted, etc.) */
  invoiceTypes?: EntryMethodVm[] | null;
  entered?: DateTimeRangeVm;
  processed?: DateTimeRangeVm;
  checkDate?: DateTimeRangeVm;
  shipped?: DateTimeRangeVm;
  /** Searches by Carrier Invoice number */
  invoices?: string | null;
  /** Searches by Air Bill Number */
  airBillNums?: string | null;
  /** Searches by check numbers invoices were paid to the carrier by */
  checks?: string | null;
  /** Searches by Reference value */
  findReference?: string | null;
  /** Sets search type */
  referenceSearchType?: string | null;
  /** Sets the types of wildcard searches for References */
  referenceSearchTypes?: string[] | null;
  shipper?: PartyVm;
  consignee?: PartyVm;
  /** Column to sort by */
  sortBy?: string | null;
  /** Sets the page.  Use a 1 based index.  (first page is 1, not 0) */
  page?: number | null;
  recordCountRequested?: number | null;
  declaredCount?: number | null;
  sortAscending?: boolean;
};
export type InvoiceResearchOptionsVmRead = {
  /** Carriers to search by */
  carriers?: CarrierMinimalVm[] | null;
  /** Bill-Tos to search by */
  billTos?: BillToMinimalVmRead[] | null;
  /** Modes to search by */
  mode?: ModeVmRead[] | null;
  /** StatusCodes to search by */
  statusCodes?: StatusCodeVm[] | null;
  /** ReferenceCodes to search by */
  referenceCodes?: AscReferenceCodeVm[] | null;
  /** Entry methods to search by (paper, EDI, etc.) */
  entryMethods?: EntryMethodVm[] | null;
  /** Carrier Invoice types to search by (active, memo, deleted, etc.) */
  invoiceTypes?: EntryMethodVm[] | null;
  entered?: DateTimeRangeVm;
  processed?: DateTimeRangeVm;
  checkDate?: DateTimeRangeVm;
  shipped?: DateTimeRangeVm;
  /** Searches by Carrier Invoice number */
  invoices?: string | null;
  /** Searches by Air Bill Number */
  airBillNums?: string | null;
  /** Searches by check numbers invoices were paid to the carrier by */
  checks?: string | null;
  /** Searches by Reference value */
  findReference?: string | null;
  /** Sets search type */
  referenceSearchType?: string | null;
  /** Sets the types of wildcard searches for References */
  referenceSearchTypes?: string[] | null;
  shipper?: PartyVm;
  consignee?: PartyVm;
  /** Column to sort by */
  sortBy?: string | null;
  /** Sets the page.  Use a 1 based index.  (first page is 1, not 0) */
  page?: number | null;
  recordCountRequested?: number | null;
  /** Read only property that handles null Record Count Requested */
  requestedRecordCount?: number;
  declaredCount?: number | null;
  sortAscending?: boolean;
};
export type EmailVm = {
  to?: string | null;
  cc?: string | null;
  subject?: string | null;
  body?: string | null;
};
export type EquipmentVm = {
  /** Internal code for a type of equipment */
  code?: string | null;
  /** Description for a type of equipment */
  description?: string | null;
  /** Associated CM Code (if any) */
  cmcode?: string | null;
  /** Is this type of equipment being used in the system? */
  inUse?: boolean | null;
};
export type CustFeesHdrVm = {
  /** GUID of the Fee Invoice this header info is for */
  feeInvoiceId?: string;
  /** ID of the Bill-To this Fee Invoice header is for */
  btid?: string | null;
  /** Fee Invoice Date */
  invDate?: string | null;
  /** Total amount due on the Fee Invoice */
  totalDue?: number | null;
  /** Fee Invoice Status */
  status?: string | null;
  /** Fee Invoice creation date */
  createDate?: string | null;
  /** Total of Transaction-style charges on this Fee Invoice */
  totalTransactionCharge?: number | null;
  /** Total of Periodic-style charges on this Fee Invoice */
  totalPeriodicCharge?: number | null;
  /** Total of Benchmark-Share charges on this Fee Invoice */
  totalBenchmarkShareCharge?: number | null;
  /** Total of Gain-Sharing charges on this Fee Invoice */
  totalGainSharingCharge?: number | null;
  /** Fee Invoice Number */
  invoiceNo?: string | null;
  /** Start date for included charges */
  fromDate?: string | null;
  /** End date for included charges */
  throughDate?: string | null;
};
export type CustFeesRangeHdrVm = {
  /** Name of the Bill-To this Fee Invoice header is for */
  custName?: string | null;
  /** Should this Fee Invoice be imported into PayLOGIK? */
  importInvoice?: boolean | null;
  /** Should this Fee Invoice be emailed out? */
  emailInvoice?: boolean | null;
  /** Should this Fee Invoice be printed? */
  printInvoice?: boolean | null;
  /** GUID of the Fee Invoice this header info is for */
  feeInvoiceId?: string;
  /** ID of the Bill-To this Fee Invoice header is for */
  btid?: string | null;
  /** Fee Invoice Date */
  invDate?: string | null;
  /** Total amount due on the Fee Invoice */
  totalDue?: number | null;
  /** Fee Invoice Status */
  status?: string | null;
  /** Fee Invoice creation date */
  createDate?: string | null;
  /** Total of Transaction-style charges on this Fee Invoice */
  totalTransactionCharge?: number | null;
  /** Total of Periodic-style charges on this Fee Invoice */
  totalPeriodicCharge?: number | null;
  /** Total of Benchmark-Share charges on this Fee Invoice */
  totalBenchmarkShareCharge?: number | null;
  /** Total of Gain-Sharing charges on this Fee Invoice */
  totalGainSharingCharge?: number | null;
  /** Fee Invoice Number */
  invoiceNo?: string | null;
  /** Start date for included charges */
  fromDate?: string | null;
  /** End date for included charges */
  throughDate?: string | null;
};
export type CustFeesRangeRequestVm = {
  /** Start date for the Fee Invoice range */
  startDate: string;
  /** End date for the Fee Invoice range */
  endDate: string;
  /** Do we only want the most recent Fee Invoices? */
  mostRecent?: boolean | null;
  /** Do we only want fresh and re-ran Fee Invoices? */
  onlyNewOrRerun?: boolean | null;
  /** Do we include Harcros in the range? */
  includeHarcros?: boolean | null;
  /** Do we only grab Harcros Fee Invoices? */
  onlyHarcros?: boolean | null;
};
export type CustFeesDetailVm = {
  /** GUID for the Fee Invoice this detail line is for */
  feeInvoiceId?: string;
  /** ID for the rule responsible for this detail line */
  custInvoiceRuleId?: string;
  /** Description of the rule responsible for this detail line */
  ruleDescription?: string | null;
  /** Internal description of the rule responsible for this detail line */
  internalDescription?: string | null;
  /** Name of the Bill-To this rule is for (used in parent/child scenarios) */
  custName?: string | null;
  /** Fee Invoice charge quantity */
  qty?: number | null;
  /** Fee Invoice per-unit charge */
  unitCharge?: number | null;
  /** Fee Invoice extended charge */
  extendedCharge?: number | null;
};
export type CustFeesDetailReportVm = {
  /** URL of the detailed report file */
  url?: string | null;
};
export type CustFeesChangeInvNumVm = {
  /** GUID of the Fee Invoice to update */
  feeInvoiceId: string;
  /** New invoice number for this Fee Invoice */
  invoiceNum: string;
};
export type CustFeesImportRequestLine = {
  /** ID of the Bill-To whose Fee Invoice we want to import */
  custId?: string | null;
  /** GUID of the Fee Invoice we want to import */
  feeInvoiceId?: string;
};
export type CustFeesImportRequestVm = {
  /** Starting date for the Fee Invoice ranges */
  startDate: string;
  /** End Date for the Fee Invoice ranges */
  endDate: string;
  /** List of the Fee Invoices to import */
  imports: CustFeesImportRequestLine[];
};
export type CustFeesInvoiceTestCustomerVm = {
  /** Which customer this data is for */
  customerId?: string | null;
  lineData?: CustFeesHdrVm;
  /** Detailed breakdown of the charges that make up this line */
  lineDetails?: CustFeesDetailVm[] | null;
  /** Rule descriptions for use in test data breakdowns */
  lineDescrips?: {
    [key: string]: string | null;
  } | null;
};
export type CustFeesInvoiceTestResultsVm = {
  /** Any errors that happened during the test */
  errors?: string | null;
  /** Results generated from the test */
  results?: CustFeesInvoiceTestCustomerVm[] | null;
};
export type CustFeesMakeInvoiceRequestVm = {
  /** Is this a single-customer run or an all-customer one? */
  isSingle: boolean;
  /** For single runs, which customer it's for */
  customerId?: string | null;
  /** Is this a fresh run or a rerun? */
  isRerun: boolean;
  /** Start of search range for pay-to-terms customers
    Not used for non-pay-to-terms customers */
  fromDate?: string | null;
  /** End of search range for pay-to-terms customers
    Batch creation date limit for non-pay-to-terms customers */
  throughDate: string;
  /** Date to use for calculating periodic charges */
  periodicChargeDate: string;
  /** Date to print on generated Fee Invoices */
  invoiceDate: string;
};
export type CustFeesRuleVm = {
  /** Rule ID */
  id?: number;
  /** What kind of rule (transaction, periodic, etc) */
  ruleType?: string | null;
  /** Base charge amount applied by this rule */
  charge?: number | null;
  /** Charges applied per (bill, shipment, period, etc) */
  billPer?: string | null;
  /** "External" description of the rule */
  description?: string | null;
  /** "Internal" description of the rule */
  internalDescrip?: string | null;
  /** What Carrier Invoice source (EDI, paper, etc) this rule applies to */
  source?: string | null;
  /** Does this rule apply to SINGLE Carrier Invoices or STATEMENTs? */
  invType?: string | null;
  /** Does this rule apply to DOMESTIC shipments or INTERNATIONAL ones? */
  intDom?: string | null;
  /** Minimum allowed charge for this rule */
  minCharge?: number | null;
  /** Maximum allowed charge for this rule */
  maxCharge?: number | null;
  /** When this rule becomes effective */
  startDate?: string | null;
  /** When this rule stops being effective */
  stopDate?: string | null;
  /** Is this rule inherited/passed-down in parent/child customer setups? */
  applyToChildren?: boolean | null;
  /** List of carriers this rule checks */
  carrIdList?: string[] | null;
  /** Are the listed carriers exclusive or inclusive? */
  excludeCarriers?: boolean | null;
  /** List of modes this rule checks */
  modeList?: string[] | null;
  /** Are the listed modes exclusive or inclusive? */
  excludeModes?: boolean | null;
  /** When this rule was last applied to a Carrier Invoice */
  lastAppliedDate?: string | null;
};
export type CustInvoiceRuleVm = {
  /** Rule GUID */
  custInvoiceRuleId?: string;
  /** Is this rule inherited/passed-down in parent/child customer setups? */
  applyToChildren?: boolean | null;
  /** What kind of rule (transaction, periodic, etc) */
  ruleType?: string | null;
  /** Base charge amount applied by this rule */
  charge?: number | null;
  /** Charges applied per (bill, shipment, period, etc) */
  per?: string | null;
  /** "External" description of the rule */
  description?: string | null;
  /** "Internal" description of the rule */
  internalDescription?: string | null;
  /** What Carrier Invoice source (EDI, paper, etc) this rule applies to */
  source?: string | null;
  /** What ship mode (LTL, ocean, etc) this rule applies to */
  mode?: string | null;
  /** Does this rule apply to SINGLE Carrier Invoices or STATEMENTs? */
  type?: string | null;
  /** Does this rule apply to DOMESTIC shipments or INTERNATIONAL ones? */
  intDom?: string | null;
  /** Minimum allowed charge for this rule */
  min?: number | null;
  /** Maximum allowed charge for this rule */
  max?: number | null;
  /** When this rule becomes effective */
  startDate?: string | null;
  /** When this rule stops being effective */
  stopDate?: string | null;
  /** Is the mode from before exclusive or inclusive? */
  excludeMode?: boolean | null;
  /** When this rule was last applied to a Carrier Invoice */
  lastAppliedDate?: string | null;
  /** List of carriers this rule checks */
  carrIdList?: string[] | null;
  /** Is the carrier list exclusive or inclusive? */
  excludeCarriers?: boolean | null;
};
export type CustFeesRuleComparisonVm = {
  /** List of rules for a Bill-To using the new structure */
  newRules?: CustFeesRuleVm[] | null;
  /** List of rules for a Bill-To using the old structure */
  oldRules?: CustInvoiceRuleVm[] | null;
};
export type CustFeesRuleTypeDetailsVm = {
  /** Rule ID */
  id?: number | null;
  /** ID of the Bill-To this detail setup is for */
  btId: string;
  /** ID for what kind of rule (transaction, periodic, etc) */
  ruleTypeId: number;
  /** Minimum allowed charge for this rule type */
  minCharge?: number | null;
  /** Maximum allowed charge for this rule type */
  maxCharge?: number | null;
};
export type CustFeesRulesAndDetailsVm = {
  /** List of rules for the Bill-To */
  rules?: CustFeesRuleVm[] | null;
  /** List of rule-type details for the Bill-To */
  details?: CustFeesRuleTypeDetailsVm[] | null;
};
export type CustFeesRuleInfoVm = {
  /** Rule ID */
  id?: number;
  /** ID of the Bill-To this rule is for */
  btId: string;
  /** What kind of rule (transaction, periodic, etc) */
  ruleTypeId: number;
  /** Base charge amount applied by this rule */
  charge?: number | null;
  /** Charges applied per (bill, shipment, period, etc) */
  billPerId: number;
  /** "External" description of the rule */
  description?: string | null;
  /** "Internal" description of the rule */
  internalDescrip?: string | null;
  /** What Carrier Invoice source (EDI, paper, etc) this rule applies to */
  source?: string | null;
  /** Does this rule apply to SINGLE Carrier Invoices or STATEMENTs? */
  invType?: string | null;
  /** Does this rule apply to DOMESTIC shipments or INTERNATIONAL ones? */
  intDomId?: number | null;
  /** Minimum allowed charge for this rule */
  minCharge?: number | null;
  /** Maximum allowed charge for this rule */
  maxCharge?: number | null;
  /** When this rule becomes effective */
  startDate?: string | null;
  /** When this rule stops being effective */
  stopDate?: string | null;
  /** Is this rule inherited/passed-down in parent/child customer setups? */
  applyToChildren?: boolean | null;
  /** List of carriers this rule checks */
  carrIdList?: string[] | null;
  /** Are the listed carriers exclusive or inclusive? */
  excludeCarriers?: boolean | null;
  /** List of modes this rule checks */
  modeList?: string[] | null;
  /** Are the listed modes exclusive or inclusive? */
  excludeModes?: boolean | null;
};
export type CustFeesCategoryVm = {
  /** Category ID */
  id?: number;
  /** Category Name */
  name?: string | null;
};
export type FunctionsVm = {
  /** Function identifier (e.g., "APPROVE_INVOICES", "MANAGE_USERS") */
  functionId: string;
  /** Human-readable description of the function */
  description: string;
};
export type TargetLevel = "All" | "CarrierInvoice" | "CarrierInvoiceLine";
export type GlBulkCodingRequest = {
  btid?: string | null;
  endDate?: string | null;
  level?: TargetLevel;
  overwriteExistingGlCodes?: boolean;
  startDate?: string | null;
  socketId?: string | null;
};
export type GlCodingRequest = {
  addGlRefRecords?: boolean;
  invoiceId?: number;
  level?: TargetLevel;
};
export type HopkinsDepartmentData = {
  accountNum?: string | null;
  outboundCountry?: string | null;
};
export type HopkinsDepartmentVm = {
  billToId?: string | null;
  departments?: string | null;
  comments?: string | null;
  additionalData?: HopkinsDepartmentData;
};
export type ImageType =
  | "None"
  | "AddPage"
  | "BL_1"
  | "BL_2"
  | "BL_3"
  | "BL_4"
  | "BL_5"
  | "BL_6"
  | "BL_7"
  | "BOL"
  | "CINV"
  | "DR_1"
  | "DR_2"
  | "DR_3"
  | "EDIInvoice"
  | "Images"
  | "INV"
  | "Invoice"
  | "LOA"
  | "Misc"
  | "OTHER"
  | "POD";
export type DisconnectedCarrInvImagesVm = {
  /** ID of the CarrInvImages record */
  id?: number;
  /** ID of the carrier associated with this image */
  carrierId?: string | null;
  /** Name of the carrier associated with this image */
  carrierName?: string | null;
  /** Carrier Invoice Number the image is linked to (may not actually exist in CarrInv) */
  invoiceNum?: string | null;
  /** Carrier Invoice Revision # the image is potentially linked to (or -999 if no candidates) */
  revNum?: number;
  /** ID of the Carrier Invoice the image is linked to, if it exists */
  invIdx?: number;
  /** Shipment # the image is associated with */
  shipmentNum?: string | null;
  imageType?: ImageType;
  /** A carrier this image could be linked to, generally just mimics CarrierName */
  possibly?: string | null;
  /** Subfolder for the image data in S3 storage */
  subFolder?: string | null;
  /** Local image path, if any */
  imagePath?: string | null;
  /** Image's file name */
  imageFileName?: string | null;
  /** When the image was scanned in */
  creationTime?: string;
  /** When the image was linked to a Carrier Invoice */
  dateLinked?: string;
};
export type CarrInvImages = {
  id?: number;
  recType?: string | null;
  carrierId?: string | null;
  invoicenum?: string | null;
  revNum?: number;
  shipmentNum?: string | null;
  imageType?: string | null;
  imagePath?: string | null;
  imageName?: string | null;
  invIdx?: number;
  dateLinked?: string;
  fileDate?: string | null;
  invoiceTotal?: number;
  subFolder?: string | null;
  originalFileName?: string | null;
  source?: string | null;
  s3Path?: string | null;
};
export type CarrInvImagesRead = {
  id?: number;
  recType?: string | null;
  carrierId?: string | null;
  invoicenum?: string | null;
  revNum?: number;
  shipmentNum?: string | null;
  imageType?: string | null;
  imagePath?: string | null;
  imageName?: string | null;
  invIdx?: number;
  dateLinked?: string;
  fileDate?: string | null;
  invoiceTotal?: number;
  subFolder?: string | null;
  awsSubKey?: string | null;
  originalFileName?: string | null;
  source?: string | null;
  s3Path?: string | null;
};
export type CarrInvImageScanVm = {
  /** ID of the scanned image */
  scanId?: number;
  /** ID of the linked Bill-To */
  custId: string;
  /** Name of the linked Bill-To */
  custName?: string | null;
  /** Name of the linked carrier */
  carrierName?: string | null;
  /** ID of the assigned user (if any)
    Deprecated for now */
  userId?: string | null;
  id?: number;
  carrInvIdx?: number;
  invoiceNum?: string | null;
  carrInvLineIdx?: number | null;
  carrierId?: string | null;
  imageType?: string | null;
  originalFileName?: string | null;
  imageName?: string | null;
  source?: string | null;
  s3Path?: string | null;
  subKey?: string | null;
  fileDate?: string;
  dateLinked?: string;
  image?: string | null;
};
export type CarrInvImageScanVmRead = {
  /** ID of the scanned image */
  scanId?: number;
  /** ID of the linked Bill-To */
  custId: string;
  /** Name of the linked Bill-To */
  custName?: string | null;
  /** Name of the linked carrier */
  carrierName?: string | null;
  /** ID of the assigned user (if any)
    Deprecated for now */
  userId?: string | null;
  id?: number;
  carrInvIdx?: number;
  invoiceNum?: string | null;
  carrInvLineIdx?: number | null;
  carrierId?: string | null;
  imageType?: string | null;
  originalFileName?: string | null;
  imageName?: string | null;
  source?: string | null;
  s3Path?: string | null;
  subKey?: string | null;
  fileDate?: string;
  dateLinked?: string;
  image?: string | null;
  contentType?: string | null;
};
export type ImageExtractResults = {
  allSuccessful?: boolean;
  errors?: string[] | null;
};
export type CustImageExtractVm = {
  /** ID of the Bill-To the extract is for */
  custId: string;
  /** What Carrier Invoice date to use for the extracts */
  dateType: string;
  /** Start of the extract range */
  startDate: string;
  /** End of the extract range */
  endDate: string;
  /** How to group Carrier Invoices, if at all */
  groupType: string;
  /** Email addresses to send extract info to */
  emails?: string | null;
};
export type DataPairVm = {
  name?: string | null;
  display?: string | null;
  value?: string | null;
};
export type ChargeLineVm = {
  displayOrder?: number;
  type?: string | null;
  freight?: number;
  deficit?: number;
  fuel?: number;
  accessorial?: number;
  discount?: number;
  net?: number;
};
export type BasicInfoVm = {
  invoiceInfo?: DataPairVm[] | null;
  chargeLines?: ChargeLineVm[] | null;
  invoiceNum?: string | null;
  airBillNum?: string | null;
  custComment?: string | null;
  auditComment?: string | null;
  carrier?: CarrierMinimalVm;
  shipper?: PartyVm;
  consignee?: PartyVm;
};
export type BasicInfoVmGetResponse = {
  invoice?: BasicInfoVm;
  requireEditPreAudit?: boolean;
  isWebLocked?: boolean;
  showReleaseBtn?: boolean;
};
export type DetailedChargeVm = {
  invIdx?: number;
  lineIdx?: number;
  rcSeq?: number;
  displayOrder?: number;
  units?: string | null;
  weight?: number | null;
  itemDescription?: string | null;
  chargeDescription?: string | null;
  chargeAmount?: number | null;
  currency?: string | null;
  auditAmount?: number | null;
};
export type DetailedChargeVmRead = {
  invIdx?: number;
  lineIdx?: number;
  rcSeq?: number;
  displayOrder?: number;
  pieces?: number | null;
  units?: string | null;
  weight?: number | null;
  class?: string | null;
  itemDescription?: string | null;
  chargeDescription?: string | null;
  chargeAmount?: number | null;
  currency?: string | null;
  auditAmount?: number | null;
};
export type DetailedChargeListVm = {
  detailedCharges?: DetailedChargeVm[] | null;
};
export type DetailedChargeListVmRead = {
  detailedCharges?: DetailedChargeVmRead[] | null;
  totalWeight?: number;
  totalCharge?: number;
  currency?: string | null;
};
export type InvType = "Single" | "Statement";
export type UnifiedInvRefVm = {
  id?: number;
  invIdx?: number | null;
  lineIdx?: number | null;
  recType?: string | null;
  carrierId?: string | null;
  invoiceNum?: string | null;
  invRev?: number;
  lineSeq?: number;
  refSeq?: number;
  refIdQual?: string | null;
  refId?: string | null;
  refDescrip?: string | null;
  refDate?: string | null;
  refTimecode?: string | null;
  ruleUsed?: number;
  grpNum?: number | null;
  ascCodeDescription?: string | null;
  fpsCustId?: string | null;
  modified?: boolean;
};
export type ReferenceListVm = {
  references?: UnifiedInvRefVm[] | null;
  accountCodingData?: UnifiedInvRefVm[][] | null;
  deletedAccountCodingData?: UnifiedInvRefVm[][] | null;
  accountCodingHeaders?: UnifiedInvRefVm[] | null;
  showAccountCoding?: boolean;
  showReleaseInvoiceButton?: boolean;
  revReason?: string | null;
};
export type ImageListVm = {
  images?: CarrierInvoiceImagesVm[] | null;
};
export type ImageListVmRead = {
  images?: CarrierInvoiceImagesVmRead[] | null;
  needsEdiInvoice?: boolean;
};
export type InvoiceComment = {
  comment?: string | null;
};
export type PurgableInvoiceVm = {
  /** Name of the file imported */
  fileName?: string | null;
  /** Number of Carrier Invoices linked to this file */
  invoiceCount?: number;
  /** Date Carrier Invoices were created from the file */
  createDate?: string;
};
export type InvoicePurgeRequestVm = {
  /** Kind of Carrier Invoice to purge */
  recType?: string | null;
  /** ID of the Carrier whose Carrier Invoice to purge */
  carrierId?: string | null;
  /** Invoice # of the Carrier Invoice to purge */
  invoiceNumber?: string | null;
  /** Revision # of the Carrier Invoice to purge */
  invRev?: number;
};
export type InvoiceResearchListVm = {
  invIdx?: number | null;
  lineIdx?: number;
  billToName?: string | null;
  carrierId?: string | null;
  carrierName?: string | null;
  carrierNameLink?: string | null;
  invoiceNum?: string | null;
  invoiceNumLink?: string | null;
  invoiceReviewStatus?: string | null;
  /** Invoice type for the overall Carrier Invoice */
  invRecType?: string | null;
  /** Empty for single invoices */
  shipmentNum?: string | null;
  shipmentNumLink?: string | null;
  /** Empty for single invoices */
  shipmentReviewStatus?: string | null;
  /** Invoice type for the Carrier Invoice Line */
  lineRecType?: string | null;
  createDate?: string | null;
  shipDate?: string | null;
  /** replace source with EDITEST when RecType = EDITEST? */
  source?: string | null;
  /** Default to Not Specified */
  purpose?: string | null;
  /** COALESCE (CBT.Mode, inv.Mode, '') */
  mode?: string | null;
  ibob?: string | null;
  invType?: string | null;
  billingDate?: string | null;
  currAmtDue?: number | null;
  auditFlag?: boolean | null;
  shipperName?: string | null;
  shipperCity?: string | null;
  shipperState?: string | null;
  shipperPostal?: string | null;
  shipperAccount?: string | null;
  consigneeName?: string | null;
  consigneeCity?: string | null;
  consigneeState?: string | null;
  consigneePostal?: string | null;
  /** Weight in pounds */
  totWgtPounds?: number | null;
  rcvBatchId?: number | null;
  rcvBatchDate?: string | null;
  paidNetDue?: number | null;
  checkNumber?: number | null;
  checkAmt?: number | null;
  checkDate?: string | null;
  /** PayableBatch.PayMethod */
  payMethod?: string | null;
  custComment?: string | null;
  isaSenderId?: string | null;
};
export type InvoiceResearchListVmRead = {
  invIdx?: number | null;
  lineIdx?: number;
  billToName?: string | null;
  carrierId?: string | null;
  carrierName?: string | null;
  carrierNameLink?: string | null;
  invoiceNum?: string | null;
  invoiceNumLink?: string | null;
  invoiceReviewStatus?: string | null;
  /** Invoice type for the overall Carrier Invoice */
  invRecType?: string | null;
  /** Empty for single invoices */
  shipmentNum?: string | null;
  shipmentNumLink?: string | null;
  /** Empty for single invoices */
  shipmentReviewStatus?: string | null;
  /** Invoice type for the Carrier Invoice Line */
  lineRecType?: string | null;
  enteredDate?: string | null;
  createDate?: string | null;
  shipDateFormatted?: string | null;
  shipDate?: string | null;
  /** replace source with EDITEST when RecType = EDITEST? */
  source?: string | null;
  /** Default to Not Specified */
  purpose?: string | null;
  /** COALESCE (CBT.Mode, inv.Mode, '') */
  mode?: string | null;
  ibob?: string | null;
  invType?: string | null;
  invDate?: string | null;
  billingDate?: string | null;
  currAmtDue?: number | null;
  auditFlag?: boolean | null;
  shipperName?: string | null;
  shipperCity?: string | null;
  shipperState?: string | null;
  shipperPostal?: string | null;
  shipperAccount?: string | null;
  consigneeName?: string | null;
  consigneeCity?: string | null;
  consigneeState?: string | null;
  consigneePostal?: string | null;
  /** Weight in pounds */
  totWgtPounds?: number | null;
  rcvBatchId?: number | null;
  procDate?: string | null;
  rcvBatchDate?: string | null;
  paidNetDue?: number | null;
  checkNumber?: number | null;
  checkAmt?: number | null;
  /** From Checks table */
  checkDateFormatted?: string | null;
  checkDate?: string | null;
  /** PayableBatch.PayMethod */
  payMethod?: string | null;
  custComment?: string | null;
  isaSenderId?: string | null;
  /** Ordered columns for User Specified Reference Columns */
  userSpecificReferences?: string[] | null;
};
export type InvoiceResearchListVmPagingResponse = {
  data?: InvoiceResearchListVm[] | null;
  total?: number | null;
  isError?: boolean;
  error?: string | null;
};
export type InvoiceResearchListVmPagingResponseRead = {
  data?: InvoiceResearchListVmRead[] | null;
  total?: number | null;
  isError?: boolean;
  error?: string | null;
};
export type MakeRealVm = {
  customer?: string | null;
  invDate?: string;
  status?: string | null;
};
export type ExceptionManagerListVm = {
  /** Index ID for a Carrier Invoice */
  invIdx?: number;
  /** Index ID for a Carrier Invoice Line */
  lineIdx?: number;
  /** Line # for a Carrier Invoice Line */
  lineSeq?: number;
  /** What kind of Carrier Invoice (SINGLE or STATEMENT) this is */
  invType?: string | null;
  /** ID of the Carrier this Carrier Invoice is for */
  carrierId?: string | null;
  /** Name of the Carrier this Carrier Invoice is for */
  carrierName?: string | null;
  /** ID of the Bill-To this Carrier Invoice is for */
  customerId?: string | null;
  /** Name of the Bill-To this Carrier Invoice is for */
  customerName?: string | null;
  /** Invoice Number on the Carrier Invoice */
  invoiceNum?: string | null;
  /** Air Bill # (if any) associated with the Carrier Invoice */
  airbillNum?: string | null;
  /** Carrier Invoice's review status */
  reviewStatus?: string | null;
  /** Airbill's review status (if present) */
  airbillStatus?: string | null;
  /** Ship Date from the Carrier Invoice */
  shipDate?: string | null;
  /** Invoice Net Due — the original amount billed by the Carrier */
  netDue?: number | null;
  /** Audit Net Due — the amount determined by Freight Audit */
  auditNet?: number | null;
  /** Summary of audit results (including "not audited") */
  auditResult?: string | null;
  /** ID of the shipper on the Carrier Invoice */
  shipperPartyId?: number | null;
  /** Name of the shipper on the Carrier Invoice */
  shipperName?: string | null;
  /** Postal code of the shipper on the Carrier Invoice */
  shipperPostal?: string | null;
  /** ID of the consignee on the Carrier Invoice */
  consigneePartyId?: number | null;
  /** Name of the consignee on the Carrier Invoice */
  consigneeName?: string | null;
  /** Postal code of the consignee on the Carrier Invoice */
  consigneePostal?: string | null;
  /** Billing Date from the Carrier Invoice */
  billingDate?: string | null;
  /** Date the Carrier Invoice was entered */
  createDate?: string | null;
  /** Total # of units on the shipment */
  totLadQty?: number | null;
  /** Total weight of the shipment */
  totWgt?: number | null;
  /** User who created the Carrier Invoice */
  createUser?: string | null;
  /** Revision # for the Carrier Invoice */
  invRev?: number;
  /** CarrInv or CarrLine Rem long comment where RemarkSeq = 999 */
  comment?: string | null;
  /** Customer comment */
  custComment?: string | null;
};
export type ExceptionManagerActionVm = {
  /** List of Carrier Invoices with exceptions to act on */
  invoicesToActOn: ExceptionManagerListVm[];
  /** Comments to add alongside the changes */
  comments: string;
};
export type ExceptionManagerListAcceptAsAdjustedVm = {
  /** The charges to update on the Carrier Invoice */
  adjustedCharges?: LineRcTariffQwMarksVm[] | null;
  /** The adjustmet to apply to the charge */
  invoiceLevelAdjustment?: number | null;
  /** Index ID for a Carrier Invoice */
  invIdx?: number;
  /** Index ID for a Carrier Invoice Line */
  lineIdx?: number;
  /** Line # for a Carrier Invoice Line */
  lineSeq?: number;
  /** What kind of Carrier Invoice (SINGLE or STATEMENT) this is */
  invType?: string | null;
  /** ID of the Carrier this Carrier Invoice is for */
  carrierId?: string | null;
  /** Name of the Carrier this Carrier Invoice is for */
  carrierName?: string | null;
  /** ID of the Bill-To this Carrier Invoice is for */
  customerId?: string | null;
  /** Name of the Bill-To this Carrier Invoice is for */
  customerName?: string | null;
  /** Invoice Number on the Carrier Invoice */
  invoiceNum?: string | null;
  /** Air Bill # (if any) associated with the Carrier Invoice */
  airbillNum?: string | null;
  /** Carrier Invoice's review status */
  reviewStatus?: string | null;
  /** Airbill's review status (if present) */
  airbillStatus?: string | null;
  /** Ship Date from the Carrier Invoice */
  shipDate?: string | null;
  /** Invoice Net Due — the original amount billed by the Carrier */
  netDue?: number | null;
  /** Audit Net Due — the amount determined by Freight Audit */
  auditNet?: number | null;
  /** Summary of audit results (including "not audited") */
  auditResult?: string | null;
  /** ID of the shipper on the Carrier Invoice */
  shipperPartyId?: number | null;
  /** Name of the shipper on the Carrier Invoice */
  shipperName?: string | null;
  /** Postal code of the shipper on the Carrier Invoice */
  shipperPostal?: string | null;
  /** ID of the consignee on the Carrier Invoice */
  consigneePartyId?: number | null;
  /** Name of the consignee on the Carrier Invoice */
  consigneeName?: string | null;
  /** Postal code of the consignee on the Carrier Invoice */
  consigneePostal?: string | null;
  /** Billing Date from the Carrier Invoice */
  billingDate?: string | null;
  /** Date the Carrier Invoice was entered */
  createDate?: string | null;
  /** Total # of units on the shipment */
  totLadQty?: number | null;
  /** Total weight of the shipment */
  totWgt?: number | null;
  /** User who created the Carrier Invoice */
  createUser?: string | null;
  /** Revision # for the Carrier Invoice */
  invRev?: number;
  /** CarrInv or CarrLine Rem long comment where RemarkSeq = 999 */
  comment?: string | null;
  /** Customer comment */
  custComment?: string | null;
};
export type ExceptionManagerAcceptAsAdjustedVm = {
  /** List of Carrier Invoices with exceptions to act on */
  invoicesToActOn: ExceptionManagerListAcceptAsAdjustedVm[];
  /** Comments to add alongside the changes */
  comments: string;
};
export type MassUpdateVm = {
  /** ID of the Customer we're making an update for */
  customerId: string;
  /** Customer we're making an update for */
  customer?: string | null;
  /** ID of the Carrier we're making an update for */
  carrierId?: string | null;
  /** Carrier we're making an update for */
  carrier?: string | null;
  /** Invoice # for the Carrier Invoice we're updating */
  invoice?: string | null;
  /** Revision # of the Carrier Invoice we're updating */
  invRev?: number;
  /** Which line of a STATEMENT Carrier Invoice we're updating */
  lineSeq?: number | null;
  /** Shipment # for a STATEMENT Carrier Invoice line we're updating */
  shipment?: string | null;
  /** Purpose for the Carrier Invoice we're updating */
  purpose?: string | null;
  /** Which reference field we're updating */
  field: string;
  /** The "old" value of the ref field */
  oldValue?: string | null;
  /** The value we're setting in the ref field */
  newValue?: string | null;
  /** Result of the change (success / fail) */
  result?: string | null;
  /** Batch date of the associated Carrier Invoice
    Used mainly for filtering */
  batchDate?: string | null;
};
export type UpdateSearchParams = {
  /** ID of the Customer we're searching for ref codes */
  customerId: string;
  /** ID of the Carrier we're searching for ref codes */
  carrierId?: string | null;
  /** Do we want pre-Freight Audit Carrier Invoices? */
  inclPreaudit?: boolean | null;
  /** Start date of the search range for Carrier Invoices after Freight Audit */
  dateFrom?: string | null;
  /** End date of the search range for Carrier Invoices after Freight Audit */
  dateTo?: string | null;
  /** Which reference field we're looking for */
  field: string;
  /** The value of the ref field we're looking for */
  oldValue?: string | null;
  /** The value we want to set in the ref field */
  newValue?: string | null;
};
export type HarcrosMatchVm = {
  /** GUID for an individual ticket import */
  id?: string;
  /** External ticket ID */
  refId?: string | null;
  /** Order Location code */
  orderLoc?: string | null;
  /** Ship-By code */
  shipBy?: string | null;
  /** When the shipment for this ticket was sent */
  dateSent?: string;
  /** When the ticket's charge is for */
  ticketDate?: string;
  /** Order Type code */
  ordType?: string | null;
  /** Is this a PO ticket, or an SO? */
  poso?: string | null;
  /** GL Code for the ticket */
  accountCode?: string | null;
  /** Has this ticket been matched to a Carrier Invoice via Match Pay? */
  matched?: boolean | null;
  /** When this ticket was imported */
  importDate?: string;
  /** Charge amount for the ticket (optional) */
  amount?: number | null;
};
export type CarrierChargeCodeSourceGenericDropDownStruct = {
  value?: CarrierChargeCodeSource;
  display?: string | null;
};
export type CustFeesReportNamesVm = {
  /** Internal report name */
  reportName?: string | null;
  /** User-friendly report name */
  reportNameDescription?: string | null;
};
export type AchPaymentVm = {
  selected?: boolean;
  billToId?: string | null;
  billToName?: string | null;
  carrierId?: string | null;
  carrierName?: string | null;
  batchId?: number;
  payDate?: string;
  checkNumber?: number;
  totalDue?: number;
  secCode?: string | null;
  paymentMethod?: string | null;
};
export type PayablesExceptionsVm = {
  /** ID of the pay method exception */
  id: number;
  /** ID of the customer the pay method exception is for */
  customerID: string;
  /** Name of the customer the pay method exception is for - only sent to client */
  customerName?: string | null;
  /** ID of the carrier the pay method exception is for */
  carrierID: string;
  /** Which of the carrier's pay methods to use */
  payMethodID: number;
};
export type PayDaysStartVm = {
  /** Category ID for Start point */
  indicator: number;
  /** Description for Start point */
  description: string;
};
export type PermittedValuesVm = {
  /** Internal ID for this permitted value entry */
  id: number;
  /** ID of the carrier this permitted value entry applies to */
  carrierId: string;
  /** ID of the customer this permitted value entry applies to */
  btid: string;
  /** ASC Ref Code (or internal definition) this permitted value entry applies to */
  fieldName: string;
  /** A specific permitted value */
  permittedValue: string;
};
export type PostalCodeVm = {
  /** ID of the postal code entry */
  id: number;
  /** Postal Code */
  zip51: string;
  /** City associated with the postal code */
  city: string;
  /** State/Province associated with the postal code */
  state: string;
  /** Country associated with the postal code */
  country: string;
};
export type PayMethodEntry = {
  /** ID of the payment method */
  methodId?: number;
  /** Name of the payment method */
  methodName?: string | null;
  isDefaultPayMethod?: boolean;
};
export type PrintCheckVm = {
  /** ID of the customer the checks are for */
  custId?: string | null;
  /** Name of the customer the checks are for */
  custName?: string | null;
  /** ID of the carrier the checks are for */
  carrierID?: string | null;
  /** Name of the carrier the checks are for */
  carrierName?: string | null;
  /** ID of the payable batch responsible for the checks */
  batchID?: number;
  /** Number of invoices that will be paid by the checks */
  invoiceCount?: number | null;
  /** When payment is scheduled */
  payDate?: string | null;
  /** How much the checks are worth */
  totalDue?: number | null;
  /** List of available payment methods (ID/Name) */
  payMethods?: PayMethodEntry[] | null;
  /** Linked GL Code */
  fbogl?: string | null;
  /** Linked Check #, if any */
  checkNumber?: number | null;
};
export type PrintCheckVmRead = {
  /** ID of the customer the checks are for */
  custId?: string | null;
  /** Name of the customer the checks are for */
  custName?: string | null;
  /** ID of the carrier the checks are for */
  carrierID?: string | null;
  /** Name of the carrier the checks are for */
  carrierName?: string | null;
  /** ID of the payable batch responsible for the checks */
  batchID?: number;
  /** Number of invoices that will be paid by the checks */
  invoiceCount?: number | null;
  /** When payment is scheduled */
  payDate?: string | null;
  /** How much the checks are worth */
  totalDue?: number | null;
  /** List of available payment methods (ID/Name) */
  payMethods?: PayMethodEntry[] | null;
  /** ID of the default pay method */
  defaultPayMethodId?: number;
  /** Linked GL Code */
  fbogl?: string | null;
  /** Linked Check #, if any */
  checkNumber?: number | null;
};
export type PrintCheckRequestEntryVm = {
  /** ID of the payable batch the print request is for */
  batchId?: number;
  /** Name of the pay method to use for check printing */
  payMethodName?: string | null;
};
export type PrintCheckRequestVm = {
  /** List of check print requests */
  batchInfo: PrintCheckRequestEntryVm[];
  /** Date to print on the checks */
  checkDate: string;
  /** Account # to use for the checks */
  acctNum: string;
};
export type ReprintCheckRequestVm = {
  /** Is this request to reprint checks? */
  reprintChecks: boolean;
  /** Is this request to reprint the summary? */
  reprintSummary: boolean;
  /** Is this request to reprint the long stubs? */
  reprintStubs: boolean;
  /** List of check print requests */
  batchInfo: PrintCheckRequestEntryVm[];
  /** Date to print on the checks */
  checkDate: string;
  /** Account # to use for the checks */
  acctNum: string;
};
export type CashReceiptsVm = {
  /** Which merge-batch this receipt was part of, if any */
  batchID?: number;
  /** Unique receipt ID */
  cashReceiptsID?: number;
  /** Deposit date for this receipt */
  depositDate?: string;
  /** When Funds are Available for this receipt */
  fundsAvailDate?: string;
  /** How much money was received on this receipt */
  fundsRecd?: number;
  /** Acct # of the associated bank account for this receipt */
  bankAccountNum?: string | null;
  /** Name of the associated bank account for this receipt */
  bankAccountName?: string | null;
  /** How funds were sent for this receipt */
  deposMeth?: string | null;
  /** ID of the customer for this receipt */
  customerId?: string | null;
  /** Name of the customer for this receipt */
  customerName?: string | null;
  /** How much money is still outstanding for this receipt */
  amtNotYetApplied?: number;
  /** How much overpayment, if any, applies to this receipt */
  overfundAmt?: number;
  /** Any comments on this receipt - mostly merge trails */
  comments?: string | null;
};
export type ReceiveFundsInvoiceVm = {
  /** Internal Carrier Invoice ID */
  invIdx?: number;
  /** Internal Carrier Invoice Line ID */
  lineIdx?: number;
  /** Overall Carrier Invoice active status */
  invRecType?: string | null;
  /** ID of the Carrier linked to this Carrier Invoice */
  carrierId?: string | null;
  /** Carrier Invoice # */
  invoiceNum?: string | null;
  /** Which revision of the Carrier Invoice this is */
  invRev?: number;
  /** Which line of Carrier Invoice data this is */
  lineSeq?: number;
  /** ID of the Bill-To linked to this Carrier Invoice */
  btId?: string | null;
  /** Name of the Bill-To linked to this Carrier Invoice */
  customerName?: string | null;
  /** Name of the Carrier linked to this Carrier Invoice */
  carrierName?: string | null;
  /** SINGLE or STATEMENT */
  invType?: string | null;
  /** Billing date on the Carrier Invoice */
  billingDate?: string | null;
  /** Internal ID of the approved batch */
  apprBatchId?: number | null;
  /** Air Bill # */
  airbillNum?: string | null;
  /** Approved Net Due for the Carrier Invoice */
  currAmtDue?: number;
  /** Internal ID of the received batch */
  rcvBatchId?: number | null;
  /** Carrier Invoice's review status */
  reviewStatus?: string | null;
  /** Date the Carrier Invoice was placed in a Receivable Batch */
  rcvBatchDate?: string | null;
};
export type ReceiveFundsRequestVm = {
  /** Internal Carrier Invoice ID */
  invIdx?: number;
  /** Internal Carrier Invoice Line ID */
  lineIdx?: number;
};
export type ReceiveFundsVm = {
  /** List of Carrier Invoice IDs to receive funds for */
  invoices: ReceiveFundsRequestVm[];
  /** ID of the customer the fund request is for */
  customerId: string;
  /** ID of the bank account the funds are sent to */
  bankAcctId: string;
  /** Deposit date for the funds */
  depositDate: string;
  /** Date for the funds to be available */
  availDate: string;
  /** Amount of funding being applied */
  amount: number;
  /** How funds are being deposited */
  depositMethod: string;
  /** Additional comment for applied funds */
  memo?: string | null;
};
export type UseUnappliedCashVm = {
  /** List of Carrier Invoice IDs to receive funds for */
  invoices: ReceiveFundsRequestVm[];
  /** ID of the customer the fund request is for */
  customerId: string;
  /** ID of the bank account the funds are sent to */
  cashReceiptIds: number[];
};
export type DepositFundsVm = {
  /** ID of the customer the fund request is for */
  customerId: string;
  /** ID of the bank account the funds are sent to */
  bankAcctId: string;
  /** Deposit date for the funds */
  depositDate: string;
  /** Date for the funds to be available */
  availDate: string;
  /** Amount of funding being applied */
  amount: number;
  /** How funds are being deposited */
  depositMethod: string;
  /** Additional comment for applied funds */
  memo?: string | null;
};
export type ReceiveCreditVm = {
  /** ID of the carrier the credit is for - if not for a specific carrier,
    then it is an overfund listed under Sunset */
  carrierId?: string | null;
  /** ID of the customer the fund request is for */
  customerId: string;
  /** ID of the bank account the funds are sent to */
  bankAcctId: string;
  /** Amount of funding being applied */
  amount: number;
  /** Additional comment for applied funds */
  memo?: string | null;
};
export type EmbedReport = {
  reportId?: string;
  reportName?: string | null;
  embedUrl?: string | null;
};
export type EmbedToken = {};
export type EmbedTokenRead = {
  token?: string | null;
  tokenId?: string;
  expiration?: string;
};
export type EmbedParams = {
  type?: string | null;
  embedReport?: EmbedReport[] | null;
  embedToken?: EmbedToken;
};
export type EmbedParamsRead = {
  type?: string | null;
  embedReport?: EmbedReport[] | null;
  embedToken?: EmbedTokenRead;
};
export type ReportBookmarkVm = {
  id?: number;
  userId?: string | null;
  reportId?: string | null;
  displayName?: string | null;
  bookmarkBase64?: string | null;
  isPublic?: boolean;
};
export type CreateReportBookmarkVm = {
  bookmark?: ReportBookmarkVm;
  isPublic?: boolean;
  billTos?: BillToMinimalVm[] | null;
};
export type CreateReportBookmarkVmRead = {
  bookmark?: ReportBookmarkVm;
  isPublic?: boolean;
  billTos?: BillToMinimalVmRead[] | null;
};
export type StatesVm = {
  /** ID of the state code entry */
  id: number;
  /** Country the state code is used in */
  country: string;
  /** State code */
  abbrev: string;
  /** Full name of the state/province */
  stateName: string;
};
export type XRaySettings = {
  samplingRuleManifest?: string | null;
  awsXRayPlugins?: string | null;
};
export type WebDefaultsSettings = {
  receivableBatchSize?: string | null;
  glCodingBatchSize?: string | null;
};
export type WebAnnounceSettings = {
  shortText?: string | null;
  moreUrl?: string | null;
  loginMoreUrl?: string | null;
  loginExpireDate?: string | null;
  loginAnnounceFile?: string | null;
  expireDate?: string | null;
};
export type TransTermsSettings = {
  tofc?: string | null;
  tl?: string | null;
  strg?: string | null;
  spack?: string | null;
  rail?: string | null;
  prcl?: string | null;
  olcl?: string | null;
  ocl?: string | null;
  ltl?: string | null;
  imodal?: string | null;
  cour?: string | null;
  cofc?: string | null;
  air?: string | null;
};
export type TokenServiceOptionsSettings = {
  secretKey?: string | null;
};
export type SystemSettings = {
  yesShort?: string | null;
  weightQualDefault?: string | null;
  weightQualConversionQuantityName?: string | null;
  webLocked?: string | null;
  useCarrierConfiguredCheckRemitFileLocations?: string | null;
  unknownBillToId?: string | null;
  tempFolder?: string | null;
  sysErrorMailTo?: string | null;
  sysErrorMailFrom?: string | null;
  sqlErrorEMail?: string | null;
  spwBaseAddress?: string | null;
  sendEmailFlag?: string | null;
  sendDebugEmailFlag?: string | null;
  ratingApiUrl?: string | null;
  ratingApiKey?: string | null;
  payLogikPassword?: string | null;
  payLogikEmail?: string | null;
  missingDateDefault?: string | null;
  mcLeodWebServiceUrl?: string | null;
  mcLeodWebServiceOrderType?: string | null;
  mcLeodWebServiceDeviceId?: string | null;
  mcLeodWebServiceContentType?: string | null;
  mcLeodWebServiceAllowedImageTypes?: string | null;
  mailServer?: string | null;
  mailPort?: string | null;
  mailEnableSsl?: string | null;
  legacyPlExternWsUrl?: string | null;
  legacyFpsAdvWsUrl?: string | null;
  lastBillingInvNum?: string | null;
  harcrosNoRefId?: string | null;
  enableGlFnLogging?: string | null;
  debugEmail?: string | null;
  databaseType?: string | null;
  connectionString3gtms?: string | null;
  carrierIdUps?: string | null;
  carrierIdSunset?: string | null;
  billingInvoiceUserId?: string | null;
  billingInvCarrier?: string | null;
  baseCurrency?: string | null;
  baseCountry?: string | null;
  awsExportsBucket?: string | null;
  auditResultOutOfTolerance?: string | null;
  auditResultNotRateAudited?: string | null;
  auditResultNothingReturned?: string | null;
  auditResultMaxClassExceeded?: string | null;
  auditResultHandAudit?: string | null;
  auditResultAutoBilling?: string | null;
  assocWebSiteNewUi?: string | null;
  assocWebSite?: string | null;
};
export type SunsetTransRemitSettings = {
  sunsetTransRemitItEmail?: string | null;
  sunsetTransRemitEmailFrom?: string | null;
  sunsetTransEmailTo?: string | null;
};
export type SecuritySettings = {
  carrierAdmin?: string | null;
};
export type ReportingSettings = {
  plReportUserPswd?: string | null;
};
export type RatingApiSettings = {
  baseUrl?: string | null;
  apiKey?: string | null;
};
export type PowerBiSettings = {
  workspaceId?: string | null;
  reportId?: string | null;
};
export type PdfOptionsSettings = {
  imageUploadDirectoryBase?: string | null;
};
export type PcMilesSettings = {
  milesEmailTo?: string | null;
  milesEmailFrom?: string | null;
};
export type PcMilerSettings = {
  username?: string | null;
  serviceBaseAddress?: string | null;
  requestType?: string | null;
  passCode?: string | null;
  hmacType?: string | null;
  account?: string | null;
};
export type PayLogikOptionsSettings = {
  invoiceNumSuffix?: string | null;
  eventLogCreateCarrInv?: string | null;
};
export type PayLogikLoggingSettings = {
  toEmail?: string | null;
  payLogikPassword?: string | null;
  payLogikEmail?: string | null;
  mailServer?: string | null;
  mailPort?: string | null;
  mailEnableSsl?: string | null;
  logFilePath?: string | null;
  emailSubject?: string | null;
};
export type PayablesSettings = {
  lastCheckNum?: string | null;
};
export type McLeodSettings = {
  allowedImages?: string | null;
};
export type LoggingSettingsSettings = {
  cloudWatchLogGroup?: string | null;
};
export type LoggingConsoleSettings = {
  formatterName?: string | null;
};
export type LoggingSettings = {
  console?: LoggingConsoleSettings;
};
export type ImagingSettings = {
  imageSubFolder?: string | null;
  imageSaveToWindowsFileShare?: string | null;
  imageSaveToAwsS3?: string | null;
  imageRootSave?: string | null;
  imageRootMcLeodSave?: string | null;
  imageRootMcLeod?: string | null;
  imageRootIn?: string | null;
  imageRootDisc?: string | null;
  imageExt?: string | null;
  imageDisconnectedImagesFolder?: string | null;
  awsMcLeodImageRoot?: string | null;
  awsInvoiceImageBucket?: string | null;
  awsDisconnectedImagesRootKey?: string | null;
  actuallyDeleteImages?: string | null;
};
export type Iagi4Settings = {
  g14ItEmail?: string | null;
  g14EmailTo?: string | null;
  g14EmailFrom?: string | null;
};
export type IaSettings = {
  itEmailTo?: string | null;
  iaEmailToInvalidChargeCode?: string | null;
  iaEmailTo?: string | null;
  iaEmailFrom?: string | null;
  iaCreditsEmailTo?: string | null;
};
export type I360ASettings = {
  serverIp?: string | null;
  masterUserId?: string | null;
  masterPassword?: string | null;
  landingPageUrl?: string | null;
  invoicePageUrl?: string | null;
  defaultRemoteIp?: string | null;
  authServerUrl?: string | null;
};
export type GraphMailSettings = {
  tenantId?: string | null;
  senderUser?: string | null;
  clientSecret?: string | null;
  clientId?: string | null;
};
export type FedExRemitSettings = {
  fedExRemitItEmail?: string | null;
  fedExRemitEmailTo?: string | null;
  fedExRemitEmailFrom?: string | null;
};
export type EdiSettings = {
  remit820SenderQual?: string | null;
  remit820SenderId?: string | null;
};
export type CustomerInvoicesSettings = {
  printCustomerInvoices?: string | null;
  invoicePurpose?: string | null;
  invoiceMode?: string | null;
  invoiceCarrierZip?: string | null;
  invoiceCarrierName?: string | null;
  invoiceCarrierId?: string | null;
  emailCustomerInvoices?: string | null;
};
export type ConnectionStringsSettings = {
  payLogikConnectionString?: string | null;
  loggingConnectionString?: string | null;
  hangfireConnection?: string | null;
  threeGTmsConnectionString?: string | null;
};
export type ComdataSettings = {
  comdataUsername?: string | null;
  comdataUrl?: string | null;
  comdataPassword?: string | null;
  callComData?: string | null;
  accountCode?: string | null;
};
export type ScopeBaseSettings = {
  zero?: string | null;
};
export type AzureAdSettings = {
  tenantId?: string | null;
  scopeBase?: ScopeBaseSettings;
  pbiUsername?: string | null;
  pbiPassword?: string | null;
  clientSecret?: string | null;
  clientId?: string | null;
  authorityUrl?: string | null;
  authenticationMode?: string | null;
};
export type AwsSettings = {
  region?: string | null;
  profile?: string | null;
};
export type AutoBillSettings = {
  failureEMailTo?: string | null;
};
export type TokenValidationParametersSettings = {
  validateIssuer?: string | null;
};
export type CognitoSettings = {
  tokenValidationParameters?: TokenValidationParametersSettings;
  saveToken?: string | null;
  responseType?: string | null;
  requireHttpsMetadata?: string | null;
  metadataAddress?: string | null;
  includeErrorDetails?: string | null;
  clientId?: string | null;
  authority?: string | null;
  audience?: string | null;
};
export type AzureB2CSettings = object;
export type AuthenticationSettings = {
  cognito?: CognitoSettings;
  azureB2C?: AzureB2CSettings;
};
export type AuditSettings = {
  auditFailEmail?: string | null;
  auditEmailFrom?: string | null;
};
export type AcctgSettings = {
  transitRoutingNumber?: string | null;
  transitNumber?: string | null;
  smallCompanyName?: string | null;
  sfRemailTextBelow?: string | null;
  sfRemailTextApprovalLinkText?: string | null;
  sfRemailTextAbove?: string | null;
  sfRemailSubject?: string | null;
  sfRemailFrom?: string | null;
  remitSendSummary?: string | null;
  remitFileRoot?: string | null;
  remitFileFrom?: string | null;
  reference?: string | null;
  originatingBank?: string | null;
  mcLeodIntegrationFolder?: string | null;
  fundsRecEmail?: string | null;
  fundsDisputeEmail?: string | null;
  fundsApprErrorEmail?: string | null;
  fundsApprEmail?: string | null;
  feeInvoiceVersion?: string | null;
  feeInvoiceRoot?: string | null;
  feeInvoiceHarcrosEmailTo?: string | null;
  feeInvoiceEmailFrom?: string | null;
  discretionaryData?: string | null;
  custPayEmailTextBelow?: string | null;
  custPayEmailTextAbove?: string | null;
  custPayEmailSubject?: string | null;
  custPayEmailLinkText?: string | null;
  companyIdNumber?: string | null;
  commentEmail?: string | null;
  classAllocationRoot?: string | null;
  checkPrintEMailTo?: string | null;
  checkPrintEMailFrom?: string | null;
  changesAllowed?: string | null;
  bankCompanyName?: string | null;
  achFileRoot?: string | null;
  accountNumber?: string | null;
};
export type TraceSettings = {
  enableAspNetCore?: boolean;
  enableHttpClient?: boolean;
  enableEntityFrameworkCore?: boolean;
  enableSqlClient?: boolean;
  enablePayLogikBLL?: boolean;
  enablePayLogikLegacyDomain?: boolean;
  enableController?: boolean;
  enableApi?: boolean;
  enableSecurity?: boolean;
};
export type AppSettings = {
  allowedHosts?: string | null;
  windir?: string | null;
  webview2_Default_Background_Color?: string | null;
  vs_Perf_Session_GcHeapCount?: string | null;
  vsskuedition?: string | null;
  vsPerMonitorDpiAwarenessEnabled_4900?: string | null;
  vslang?: string | null;
  vsappidname?: string | null;
  vsappiddir?: string | null;
  visualStudioVersion?: string | null;
  visualStudioEdition?: string | null;
  visualStudioDir?: string | null;
  userprofile?: string | null;
  username?: string | null;
  userdomain_Roamingprofile?: string | null;
  userdomain?: string | null;
  userdnsdomain?: string | null;
  tool_Host_Service_Url?: string | null;
  tool_Host_Service_Token?: string | null;
  tool_Host_Service_Certificate?: string | null;
  tmp?: string | null;
  threadedWaitDialogDpiContext?: string | null;
  temp?: string | null;
  systemRoot?: string | null;
  systemDrive?: string | null;
  signInWithHomeTenantOnly?: string | null;
  sessionname?: string | null;
  serviceHubLogSessionKey?: string | null;
  serviceHubHostServiceBrokerPipeName?: string | null;
  run_Hangfire_Server?: string | null;
  public?: string | null;
  psModulePath?: string | null;
  programW6432?: string | null;
  programFilesX86?: string | null;
  programFiles?: string | null;
  programData?: string | null;
  processor_Revision?: string | null;
  processor_Level?: string | null;
  processor_Identifier?: string | null;
  processor_Architecture?: string | null;
  powershell_Distribution_Channel?: string | null;
  pkgDefApplicationConfigFile?: string | null;
  pathext?: string | null;
  path?: string | null;
  otel_Traces_Sampler?: string | null;
  otel_Service_Name?: string | null;
  otel_Resource_Attributes?: string | null;
  otel_Metric_Export_Interval?: string | null;
  otel_Metrics_Exemplar_Filter?: string | null;
  otel_Instrumentation_Genai_Capture_Message_Content?: string | null;
  otel_Exporter_Otlp_Protocol?: string | null;
  otel_Exporter_Otlp_Headers?: string | null;
  otel_Exporter_Otlp_Endpoint?: string | null;
  otel_Dotnet_Experimental_Otlp_Retry?: string | null;
  otel_Dotnet_Experimental_Httpclient_Disable_Url_Query_Redaction?:
    | string
    | null;
  otel_Dotnet_Experimental_Aspnetcore_Disable_Url_Query_Redaction?:
    | string
    | null;
  otel_Bsp_Schedule_Delay?: string | null;
  otel_Blrp_Schedule_Delay?: string | null;
  os?: string | null;
  oneDriveCommercial?: string | null;
  oneDrive?: string | null;
  number_Of_Processors?: string | null;
  ninjarmmcli?: string | null;
  msBuildLoadMicrosoftTargetsReadOnly?: string | null;
  logonserver?: string | null;
  localappdata?: string | null;
  iis_User_Home?: string | null;
  iis_Sites_Home?: string | null;
  iis_Drive?: string | null;
  iis_Bin?: string | null;
  homepath?: string | null;
  homedrive?: string | null;
  fps_Browser_User_Profile_String?: string | null;
  fps_Browser_App_Profile_String?: string | null;
  enable_Xaml_Diagnostics_Source_Info?: string | null;
  efc_17880_1592913036?: string | null;
  driverData?: string | null;
  dotnet_System_Console_Allow_Ansi_Color_Redirection?: string | null;
  dotnet_Startup_Hooks?: string | null;
  dotnet_Modifiable_Assemblies?: string | null;
  dotnet_Launch_Profile?: string | null;
  dotnet_Dashboard_Url?: string | null;
  dotnet_Dashboard_Frontend_Browsertoken?: string | null;
  container_Image_Name?: string | null;
  comSpec?: string | null;
  computername?: string | null;
  complus_ForceEnc?: string | null;
  commonProgramW6432?: string | null;
  commonProgramFilesX86?: string | null;
  commonProgramFiles?: string | null;
  aws_Secret_Access_Key?: string | null;
  aws_Default_Region?: string | null;
  aws_Ca_Bundle?: string | null;
  aws_Access_Key_Id?: string | null;
  aws_Access_Key?: string | null;
  aspnetcore_Urls?: string | null;
  aspnetcore_Https_Port?: string | null;
  aspnetcore_Hostingstartupassemblies?: string | null;
  aspnetcore_Environment?: string | null;
  aspnetcore_Auto_Reload_Ws_Key?: string | null;
  aspnetcore_Auto_Reload_Ws_Endpoint?: string | null;
  aspnetcore_Auto_Reload_Vdir?: string | null;
  aspire_Resource_Service_Endpoint_Url?: string | null;
  aspire_Dashboard_Otlp_Endpoint_Url?: string | null;
  aspire_Dashboard_Mcp_Endpoint_Url?: string | null;
  appdata?: string | null;
  apidiscovery_ProjectName?: string | null;
  apidiscovery_Filepath?: string | null;
  allusersprofile?: string | null;
  aspnetcore_Browser_Tools?: string | null;
  xRay?: XRaySettings;
  webDefaults?: WebDefaultsSettings;
  webAnnounce?: WebAnnounceSettings;
  transTerms?: TransTermsSettings;
  tokenServiceOptions?: TokenServiceOptionsSettings;
  system?: SystemSettings;
  sunsetTransRemit?: SunsetTransRemitSettings;
  security?: SecuritySettings;
  reporting?: ReportingSettings;
  ratingApi?: RatingApiSettings;
  powerBi?: PowerBiSettings;
  pdfOptions?: PdfOptionsSettings;
  pcMiles?: PcMilesSettings;
  pcMiler?: PcMilerSettings;
  payLogikOptions?: PayLogikOptionsSettings;
  payLogikLogging?: PayLogikLoggingSettings;
  payables?: PayablesSettings;
  mcLeod?: McLeodSettings;
  loggingSettings?: LoggingSettingsSettings;
  logging?: LoggingSettings;
  imaging?: ImagingSettings;
  iagi4?: Iagi4Settings;
  ia?: IaSettings;
  i360A?: I360ASettings;
  graphMail?: GraphMailSettings;
  fedExRemit?: FedExRemitSettings;
  edi?: EdiSettings;
  customerInvoices?: CustomerInvoicesSettings;
  connectionStrings?: ConnectionStringsSettings;
  comdata?: ComdataSettings;
  azureAd?: AzureAdSettings;
  aws?: AwsSettings;
  autoBill?: AutoBillSettings;
  authentication?: AuthenticationSettings;
  audit?: AuditSettings;
  acctg?: AcctgSettings;
  tracing?: TraceSettings;
};
export type UserTcactivityVm = {
  id?: string;
  tcid?: string;
  activity?: string | null;
  startTime?: string | null;
  stopTime?: string | null;
  notes?: string | null;
  userTimeCard?: UserTimeCardVm;
};
export type UserTimeCardVm = {
  id?: string;
  userId?: string | null;
  cardDate?: string;
  totalHrs?: number;
  locked?: boolean;
  activities?: UserTcactivityVm[] | null;
};
export type UserBillToVm = {
  /** ID of the customer/user link */
  id?: number;
  /** Which user is linked to the customer */
  userId: string;
  /** Which customer this link is for */
  btid: string;
};
export type FunctionalAuthLineVm = {
  /** The feature that we're defining access to */
  functionId: string;
  /** User-friendly description for the function */
  description?: string | null;
  /** Does this role have View access to the feature? */
  viewOk: boolean;
  /** Does this role have Edit access to the feature? */
  editOk: boolean;
};
export type FunctionalAuthVm = {
  /** Name of the user role, functions as a key as well */
  userRole: string;
  /** List of authorizations for the user role */
  auths: FunctionalAuthLineVm[];
};
export type UserRoleDefinitionVm = {
  /** Name of the user role, functions as a key as well */
  roleName: string;
  /** Description for the user role */
  description: string;
};
export type UserAdminListEntryVm = {
  /** ID of the linked record (customer, carrier, etc.) */
  linkId?: string | null;
  /** Name of the linked record (customer, carrier, etc.) */
  linkName?: string | null;
  /** Is this record linked for this user? */
  isLinked?: boolean;
};
export type UserAdminVm = {
  /** User ID */
  userId: string;
  /** User's last name */
  lastName?: string | null;
  /** User's first name */
  firstName?: string | null;
  /** Name for the user shown in the system */
  displayName?: string | null;
  /** User's associated company */
  company?: string | null;
  /** Who created this user in the system? */
  createdBy?: string | null;
  /** When was this user record created? */
  createdOn?: string | null;
  /** Who last edited this user record? */
  editBy?: string | null;
  /** When was this user record last edited? */
  editOn?: string | null;
  /** Who suspended this user record? */
  suspendBy?: string | null;
  /** When was this user record suspended? */
  suspendOn?: string | null;
  /** Is this user allowed to see all customers? */
  allowAllBt: boolean;
  /** Is this user allowed to see all carriers? */
  allowAllCarr: boolean;
  /** How many records will the user see in reports by default? */
  defaultMaxRec: number;
  /** How many records will the user see in reports at maximum? */
  maxMaxRec: number;
  /** Is this user allowed to approve invoices for all customers? */
  allowAllAppr: boolean;
  /** List of customers the user can see */
  linkedCustomers?: UserAdminListEntryVm[] | null;
  /** List of customers the user can approve invoices for */
  linkedApprovals?: UserAdminListEntryVm[] | null;
  /** List of carriers the user can see */
  linkedCarriers?: UserAdminListEntryVm[] | null;
  /** List of the user's associated roles */
  linkedRoles?: UserAdminListEntryVm[] | null;
};
export type UserAdminPasswordVm = {
  /** User ID */
  userId: string;
  /** User's new password */
  password: string;
};
export type UserAdminSuspendVm = {
  /** User ID */
  userId: string;
  /** Are we suspending or restoring this account? */
  suspend: boolean;
};
export type UserSessionsVm = {
  session?: string;
  userId?: string | null;
  sessionStart?: string;
  sessionEnd?: string;
  sessionTime?: number | null;
  sessionEndStatus?: string | null;
  hostName?: string | null;
};
export type CarrInvUserStatsVm = {
  entrySeconds?: number;
  invoiceCount?: number;
  lastSave?: string;
  shipmentCount?: number;
};
export const {
  useRequeueJobQuery,
  useLazyRequeueJobQuery,
  useGetAppDefaultsQuery,
  useLazyGetAppDefaultsQuery,
  useGetAppDefaultsQueryQuery,
  useLazyGetAppDefaultsQueryQuery,
  usePutAppDefaultsMutation,
  usePutSecureDefaultsMutation,
  useGetSecureDefaultsQueryQuery,
  useLazyGetSecureDefaultsQueryQuery,
  useGetWebDefaultsQuery,
  useLazyGetWebDefaultsQuery,
  useGetInvoicesApprovalPopulationDataQuery,
  useLazyGetInvoicesApprovalPopulationDataQuery,
  useGetInvoicesNeedingApprovalMutation,
  useGetMinimalInvoiceDetailQuery,
  useLazyGetMinimalInvoiceDetailQuery,
  useApproveInvoicesMutation,
  useSaveCurrentInvoiceStateMutation,
  usePostApiApproveinvoicesFrominvoiceidxsMutation,
  useGetAllAscChargeCodesQuery,
  useLazyGetAllAscChargeCodesQuery,
  useCreateAscChargeCodesMutation,
  useModifyAscChargeCodesMutation,
  useDeleteAscChargeCodesMutation,
  useGetInvoiceChargeTypesQuery,
  useLazyGetInvoiceChargeTypesQuery,
  useGetAllAscRefCodesQuery,
  useLazyGetAllAscRefCodesQuery,
  useCreateAscRefCodesMutation,
  useModifyAscRefCodesMutation,
  useDeleteAscRefCodesMutation,
  useGetGenMilesMutation,
  useLoginMutation,
  useRefreshTokenQuery,
  useLazyRefreshTokenQuery,
  useLoginWithPermissionsMutation,
  useRefreshWithPermissionsQuery,
  useLazyRefreshWithPermissionsQuery,
  useLogOutQuery,
  useLazyLogOutQuery,
  useGetMyUserQuery,
  useLazyGetMyUserQuery,
  useGetAllBankAccountsQuery,
  useLazyGetAllBankAccountsQuery,
  useUpdateBankAccountMutation,
  useGetBillToByIdQuery,
  useLazyGetBillToByIdQuery,
  useGetDataEntryAscRefCodesQuery,
  useLazyGetDataEntryAscRefCodesQuery,
  useGetAllBillToQuery,
  useLazyGetAllBillToQuery,
  useGetBillToForDisplayQuery,
  useLazyGetBillToForDisplayQuery,
  useGetUserCustomersQuery,
  useLazyGetUserCustomersQuery,
  useGetCentralSaltBillTosQuery,
  useLazyGetCentralSaltBillTosQuery,
  useGetAllBillTosForDisplayQuery,
  useLazyGetAllBillTosForDisplayQuery,
  useGetActiveBillTosForDisplayQuery,
  useLazyGetActiveBillTosForDisplayQuery,
  useGetCustomerByIdQuery,
  useLazyGetCustomerByIdQuery,
  useModifyCustomersMutation,
  useDeleteCustomersMutation,
  useGetAllCustomersQuery,
  useLazyGetAllCustomersQuery,
  useCreateCustomersMutation,
  useGetParentCustomersQuery,
  useLazyGetParentCustomersQuery,
  useActivateCustomersMutation,
  useGetFeeInvoiceDataQuery,
  useLazyGetFeeInvoiceDataQuery,
  useSetFeeInvoiceDataMutation,
  useGetModeDefaultsByCustomerQuery,
  useLazyGetModeDefaultsByCustomerQuery,
  useCreateBillToModeDefaultMutation,
  useModifyBillToModeDefaultMutation,
  useDeleteBillToModeDefaultMutation,
  useGetGlRulesQuery,
  useLazyGetGlRulesQuery,
  useGetGlCodingPreviewQuery,
  useLazyGetGlCodingPreviewQuery,
  useGetGlOverwritePreviewQuery,
  useLazyGetGlOverwritePreviewQuery,
  useSaveGlRulesMutation,
  useGlCodingBatchMutation,
  useGlCodingQueueMutation,
  useGetBillToMapsByCarrierQuery,
  useLazyGetBillToMapsByCarrierQuery,
  useCreateCarrierBtMapMutation,
  useDeleteCarrierBtMapMutation,
  useGetVoidableChecksMutation,
  useVoidChecksMutation,
  useGetAllRemitsQuery,
  useLazyGetAllRemitsQuery,
  useMakeRemitsMutation,
  useGetRemitsForChecksQuery,
  useLazyGetRemitsForChecksQuery,
  useGetRemitKeysQuery,
  useLazyGetRemitKeysQuery,
  useGetRemitsForKeyQuery,
  useLazyGetRemitsForKeyQuery,
  useGetCarrierEdiMasterByIdQuery,
  useLazyGetCarrierEdiMasterByIdQuery,
  useCreateCarrierEdiMasterMutation,
  useModifyCarrierEdiMasterMutation,
  useDeleteCarrierEdiMasterMutation,
  useGetAllCarrierFamiliesQuery,
  useLazyGetAllCarrierFamiliesQuery,
  useGetCarrierFamilyTreeQuery,
  useLazyGetCarrierFamilyTreeQuery,
  useGetCarrierFamilyByIdQuery,
  useLazyGetCarrierFamilyByIdQuery,
  useGetFamilyMembersQuery,
  useLazyGetFamilyMembersQuery,
  useCreateCarrierFamilyMutation,
  useUpdateCarrierFamilyMutation,
  useDeleteCarrierFamilyMutation,
  useAssignCarrierToFamilyMutation,
  useRemoveCarrierFromFamilyMutation,
  useCheckFamilyNameExistsQuery,
  useLazyCheckFamilyNameExistsQuery,
  useGetCarriersForDropdownQuery,
  useLazyGetCarriersForDropdownQuery,
  useGetActiveCarriersForDropdownQuery,
  useLazyGetActiveCarriersForDropdownQuery,
  useGetPermissionedCarriersForDropdownQuery,
  useLazyGetPermissionedCarriersForDropdownQuery,
  useGetByScacQuery,
  useLazyGetByScacQuery,
  useGetCarrierChargeCodeMappingQuery,
  useLazyGetCarrierChargeCodeMappingQuery,
  useGetCarrierChargeCodeMappingByIdQuery,
  useLazyGetCarrierChargeCodeMappingByIdQuery,
  useAddNewCarrierChargeCodeMappingMutation,
  useUpdateCarrierChargeCodeMappingMutation,
  useDeletCarrierChargeCodeMappingMutation,
  useGetCarrierChargeCodeMappingOverridesQuery,
  useLazyGetCarrierChargeCodeMappingOverridesQuery,
  useGetCarrierChargeCodeMappingOverrideByCarrierIdQuery,
  useLazyGetCarrierChargeCodeMappingOverrideByCarrierIdQuery,
  useAddNewCarrierChargeCodeMappingOverrideMutation,
  useUpdateCarrierChargeCodeMappingOverrideMutation,
  useDeleteCarrierChargeCodeMappingOverrideMutation,
  useGetCarrierByIdQuery,
  useLazyGetCarrierByIdQuery,
  useGetAllCarriersQuery,
  useLazyGetAllCarriersQuery,
  useCreateCarriersMutation,
  useModifyCarriersMutation,
  useDeleteCarriersMutation,
  useActivateCarriersMutation,
  useGetModeOverridesQuery,
  useLazyGetModeOverridesQuery,
  useGetSpecificModeOverrideQuery,
  useLazyGetSpecificModeOverrideQuery,
  useDeleteModeOverrideMutation,
  useUpdateModeOverrideMutation,
  useAddModeOverrideMutation,
  useGetAllCarrierContactsQuery,
  useLazyGetAllCarrierContactsQuery,
  useCreateCarrierContactsMutation,
  useGetCarrierContactByIdQuery,
  useLazyGetCarrierContactByIdQuery,
  useModifyCarrierContactsMutation,
  useDeleteCarrierContactsMutation,
  useGetCarrierModeMapsByIdQuery,
  useLazyGetCarrierModeMapsByIdQuery,
  useCreateCarrierModeMapsMutation,
  useModifyCarrierModeMapsMutation,
  useDeleteCarrierModeMapsMutation,
  useGetPayMethodsForCarrierQuery,
  useLazyGetPayMethodsForCarrierQuery,
  useCreateCarrierPayRemitMutation,
  useModifyCarrierPayRemitMutation,
  useDeleteCarrierPayRemitMutation,
  useGetCarrierRemitMethodsQuery,
  useLazyGetCarrierRemitMethodsQuery,
  useGetCarrierRemitDeliveryMethodsQuery,
  useLazyGetCarrierRemitDeliveryMethodsQuery,
  useGetCarrierRemitFormatsQuery,
  useLazyGetCarrierRemitFormatsQuery,
  useGetAchSecCodesQuery,
  useLazyGetAchSecCodesQuery,
  useGetCarrierInvoiceByIdQuery,
  useLazyGetCarrierInvoiceByIdQuery,
  useDeleteInvoiceMutation,
  useGetCarrInvByInvNumQuery,
  useLazyGetCarrInvByInvNumQuery,
  useGetInvoiceSummaryQuery,
  useLazyGetInvoiceSummaryQuery,
  useGetInvoiceLineSummaryQuery,
  useLazyGetInvoiceLineSummaryQuery,
  useGetInvoiceChargeDetailsQuery,
  useLazyGetInvoiceChargeDetailsQuery,
  useGetInvoiceLineChargeDetailsQuery,
  useLazyGetInvoiceLineChargeDetailsQuery,
  useGetBundleInfoQuery,
  useLazyGetBundleInfoQuery,
  useGetAllInvoiceRevsQuery,
  useLazyGetAllInvoiceRevsQuery,
  useCreateMutation,
  useCreateWebInvoiceMutation,
  useUpdateWebInvoiceMutation,
  useInitiateMultiPartInvoiceCreationMutation,
  useMultiPartInvoiceCreationMutation,
  useCompleteMultiPartInvoiceCreationMutation,
  useAbortMultiPartInvoiceCreationMutation,
  useCreateQueuedMutation,
  usePostApiCarrinvCheckqueuedinvoicecreationstateMutation,
  useReAuditMutation,
  useTestAuditMutation,
  useDeleteShipmentMutation,
  useMakeInvoiceMemoMutation,
  useMakeInvoiceRealMutation,
  useReassignInvoiceCustomerMutation,
  useReassignInvoiceNumberMutation,
  useValidateCodingMutation,
  useValidateLineCodingMutation,
  useCreateBillingInvoiceMutation,
  useCreateBillingInvoiceQueuedMutation,
  useCreatePdfInvoiceMutation,
  useCreatePdfInvoiceQueuedMutation,
  useRegeneratePdfInvoiceMutation,
  useGetImagesForInvoiceQuery,
  useLazyGetImagesForInvoiceQuery,
  useAddImageMutation,
  useClearCachedImagesForInvoiceMutation,
  useGetImageWithDataQuery,
  useLazyGetImageWithDataQuery,
  useGetImageWithDataFromObjectMutation,
  useGetInvoiceEdiQuery,
  useLazyGetInvoiceEdiQuery,
  useCarrInvDisconnectImageMutation,
  useWhatIfChargeCodesForNewBilltoQuery,
  useLazyWhatIfChargeCodesForNewBilltoQuery,
  useGetInvoicesForBatchingQuery,
  useLazyGetInvoicesForBatchingQuery,
  useGetAllCarrServicesQuery,
  useLazyGetAllCarrServicesQuery,
  useCreateCarrierServicesMutation,
  useGetCarrierServicesByIdQuery,
  useLazyGetCarrierServicesByIdQuery,
  useModifyCarrierServiceMutation,
  useDeleteCarrierServicesMutation,
  useGetAllowedCarrSvcAuditFnsQuery,
  useLazyGetAllowedCarrSvcAuditFnsQuery,
  useGetTicketQuery,
  useLazyGetTicketQuery,
  useMakeCSaltInvoiceMutation,
  useGetRegisterFbOsQuery,
  useLazyGetRegisterFbOsQuery,
  useGetRegisterInfoMutation,
  useGetAllCmContractsQuery,
  useLazyGetAllCmContractsQuery,
  useCreateCmContractsMutation,
  useModifyCmContractsMutation,
  useDeleteCmContractsMutation,
  useGetAllMasterCodesQuery,
  useLazyGetAllMasterCodesQuery,
  useGetMasterCodesForElementQuery,
  useLazyGetMasterCodesForElementQuery,
  useAddModeMutation,
  useModifyMasterCodesMutation,
  useGetMasterCodeFiltersQuery,
  useLazyGetMasterCodeFiltersQuery,
  useGetActiveCurrencyCodesQuery,
  useLazyGetActiveCurrencyCodesQuery,
  useGetAuditFailCodesQuery,
  useLazyGetAuditFailCodesQuery,
  useGetPreReqStatusesQuery,
  useLazyGetPreReqStatusesQuery,
  useGetCustomerContactsByIdQuery,
  useLazyGetCustomerContactsByIdQuery,
  useCreateCustomerContactsMutation,
  useModifyCustomerContactsMutation,
  useDeleteCustomerContactsMutation,
  useGetAllCurrenciesQuery,
  useLazyGetAllCurrenciesQuery,
  useGetRefDefsQuery,
  useLazyGetRefDefsQuery,
  useGetCustomerRefDefsQuery,
  useLazyGetCustomerRefDefsQuery,
  useGetRefDefsForInvoiceQuery,
  useLazyGetRefDefsForInvoiceQuery,
  useCreateRefDefMutation,
  useModifyRefDefMutation,
  useDeleteRefDefMutation,
  useCreateAndPrepBatchesMutation,
  useGetChildBatchesQuery,
  useLazyGetChildBatchesQuery,
  useCreateAndPrepBatchesFromInvoicesMutation,
  useGetAgedReceivablesQuery,
  useLazyGetAgedReceivablesQuery,
  useGetListQuery,
  useLazyGetListQuery,
  useUpsertMutation,
  useGetCustPayByBillToIdByIdQuery,
  useLazyGetCustPayByBillToIdByIdQuery,
  useGetCustPaySetupByIdQuery,
  useLazyGetCustPaySetupByIdQuery,
  useCreateCustPaySetupMutation,
  useModifyCustPaySetupMutation,
  useDeleteCustPaySetupMutation,
  useGetShipmentCountByStatusQuery,
  useLazyGetShipmentCountByStatusQuery,
  useGetAgedInvoiceSummaryQuery,
  useLazyGetAgedInvoiceSummaryQuery,
  useGetDataEntryAdminInfoByCustomerQuery,
  useLazyGetDataEntryAdminInfoByCustomerQuery,
  useGetDataEntryAdminInfoForInvoiceQuery,
  useLazyGetDataEntryAdminInfoForInvoiceQuery,
  useModifyDataEntryAdminInfoMutation,
  useDeleteDataEntryAdminInfoMutation,
  useCreateDataEntryAdminInfoMutation,
  useInvoiceResearchExportMutation,
  useGetDataExportsQuery,
  useLazyGetDataExportsQuery,
  useDeleteExportMutation,
  useSendMailWithOutAttachmentsMutation,
  useGetActiveEquipsForDropdownQuery,
  useLazyGetActiveEquipsForDropdownQuery,
  useGetInvoiceHistoryQuery,
  useLazyGetInvoiceHistoryQuery,
  useGetInvoiceRangeMutation,
  useGetInvoiceHistoryDetailsQuery,
  useLazyGetInvoiceHistoryDetailsQuery,
  useGetInvoiceRangeDetailsQuery,
  useLazyGetInvoiceRangeDetailsQuery,
  useGenerateInvoiceDetailReportQuery,
  useLazyGenerateInvoiceDetailReportQuery,
  useDeleteFeesInvoiceMutation,
  useRenameFeesInvoiceMutation,
  useImportInvoicesMutation,
  useGetImportDatesQuery,
  useLazyGetImportDatesQuery,
  useGetImportReportsForDateQuery,
  useLazyGetImportReportsForDateQuery,
  useGetTermsCustomersQuery,
  useLazyGetTermsCustomersQuery,
  useTestNonPayInvoicesMutation,
  useMakeNonPayInvoicesMutation,
  useTestPayInvoicesMutation,
  useMakePayInvoicesMutation,
  useGetCompareRulesQuery,
  useLazyGetCompareRulesQuery,
  useConvertFeesAppRuleMutation,
  useGetCustomerRulesQuery,
  useLazyGetCustomerRulesQuery,
  useGetRuleDataQuery,
  useLazyGetRuleDataQuery,
  useDeleteFeesRuleMutation,
  useCreateFeesRuleMutation,
  useUpdateFeesRuleMutation,
  useSetFeesRuleDetailMutation,
  useGetRuleTypesQuery,
  useLazyGetRuleTypesQuery,
  useGetBillPerTypesQuery,
  useLazyGetBillPerTypesQuery,
  useGetIntDomTypesQuery,
  useLazyGetIntDomTypesQuery,
  useGetFunctionsQuery,
  useLazyGetFunctionsQuery,
  useCreateFunctionMutation,
  useModifyFunctionMutation,
  useBulkCodingMutation,
  useGetGlCodeForInvoiceMutation,
  usePostHopkinsDepartmentMutation,
  useGetHealthCheckQuery,
  useLazyGetHealthCheckQuery,
  use$getQuery,
  useLazy$getQuery,
  useGetImageQuery,
  useLazyGetImageQuery,
  useDeleteImageMutation,
  useDeleteMultipleImagesMutation,
  useDisconnectImageMutation,
  useDisconnectMultipleImagesMutation,
  useGetDisconnectedImagesQuery,
  useLazyGetDisconnectedImagesQuery,
  useUploadDisconnectedImageMutation,
  useGetDisconnectedImagesQueryableQuery,
  useLazyGetDisconnectedImagesQueryableQuery,
  useGetQueuesQuery,
  useLazyGetQueuesQuery,
  useGetQueueImagesQuery,
  useLazyGetQueueImagesQuery,
  useIndexImageMutation,
  useAddImageToQueueMutation,
  useAddScannedImageMutation,
  useGetScannedImagesQuery,
  useLazyGetScannedImagesQuery,
  useDeleteScannedImagesMutation,
  useGetScannedImageCustomersQuery,
  useLazyGetScannedImageCustomersQuery,
  useUpdateScannedImagesMutation,
  useGetAllowedImageTypesQuery,
  useLazyGetAllowedImageTypesQuery,
  useDeleteUnindexedImageMutation,
  useCustomerImageExtractMutation,
  useReleaseInvoiceMutation,
  useGetBasicInvInfoQuery,
  useLazyGetBasicInvInfoQuery,
  useGetDetailedChargesQuery,
  useLazyGetDetailedChargesQuery,
  useGetReferencesQuery,
  useLazyGetReferencesQuery,
  useUpdateReferencesMutation,
  useGetImagesQuery,
  useLazyGetImagesQuery,
  useUpdateCommentMutation,
  useGetPurgableInvoiceListQuery,
  useLazyGetPurgableInvoiceListQuery,
  useUnbatchReceivableBatchesMutation,
  useUnapproveApprovedBatchesMutation,
  usePurgeInvoiceMutation,
  usePurgeInvoicesFromFileMutation,
  useGetInvoiceResearchPopulationDataQuery,
  useLazyGetInvoiceResearchPopulationDataQuery,
  useSearchInvoicesMutation,
  useReactDataTableServerSideProcessingMutation,
  useGetMakeRealWorkaroundInvoicesQuery,
  useLazyGetMakeRealWorkaroundInvoicesQuery,
  usePostMakeRealWorkaroundInvoicesMutation,
  useGetStatusesForExceptionsQuery,
  useLazyGetStatusesForExceptionsQuery,
  useGetExceptionsForGridQuery,
  useLazyGetExceptionsForGridQuery,
  useSaveCurrentRemarksMutation,
  useAcceptAsEnteredMutation,
  useAcceptAsAuditedMutation,
  useAcceptAsAdjustedMutation,
  useRefuseInvoiceMutation,
  useExceptionManagerDeleteMutation,
  useDeclineServiceFailMutation,
  useApproveServiceFailMutation,
  useMassRefSearchMutation,
  useMassRefUpdateMutation,
  useGetCentralSaltTicketsQuery,
  useLazyGetCentralSaltTicketsQuery,
  useUpdateCentralSaltTicketMutation,
  useGetHarcrosTicketsQuery,
  useLazyGetHarcrosTicketsQuery,
  useGetAscRefCodesQuery,
  useLazyGetAscRefCodesQuery,
  useGetAscChargeCodesQuery,
  useLazyGetAscChargeCodesQuery,
  useGetTransportModesQuery,
  useLazyGetTransportModesQuery,
  useGetAvailableAuditFailStatusesQuery,
  useLazyGetAvailableAuditFailStatusesQuery,
  useGetCarrierChargeCodeSourcesQuery,
  useLazyGetCarrierChargeCodeSourcesQuery,
  useGetCustomerDataEntryCodesForUserQuery,
  useLazyGetCustomerDataEntryCodesForUserQuery,
  useGetCustomerDataEntryCodesQuery,
  useLazyGetCustomerDataEntryCodesQuery,
  useGetIa360ReportingLinkQuery,
  useLazyGetIa360ReportingLinkQuery,
  useGetInvoiceStatusCodesQuery,
  useLazyGetInvoiceStatusCodesQuery,
  useGetEntryMethodsQuery,
  useLazyGetEntryMethodsQuery,
  useGetActivityCodesQuery,
  useLazyGetActivityCodesQuery,
  useGetInvoiceTypeListQuery,
  useLazyGetInvoiceTypeListQuery,
  useGetIbobsListQuery,
  useLazyGetIbobsListQuery,
  useGetReportNameListQuery,
  useLazyGetReportNameListQuery,
  useGetQueueIsActiveQuery,
  useLazyGetQueueIsActiveQuery,
  useGetPartiesQuery,
  useLazyGetPartiesQuery,
  useGetUnMadeAchPaymentsQuery,
  useLazyGetUnMadeAchPaymentsQuery,
  useGenerateAcHesMutation,
  useGetAchDatesQuery,
  useLazyGetAchDatesQuery,
  useGetAchFilesForDateQuery,
  useLazyGetAchFilesForDateQuery,
  useGetCarrierPayableExceptionsByIdQuery,
  useLazyGetCarrierPayableExceptionsByIdQuery,
  useCreateCarrierPayExceptionMutation,
  useModifyCarrierPayExceptionMutation,
  useDeleteCarrierPayExceptionMutation,
  useGetAllPayDayStartsQuery,
  useLazyGetAllPayDayStartsQuery,
  useGetPermittedValsByCustomerQuery,
  useLazyGetPermittedValsByCustomerQuery,
  useGetInvoicePermittedValuesQuery,
  useLazyGetInvoicePermittedValuesQuery,
  useCreatePermittedValueMutation,
  useModifyPermittedValueMutation,
  useDeletePermittedValueMutation,
  useGetPostalCodesQuery,
  useLazyGetPostalCodesQuery,
  useCreatePostalCodeMutation,
  useModifyPostalCodeMutation,
  useDeletePostalCodeMutation,
  useGetAllChecksQuery,
  useLazyGetAllChecksQuery,
  useGetChecksForDateQuery,
  useLazyGetChecksForDateQuery,
  useGetReprintChecksForDateQuery,
  useLazyGetReprintChecksForDateQuery,
  useMakeNewBatchesMutation,
  usePrintChecksMutation,
  useReprintChecksMutation,
  useGetCheckDatesQuery,
  useLazyGetCheckDatesQuery,
  useGetPrintedChecksForDateQuery,
  useLazyGetPrintedChecksForDateQuery,
  useGetReceiptsQuery,
  useLazyGetReceiptsQuery,
  useMergeReceiptsMutation,
  useGetApprovedInvoicesQuery,
  useLazyGetApprovedInvoicesQuery,
  useGetUnappliedCashQuery,
  useLazyGetUnappliedCashQuery,
  useReceiveFundsMutation,
  useUseUnappliedCashMutation,
  useDepositFundsMutation,
  useCreateCreditMutation,
  useGetApiReportingQuery,
  useLazyGetApiReportingQuery,
  useGetBookmarksForUserQuery,
  useLazyGetBookmarksForUserQuery,
  useCreateBookmarkMutation,
  useDeleteBookmarkMutation,
  useGetStatesQuery,
  useLazyGetStatesQuery,
  useCreateStatesMutation,
  useModifyStatesMutation,
  useDeleteStatesMutation,
  useGetConfigQuery,
  useLazyGetConfigQuery,
  useGetAppconfigQuery,
  useLazyGetAppconfigQuery,
  useGetTimecardForUserIdQuery,
  useLazyGetTimecardForUserIdQuery,
  useAddTimeCardMutation,
  useDeleteTimeCardMutation,
  useGetUserBillToInfoByCustomerQuery,
  useLazyGetUserBillToInfoByCustomerQuery,
  useCreateUserBillToInfoMutation,
  useDeleteUserBillToInfoMutation,
  useGetMyConfigQuery,
  useLazyGetMyConfigQuery,
  useSaveMyConfigMutation,
  useGetUserConfigurationQuery,
  useLazyGetUserConfigurationQuery,
  useSaveUserConfigMutation,
  useGetRoleAuthsQuery,
  useLazyGetRoleAuthsQuery,
  useCreateNewRoleMutation,
  useUpdateRoleMutation,
  useCopyRoleMutation,
  useGetAllUsersQuery,
  useLazyGetAllUsersQuery,
  useUpdateUserMutation,
  useGetFullUserListQuery,
  useLazyGetFullUserListQuery,
  useGetUserAdminInfoQuery,
  useLazyGetUserAdminInfoQuery,
  useGetKnownCompaniesQuery,
  useLazyGetKnownCompaniesQuery,
  useAddUserMutation,
  useChangePasswordMutation,
  useSuspendUserMutation,
  useGetTimeCardUsersQuery,
  useLazyGetTimeCardUsersQuery,
  useGetUserSessionsForUserQuery,
  useLazyGetUserSessionsForUserQuery,
  useGetMyUserSessionsQuery,
  useLazyGetMyUserSessionsQuery,
  useGetCarrInvStatsForUserQuery,
  useLazyGetCarrInvStatsForUserQuery,
  useGetMyCarrInvStatsQuery,
  useLazyGetMyCarrInvStatsQuery,
} = injectedRtkApi;
